import * as React from 'react';
import React__default, { useContext, createElement as createElement$2, Fragment, createContext, forwardRef, useState, useEffect, useCallback, useMemo } from 'react';
import { jsx as jsx$1 } from 'react/jsx-runtime';
import * as Sentry from '@sentry/react';
import localize from '@aetonix/ae-localizer';
import * as XLSX from 'xlsx/dist/xlsx.full.min.js';
import JSZip from 'jszip';
import * as ReportGenerator from '@aetonix/report-generator';
import { buildSection } from '@aetonix/report-generator/src/schema-builder/section-builders';
import dotty from 'dotty';
import { useResourceStore, useSliceStore, DefaultValues, parseValue } from '@aetonix/stores';
import { Images } from '@aetonix/assets';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$p =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$o = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$n = fails$o;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$n(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});

var fails$m = fails$o;

var functionBindNative = !fails$m(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$3 = functionBindNative;

var call$m = Function.prototype.call;

var functionCall = NATIVE_BIND$3 ? call$m.bind(call$m) : function () {
  return call$m.apply(call$m, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$3 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$3 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$3(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$5 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND$2 = functionBindNative;

var FunctionPrototype$2 = Function.prototype;
var call$l = FunctionPrototype$2.call;
var uncurryThisWithBind = NATIVE_BIND$2 && FunctionPrototype$2.bind.bind(call$l, call$l);

var functionUncurryThis = NATIVE_BIND$2 ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$l.apply(fn, arguments);
  };
};

var uncurryThis$q = functionUncurryThis;

var toString$c = uncurryThis$q({}.toString);
var stringSlice$9 = uncurryThis$q(''.slice);

var classofRaw$2 = function (it) {
  return stringSlice$9(toString$c(it), 8, -1);
};

var uncurryThis$p = functionUncurryThis;
var fails$l = fails$o;
var classof$9 = classofRaw$2;

var $Object$4 = Object;
var split$3 = uncurryThis$p(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$l(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$9(it) === 'String' ? split$3(it, '') : $Object$4(it);
} : $Object$4;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$7 = function (it) {
  return it === null || it === undefined;
};

var isNullOrUndefined$6 = isNullOrUndefined$7;

var $TypeError$h = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$7 = function (it) {
  if (isNullOrUndefined$6(it)) throw new $TypeError$h("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$2 = indexedObject;
var requireObjectCoercible$6 = requireObjectCoercible$7;

var toIndexedObject$5 = function (it) {
  return IndexedObject$2(requireObjectCoercible$6(it));
};

var documentAll$2 = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll$2 == 'undefined' && documentAll$2 !== undefined;

var documentAll_1 = {
  all: documentAll$2,
  IS_HTMLDDA: IS_HTMLDDA
};

var $documentAll$1 = documentAll_1;

var documentAll$1 = $documentAll$1.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$p = $documentAll$1.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll$1;
} : function (argument) {
  return typeof argument == 'function';
};

var isCallable$o = isCallable$p;
var $documentAll = documentAll_1;

var documentAll = $documentAll.all;

var isObject$c = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable$o(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable$o(it);
};

var global$o = global$p;
var isCallable$n = isCallable$p;

var aFunction = function (argument) {
  return isCallable$n(argument) ? argument : undefined;
};

var getBuiltIn$7 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$o[namespace]) : global$o[namespace] && global$o[namespace][method];
};

var uncurryThis$o = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$o({}.isPrototypeOf);

var engineUserAgent = typeof navigator != 'undefined' && String(navigator.userAgent) || '';

var global$n = global$p;
var userAgent$5 = engineUserAgent;

var process$4 = global$n.process;
var Deno$1 = global$n.Deno;
var versions = process$4 && process$4.versions || Deno$1 && Deno$1.version;
var v8 = versions && versions.v8;
var match$1, version;

if (v8) {
  match$1 = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match$1[0] > 0 && match$1[0] < 4 ? 1 : +(match$1[0] + match$1[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent$5) {
  match$1 = userAgent$5.match(/Edge\/(\d+)/);
  if (!match$1 || match$1[1] >= 74) {
    match$1 = userAgent$5.match(/Chrome\/(\d+)/);
    if (match$1) version = +match$1[1];
  }
}

var engineV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION$1 = engineV8Version;
var fails$k = fails$o;
var global$m = global$p;

var $String$5 = global$m.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$k(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String$5(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION$1 && V8_VERSION$1 < 41;
});

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL$2 = symbolConstructorDetection;

var useSymbolAsUid = NATIVE_SYMBOL$2
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var getBuiltIn$6 = getBuiltIn$7;
var isCallable$m = isCallable$p;
var isPrototypeOf$5 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var $Object$3 = Object;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$6('Symbol');
  return isCallable$m($Symbol) && isPrototypeOf$5($Symbol.prototype, $Object$3(it));
};

var $String$4 = String;

var tryToString$5 = function (argument) {
  try {
    return $String$4(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$l = isCallable$p;
var tryToString$4 = tryToString$5;

var $TypeError$g = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$a = function (argument) {
  if (isCallable$l(argument)) return argument;
  throw new $TypeError$g(tryToString$4(argument) + ' is not a function');
};

var aCallable$9 = aCallable$a;
var isNullOrUndefined$5 = isNullOrUndefined$7;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$6 = function (V, P) {
  var func = V[P];
  return isNullOrUndefined$5(func) ? undefined : aCallable$9(func);
};

var call$k = functionCall;
var isCallable$k = isCallable$p;
var isObject$b = isObject$c;

var $TypeError$f = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$k(fn = input.toString) && !isObject$b(val = call$k(fn, input))) return val;
  if (isCallable$k(fn = input.valueOf) && !isObject$b(val = call$k(fn, input))) return val;
  if (pref !== 'string' && isCallable$k(fn = input.toString) && !isObject$b(val = call$k(fn, input))) return val;
  throw new $TypeError$f("Can't convert object to primitive value");
};

var shared$4 = {exports: {}};

var isPure = false;

var global$l = global$p;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$7 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$7(global$l, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$l[key] = value;
  } return value;
};

var global$k = global$p;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = global$k[SHARED] || defineGlobalProperty$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$4.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.33.3',
  mode: 'global',
  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.33.3/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var requireObjectCoercible$5 = requireObjectCoercible$7;

var $Object$2 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$8 = function (argument) {
  return $Object$2(requireObjectCoercible$5(argument));
};

var uncurryThis$n = functionUncurryThis;
var toObject$7 = toObject$8;

var hasOwnProperty$1 = uncurryThis$n({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty$1(toObject$7(it), key);
};

var uncurryThis$m = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$b = uncurryThis$m(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$b(++id + postfix, 36);
};

var global$j = global$p;
var shared$3 = shared$4.exports;
var hasOwn$e = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL$1 = symbolConstructorDetection;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var Symbol$1 = global$j.Symbol;
var WellKnownSymbolsStore = shared$3('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1['for'] || Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$m = function (name) {
  if (!hasOwn$e(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL$1 && hasOwn$e(Symbol$1, name)
      ? Symbol$1[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

var call$j = functionCall;
var isObject$a = isObject$c;
var isSymbol$1 = isSymbol$2;
var getMethod$5 = getMethod$6;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$l = wellKnownSymbol$m;

var $TypeError$e = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$l('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$a(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$5(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$j(exoticToPrim, input, pref);
    if (!isObject$a(result) || isSymbol$1(result)) return result;
    throw new $TypeError$e("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$3 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var global$i = global$p;
var isObject$9 = isObject$c;

var document$3 = global$i.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$9(document$3) && isObject$9(document$3.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$3.createElement(it) : {};
};

var DESCRIPTORS$f = descriptors;
var fails$j = fails$o;
var createElement$1 = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$f && !fails$j(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement$1('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});

var DESCRIPTORS$e = descriptors;
var call$i = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$4 = createPropertyDescriptor$5;
var toIndexedObject$4 = toIndexedObject$5;
var toPropertyKey$2 = toPropertyKey$3;
var hasOwn$d = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$e ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$4(O);
  P = toPropertyKey$2(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$d(O, P)) return createPropertyDescriptor$4(!call$i(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$d = descriptors;
var fails$i = fails$o;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$d && fails$i(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});

var isObject$8 = isObject$c;

var $String$3 = String;
var $TypeError$d = TypeError;

// `Assert: Type(argument) is Object`
var anObject$i = function (argument) {
  if (isObject$8(argument)) return argument;
  throw new $TypeError$d($String$3(argument) + ' is not an object');
};

var DESCRIPTORS$c = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$h = anObject$i;
var toPropertyKey$1 = toPropertyKey$3;

var $TypeError$c = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$c ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$h(O);
  P = toPropertyKey$1(P);
  anObject$h(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$h(O);
  P = toPropertyKey$1(P);
  anObject$h(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError$c('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$b = descriptors;
var definePropertyModule$4 = objectDefineProperty;
var createPropertyDescriptor$3 = createPropertyDescriptor$5;

var createNonEnumerableProperty$6 = DESCRIPTORS$b ? function (object, key, value) {
  return definePropertyModule$4.f(object, key, createPropertyDescriptor$3(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var makeBuiltIn$3 = {exports: {}};

var DESCRIPTORS$a = descriptors;
var hasOwn$c = hasOwnProperty_1;

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$a && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$c(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$a || (DESCRIPTORS$a && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$l = functionUncurryThis;
var isCallable$j = isCallable$p;
var store$1 = sharedStore;

var functionToString = uncurryThis$l(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$j(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$3 = store$1.inspectSource;

var global$h = global$p;
var isCallable$i = isCallable$p;

var WeakMap$2 = global$h.WeakMap;

var weakMapBasicDetection = isCallable$i(WeakMap$2) && /native code/.test(String(WeakMap$2));

var shared$2 = shared$4.exports;
var uid = uid$2;

var keys$1 = shared$2('keys');

var sharedKey$3 = function (key) {
  return keys$1[key] || (keys$1[key] = uid(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = weakMapBasicDetection;
var global$g = global$p;
var isObject$7 = isObject$c;
var createNonEnumerableProperty$5 = createNonEnumerableProperty$6;
var hasOwn$b = hasOwnProperty_1;
var shared$1 = sharedStore;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$3 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$4 = global$g.TypeError;
var WeakMap$1 = global$g.WeakMap;
var set$1, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set$1(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$7(it) || (state = get(it)).type !== TYPE) {
      throw new TypeError$4('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared$1.state) {
  var store = shared$1.state || (shared$1.state = new WeakMap$1());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set$1 = function (it, metadata) {
    if (store.has(it)) throw new TypeError$4(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$3[STATE] = true;
  set$1 = function (it, metadata) {
    if (hasOwn$b(it, STATE)) throw new TypeError$4(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$5(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$b(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$b(it, STATE);
  };
}

var internalState = {
  set: set$1,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var uncurryThis$k = functionUncurryThis;
var fails$h = fails$o;
var isCallable$h = isCallable$p;
var hasOwn$a = hasOwnProperty_1;
var DESCRIPTORS$9 = descriptors;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var inspectSource$2 = inspectSource$3;
var InternalStateModule$5 = internalState;

var enforceInternalState$1 = InternalStateModule$5.enforce;
var getInternalState$3 = InternalStateModule$5.get;
var $String$2 = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$6 = Object.defineProperty;
var stringSlice$8 = uncurryThis$k(''.slice);
var replace$8 = uncurryThis$k(''.replace);
var join$3 = uncurryThis$k([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS$9 && !fails$h(function () {
  return defineProperty$6(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$2 = makeBuiltIn$3.exports = function (value, name, options) {
  if (stringSlice$8($String$2(name), 0, 7) === 'Symbol(') {
    name = '[' + replace$8($String$2(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$a(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
    if (DESCRIPTORS$9) defineProperty$6(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$a(options, 'arity') && value.length !== options.arity) {
    defineProperty$6(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$a(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$9) defineProperty$6(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState$1(value);
  if (!hasOwn$a(state, 'source')) {
    state.source = join$3(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$2(function toString() {
  return isCallable$h(this) && getInternalState$3(this).source || inspectSource$2(this);
}, 'toString');

var isCallable$g = isCallable$p;
var definePropertyModule$3 = objectDefineProperty;
var makeBuiltIn$1 = makeBuiltIn$3.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$b = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$g(value)) makeBuiltIn$1(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$3.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor$4 = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor$4 : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$5 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$4 = toIntegerOrInfinity$5;

var max$2 = Math.max;
var min$2 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$2 = function (index, length) {
  var integer = toIntegerOrInfinity$4(index);
  return integer < 0 ? max$2(integer + length, 0) : min$2(integer, length);
};

var toIntegerOrInfinity$3 = toIntegerOrInfinity$5;

var min$1 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$3 = function (argument) {
  return argument > 0 ? min$1(toIntegerOrInfinity$3(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength$2 = toLength$3;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$8 = function (obj) {
  return toLength$2(obj.length);
};

var toIndexedObject$3 = toIndexedObject$5;
var toAbsoluteIndex$1 = toAbsoluteIndex$2;
var lengthOfArrayLike$7 = lengthOfArrayLike$8;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$2 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$3($this);
    var length = lengthOfArrayLike$7(O);
    var index = toAbsoluteIndex$1(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$2(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$2(false)
};

var uncurryThis$j = functionUncurryThis;
var hasOwn$9 = hasOwnProperty_1;
var toIndexedObject$2 = toIndexedObject$5;
var indexOf$1 = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var push$5 = uncurryThis$j([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$2(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$9(hiddenKeys$2, key) && hasOwn$9(O, key) && push$5(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$9(O, key = names[i++])) {
    ~indexOf$1(result, key) || push$5(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$5 = getBuiltIn$7;
var uncurryThis$i = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$g = anObject$i;

var concat$2 = uncurryThis$i([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$5('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$g(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$2(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$8 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$2 = objectDefineProperty;

var copyConstructorProperties$2 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$2.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$8(target, key) && !(exceptions && hasOwn$8(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$g = fails$o;
var isCallable$f = isCallable$p;

var replacement = /#|\.prototype\./;

var isForced$3 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable$f(detection) ? fails$g(detection)
    : !!detection;
};

var normalize = isForced$3.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$3.data = {};
var NATIVE = isForced$3.NATIVE = 'N';
var POLYFILL = isForced$3.POLYFILL = 'P';

var isForced_1 = isForced$3;

var global$f = global$p;
var getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$6;
var defineBuiltIn$a = defineBuiltIn$b;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties$1 = copyConstructorProperties$2;
var isForced$2 = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$f;
  } else if (STATIC) {
    target = global$f[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global$f[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor$2(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$2(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties$1(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$4(sourceProperty, 'sham', true);
    }
    defineBuiltIn$a(target, key, sourceProperty, options);
  }
};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$8 = descriptors;
var uncurryThis$h = functionUncurryThis;
var call$h = functionCall;
var fails$f = fails$o;
var objectKeys$1 = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$6 = toObject$8;
var IndexedObject$1 = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$5 = Object.defineProperty;
var concat$1 = uncurryThis$h([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$f(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$8 && $assign({ b: 1 }, $assign(defineProperty$5({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$5(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol('assign detection');
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] !== 7 || objectKeys$1($assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$6(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject$1(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat$1(objectKeys$1(S), getOwnPropertySymbols(S)) : objectKeys$1(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$8 || call$h(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$g = _export;
var assign$2 = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$g({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign$2 }, {
  assign: assign$2
});

var objectDefineProperties = {};

var DESCRIPTORS$7 = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule$1 = objectDefineProperty;
var anObject$f = anObject$i;
var toIndexedObject$1 = toIndexedObject$5;
var objectKeys = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$7 && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$f(O);
  var props = toIndexedObject$1(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$1.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn$4 = getBuiltIn$7;

var html$2 = getBuiltIn$4('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */
var anObject$e = anObject$i;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html$1 = html$2;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$1 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$1('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html$1.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$e(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var wellKnownSymbol$k = wellKnownSymbol$m;
var create$3 = objectCreate;
var defineProperty$4 = objectDefineProperty.f;

var UNSCOPABLES = wellKnownSymbol$k('unscopables');
var ArrayPrototype$1 = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype$1[UNSCOPABLES] === undefined) {
  defineProperty$4(ArrayPrototype$1, UNSCOPABLES, {
    configurable: true,
    value: create$3(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$3 = function (key) {
  ArrayPrototype$1[UNSCOPABLES][key] = true;
};

var iterators = {};

var fails$e = fails$o;

var correctPrototypeGetter = !fails$e(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var hasOwn$7 = hasOwnProperty_1;
var isCallable$e = isCallable$p;
var toObject$5 = toObject$8;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var $Object$1 = Object;
var ObjectPrototype = $Object$1.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object$1.getPrototypeOf : function (O) {
  var object = toObject$5(O);
  if (hasOwn$7(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$e(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object$1 ? ObjectPrototype : null;
};

var fails$d = fails$o;
var isCallable$d = isCallable$p;
var isObject$6 = isObject$c;
var getPrototypeOf$1 = objectGetPrototypeOf;
var defineBuiltIn$9 = defineBuiltIn$b;
var wellKnownSymbol$j = wellKnownSymbol$m;

var ITERATOR$7 = wellKnownSymbol$j('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject$6(IteratorPrototype$2) || fails$d(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$7].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$d(IteratorPrototype$2[ITERATOR$7])) {
  defineBuiltIn$9(IteratorPrototype$2, ITERATOR$7, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty$3 = objectDefineProperty.f;
var hasOwn$6 = hasOwnProperty_1;
var wellKnownSymbol$i = wellKnownSymbol$m;

var TO_STRING_TAG$3 = wellKnownSymbol$i('toStringTag');

var setToStringTag$5 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$6(target, TO_STRING_TAG$3)) {
    defineProperty$3(target, TO_STRING_TAG$3, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create$2 = objectCreate;
var createPropertyDescriptor$2 = createPropertyDescriptor$5;
var setToStringTag$4 = setToStringTag$5;
var Iterators$4 = iterators;

var returnThis$1 = function () { return this; };

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create$2(IteratorPrototype$1, { next: createPropertyDescriptor$2(+!ENUMERABLE_NEXT, next) });
  setToStringTag$4(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$4[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var uncurryThis$g = functionUncurryThis;
var aCallable$8 = aCallable$a;

var functionUncurryThisAccessor = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis$g(aCallable$8(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};

var isCallable$c = isCallable$p;

var $String$1 = String;
var $TypeError$b = TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (typeof argument == 'object' || isCallable$c(argument)) return argument;
  throw new $TypeError$b("Can't set " + $String$1(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = functionUncurryThisAccessor;
var anObject$d = anObject$i;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject$d(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var $$f = _export;
var call$g = functionCall;
var FunctionName = functionName;
var isCallable$b = isCallable$p;
var createIteratorConstructor$1 = iteratorCreateConstructor;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf$2 = objectSetPrototypeOf;
var setToStringTag$3 = setToStringTag$5;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$6;
var defineBuiltIn$8 = defineBuiltIn$b;
var wellKnownSymbol$h = wellKnownSymbol$m;
var Iterators$3 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME$1 = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$6 = wellKnownSymbol$h('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor$1(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    }

    return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$6]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf$2) {
          setPrototypeOf$2(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$b(CurrentIteratorPrototype[ITERATOR$6])) {
          defineBuiltIn$8(CurrentIteratorPrototype, ITERATOR$6, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$3(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME$1 && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$3(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$g(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn$8(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$f({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$6] !== defaultIterator) {
    defineBuiltIn$8(IterablePrototype, ITERATOR$6, defaultIterator, { name: DEFAULT });
  }
  Iterators$3[NAME] = defaultIterator;

  return methods;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject$3 = function (value, done) {
  return { value: value, done: done };
};

var toIndexedObject = toIndexedObject$5;
var addToUnscopables$2 = addToUnscopables$3;
var Iterators$2 = iterators;
var InternalStateModule$4 = internalState;
var defineProperty$2 = objectDefineProperty.f;
var defineIterator$1 = iteratorDefine;
var createIterResultObject$2 = createIterResultObject$3;
var DESCRIPTORS$6 = descriptors;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$4 = InternalStateModule$4.set;
var getInternalState$2 = InternalStateModule$4.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator$1(Array, 'Array', function (iterated, kind) {
  setInternalState$4(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$2(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject$2(undefined, true);
  }
  switch (state.kind) {
    case 'keys': return createIterResultObject$2(index, false);
    case 'values': return createIterResultObject$2(target[index], false);
  } return createIterResultObject$2([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators$2.Arguments = Iterators$2.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$2('keys');
addToUnscopables$2('values');
addToUnscopables$2('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS$6 && values.name !== 'values') try {
  defineProperty$2(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var global$e = global$p;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$6;
var wellKnownSymbol$g = wellKnownSymbol$m;

var ITERATOR$5 = wellKnownSymbol$g('iterator');
var TO_STRING_TAG$2 = wellKnownSymbol$g('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$5] !== ArrayValues) try {
      createNonEnumerableProperty$2(CollectionPrototype, ITERATOR$5, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$5] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG$2]) {
      createNonEnumerableProperty$2(CollectionPrototype, TO_STRING_TAG$2, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty$2(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$e[COLLECTION_NAME] && global$e[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? process.env.NODE_ENV === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (process.env.NODE_ENV !== 'production') {
      var isImportRule = rule.charCodeAt(0) === 64 && rule.charCodeAt(1) === 105;

      if (isImportRule && this._alreadyInsertedOrderInsensitiveRule) {
        // this would only cause problem in speedy mode
        // but we don't want enabling speedy to affect the observable behavior
        // so we report this error at all times
        console.error("You're attempting to insert the following rule:\n" + rule + '\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules.');
      }
      this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !isImportRule;
    }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (process.env.NODE_ENV !== 'production' && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(rule)) {
          console.error("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (process.env.NODE_ENV !== 'production') {
      this._alreadyInsertedOrderInsensitiveRule = false;
    }
  };

  return StyleSheet;
}();

var MS = '-ms-';
var MOZ = '-moz-';
var WEBKIT$1 = '-webkit-';

var COMMENT = 'comm';
var RULESET = 'rule';
var DECLARATION = 'decl';
var IMPORT = '@import';
var KEYFRAMES = '@keyframes';
var LAYER = '@layer';

/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs;

/**
 * @param {number}
 * @return {string}
 */
var from = String.fromCharCode;

/**
 * @param {object}
 * @return {object}
 */
var assign$1 = Object.assign;

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return charat(value, 0) ^ 45 ? (((((((length << 2) ^ charat(value, 0)) << 2) ^ charat(value, 1)) << 2) ^ charat(value, 2)) << 2) ^ charat(value, 3) : 0
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace$7 (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function combine (array, callback) {
	return array.map(callback).join('')
}

var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = '';

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node$1 (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function copy (root, props) {
	return assign$1(node$1('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? charat(characters, --position) : 0;

	if (column--, character === 10)
		column = 1, line--;

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < length ? charat(characters, position++) : 0;

	if (column++, character === 10)
		column = 1, line++;

	return character
}

/**
 * @return {number}
 */
function peek () {
	return charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, length = strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(position - 1, delimiter$1(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next();
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter$1 (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter$1(character);
				break
			// (
			case 40:
				if (type === 41)
					delimiter$1(type);
				break
			// \
			case 92:
				next();
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next();

	return slice(index, position)
}

/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0;
	var offset = 0;
	var length = pseudo;
	var atrule = 0;
	var property = 0;
	var previous = 0;
	var variable = 1;
	var scanning = 1;
	var ampersand = 1;
	var character = 0;
	var type = '';
	var props = rules;
	var children = rulesets;
	var reference = rule;
	var characters = type;

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && charat(characters, length - 1) == 58) {
					if (indexof(characters += replace$7(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1;
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character);
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous);
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7);
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						append(comment(commenter(next(), caret()), root, parent), declarations);
						break
					default:
						characters += '/';
				}
				break
			// {
			case 123 * variable:
				points[index++] = strlen(characters) * ampersand;
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0;
					// ;
					case 59 + offset: if (ampersand == -1) characters = replace$7(characters, /\f/g, '');
						if (property > 0 && (strlen(characters) - length))
							append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(replace$7(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
						break
					// @ ;
					case 59: characters += ';';
					// { rule/at-rule
					default:
						append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children);
							else
								switch (atrule === 99 && charat(characters, 3) === 110 ? 100 : atrule) {
									// d l m s
									case 100: case 108: case 109: case 115:
										parse(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
										break
									default:
										parse(characters, reference, reference, reference, [''], children, 0, points, children);
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
				break
			// :
			case 58:
				length = 1 + strlen(characters), property = previous;
			default:
				if (variable < 1)
					if (character == 123)
						--variable;
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1);
						break
					// ,
					case 44:
						points[index++] = (strlen(characters) - 1) * ampersand, ampersand = 1;
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next());

						atrule = peek(), offset = length = strlen(type = characters += identifier(caret())), character++;
						break
					// -
					case 45:
						if (previous === 45 && strlen(characters) == 2)
							variable = 0;
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1;
	var rule = offset === 0 ? rules : [''];
	var size = sizeof(rule);

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : replace$7(y, /&\f/g, rule[x])))
				props[k++] = z;

	return node$1(value, root, parent, offset === 0 ? RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node$1(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node$1(value, root, parent, DECLARATION, substr(value, 0, length), substr(value, length + 1, -1), length)
}

/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize$1 (children, callback) {
	var output = '';
	var length = sizeof(children);

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || '';

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case LAYER: if (element.children.length) break
		case IMPORT: case DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case KEYFRAMES: return element.return = element.value + '{' + serialize$1(element.children, callback) + '}'
		case RULESET: element.value = element.props.join(',');
	}

	return strlen(children = serialize$1(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = sizeof(collection);

	return function (element, index, children, callback) {
		var output = '';

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || '';

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element);
	}
}

var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule' || cache.compat) return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses) {
      var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
      //
      // considering this input:
      // .a {
      //   .b /* comm */ {}
      //   color: hotpink;
      // }
      // we get output corresponding to this:
      // .a {
      //   & {
      //     /* comm */
      //     color: hotpink;
      //   }
      //   .b {}
      // }

      var commentContainer = isNested ? element.parent.children : // global rule at the root level
      children;

      for (var i = commentContainer.length - 1; i >= 0; i--) {
        var node = commentContainer[i];

        if (node.line < element.line) {
          break;
        } // it is quite weird but comments are *usually* put at `column: element.column - 1`
        // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
        // this will also match inputs like this:
        // .a {
        //   /* comm */
        //   .b {}
        // }
        //
        // but that is fine
        //
        // it would be the easiest to change the placement of the comment to be the first child of the rule:
        // .a {
        //   .b { /* comm */ }
        // }
        // with such inputs we wouldn't have to search for the comment at all
        // TODO: consider changing this comment placement in the next major version


        if (node.column < element.column) {
          if (isIgnoringComment(node)) {
            return;
          }

          break;
        }
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

/* eslint-disable no-fallthrough */

function prefix(value, length) {
  switch (hash(value, length)) {
    // color-adjust
    case 5103:
      return WEBKIT$1 + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT$1 + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT$1 + value + MOZ + value + MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return WEBKIT$1 + value + MS + value + value;
    // order

    case 6165:
      return WEBKIT$1 + value + MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return WEBKIT$1 + value + replace$7(value, /(\w+).+(:[^]+)/, WEBKIT$1 + 'box-$1$2' + MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return WEBKIT$1 + value + MS + 'flex-item-' + replace$7(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return WEBKIT$1 + value + MS + 'flex-line-pack' + replace$7(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return WEBKIT$1 + value + MS + replace$7(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return WEBKIT$1 + value + MS + replace$7(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return WEBKIT$1 + 'box-' + replace$7(value, '-grow', '') + WEBKIT$1 + value + MS + replace$7(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return WEBKIT$1 + replace$7(value, /([^-])(transform)/g, '$1' + WEBKIT$1 + '$2') + value;
    // cursor

    case 6187:
      return replace$7(replace$7(replace$7(value, /(zoom-|grab)/, WEBKIT$1 + '$1'), /(image-set)/, WEBKIT$1 + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return replace$7(value, /(image-set\([^]*)/, WEBKIT$1 + '$1' + '$`$1');
    // justify-content

    case 4968:
      return replace$7(replace$7(value, /(.+:)(flex-)?(.*)/, WEBKIT$1 + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT$1 + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace$7(value, /(.+)-inline(.+)/, WEBKIT$1 + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (strlen(value) - 1 - length > 6) switch (charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return replace$7(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT$1 + '$2-$3' + '$1' + MOZ + (charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? prefix(replace$7(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return replace$7(value, ':', ':' + WEBKIT$1) + value;
        // (inline-)?fl(e)x

        case 101:
          return replace$7(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + WEBKIT$1 + (charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT$1 + '$2$3' + '$1' + MS + '$2box$3') + value;
      }

      break;
    // writing-mode

    case 5936:
      switch (charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return WEBKIT$1 + value + MS + replace$7(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return WEBKIT$1 + value + MS + replace$7(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return WEBKIT$1 + value + MS + replace$7(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }

      return WEBKIT$1 + value + MS + value + value;
  }

  return value;
}

var prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case DECLARATION:
      element["return"] = prefix(element.value, element.length);
      break;

    case KEYFRAMES:
      return serialize$1([copy(element, {
        value: replace$7(element.value, '@', '@' + WEBKIT$1)
      })], callback);

    case RULESET:
      if (element.length) return combine(element.props, function (value) {
        switch (match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return serialize$1([copy(element, {
              props: [replace$7(value, /:(read-\w+)/, ':' + MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return serialize$1([copy(element, {
              props: [replace$7(value, /:(plac\w+)/, ':' + WEBKIT$1 + 'input-$1')]
            }), copy(element, {
              props: [replace$7(value, /:(plac\w+)/, ':' + MOZ + '$1')]
            }), copy(element, {
              props: [replace$7(value, /:(plac\w+)/, MS + 'input-$1')]
            })], callback);
        }

        return '';
      });
  }
};

var isBrowser$3 = typeof document !== 'undefined';
var getServerStylisCache = isBrowser$3 ? undefined : weakMemoize(function () {
  return memoize(function () {
    var cache = {};
    return function (name) {
      return cache[name];
    };
  });
});
var defaultStylisPlugins = [prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (process.env.NODE_ENV !== 'production' && !key) {
    throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\n" + "If multiple caches share the same key they might \"fight\" for each other's style elements.");
  }

  if (isBrowser$3 && key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  if (isBrowser$3) {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (process.env.NODE_ENV !== 'production') {
    omnipresentPlugins.push(createUnsafeSelectorsAlarm({
      get compat() {
        return cache.compat;
      }

    }), incorrectImportAlarm);
  }

  if (isBrowser$3) {
    var currentSheet;
    var finalizingPlugins = [stringify, process.env.NODE_ENV !== 'production' ? function (element) {
      if (!element.root) {
        if (element["return"]) {
          currentSheet.insert(element["return"]);
        } else if (element.value && element.type !== COMMENT) {
          // insert empty rule in non-production environments
          // so @emotion/jest can grab `key` from the (JS)DOM for caches without any rules inserted yet
          currentSheet.insert(element.value + "{}");
        }
      }
    } : rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return serialize$1(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (process.env.NODE_ENV !== 'production' && serialized.map !== undefined) {
        currentSheet = {
          insert: function insert(rule) {
            sheet.insert(rule + serialized.map);
          }
        };
      }

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  } else {
    var _finalizingPlugins = [stringify];

    var _serializer = middleware(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));

    var _stylis = function _stylis(styles) {
      return serialize$1(compile(styles), _serializer);
    }; // $FlowFixMe


    var serverStylisCache = getServerStylisCache(stylisPlugins)(key);

    var getRules = function getRules(selector, serialized) {
      var name = serialized.name;

      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      }

      return serverStylisCache[name];
    };

    _insert = function _insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);

      if (cache.compat === undefined) {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }

        if ( // using === development instead of !== production
        // because if people do ssr in tests, the source maps showing up would be annoying
        process.env.NODE_ENV === 'development' && serialized.map !== undefined) {
          return rules + serialized.map;
        }

        return rules;
      } else {
        // in compat mode, we put the styles on the inserted cache so
        // that emotion-server can pull out the styles
        // except when we don't want to cache it which was in Global but now
        // is nowhere but we don't want to do a major right now
        // and just in case we're going to leave the case here
        // it's also not affecting client side bundle size
        // so it's really not a big deal
        if (shouldCache) {
          cache.inserted[name] = rules;
        } else {
          return rules;
        }
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

var reactIs$1 = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development.AsyncMode = AsyncMode;
reactIs_development.ConcurrentMode = ConcurrentMode;
reactIs_development.ContextConsumer = ContextConsumer;
reactIs_development.ContextProvider = ContextProvider;
reactIs_development.Element = Element;
reactIs_development.ForwardRef = ForwardRef;
reactIs_development.Fragment = Fragment;
reactIs_development.Lazy = Lazy;
reactIs_development.Memo = Memo;
reactIs_development.Portal = Portal;
reactIs_development.Profiler = Profiler;
reactIs_development.StrictMode = StrictMode;
reactIs_development.Suspense = Suspense;
reactIs_development.isAsyncMode = isAsyncMode;
reactIs_development.isConcurrentMode = isConcurrentMode;
reactIs_development.isContextConsumer = isContextConsumer;
reactIs_development.isContextProvider = isContextProvider;
reactIs_development.isElement = isElement;
reactIs_development.isForwardRef = isForwardRef;
reactIs_development.isFragment = isFragment;
reactIs_development.isLazy = isLazy;
reactIs_development.isMemo = isMemo;
reactIs_development.isPortal = isPortal;
reactIs_development.isProfiler = isProfiler;
reactIs_development.isStrictMode = isStrictMode;
reactIs_development.isSuspense = isSuspense;
reactIs_development.isValidElementType = isValidElementType;
reactIs_development.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs$1.exports = reactIs_production_min;
} else {
  reactIs$1.exports = reactIs_development;
}

var reactIs = reactIs$1.exports;
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

var isBrowser$2 = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$2 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      if (!isBrowser$2 && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }

      current = current.next;
    } while (current !== undefined);

    if (!isBrowser$2 && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */memoize(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (process.env.NODE_ENV !== 'production') {
  var contentValuePattern = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
  var contentValues = ['normal', 'none', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

var noComponentSelectorMessage = 'Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.';

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (process.env.NODE_ENV !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
      throw new Error(noComponentSelectorMessage);
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (process.env.NODE_ENV !== 'production' && interpolation.map !== undefined) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (process.env.NODE_ENV !== 'production') {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if (process.env.NODE_ENV !== 'production') {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
          throw new Error(noComponentSelectorMessage);
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (process.env.NODE_ENV !== 'production' && _key === 'undefined') {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (process.env.NODE_ENV !== 'production') {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (process.env.NODE_ENV !== 'production' && strings[0] === undefined) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (process.env.NODE_ENV !== 'production' && strings[i] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (process.env.NODE_ENV !== 'production') {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = murmur2(styles) + identifierName;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};

var isBrowser$1 = typeof document !== 'undefined';

var syncFallback = function syncFallback(create) {
  return create();
};

var useInsertionEffect = React['useInsertion' + 'Effect'] ? React['useInsertion' + 'Effect'] : false;
var useInsertionEffectAlwaysWithSyncFallback = !isBrowser$1 ? syncFallback : useInsertionEffect || syncFallback;

var isBrowser = typeof document !== 'undefined';
var hasOwnProperty = {}.hasOwnProperty;

var EmotionCacheContext = /* #__PURE__ */createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */createCache({
  key: 'css'
}) : null);

if (process.env.NODE_ENV !== 'production') {
  EmotionCacheContext.displayName = 'EmotionCacheContext';
}

EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/forwardRef(function (props, ref) {
    // the cache will never be null in the browser
    var cache = useContext(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

if (!isBrowser) {
  withEmotionCache = function withEmotionCache(func) {
    return function (props) {
      var cache = useContext(EmotionCacheContext);

      if (cache === null) {
        // yes, we're potentially creating this on every render
        // it doesn't actually matter though since it's only on the server
        // so there will only every be a single render
        // that could change in the future because of suspense and etc. but for now,
        // this works and i don't want to optimise for a future thing that we aren't sure about
        cache = createCache({
          key: 'css'
        });
        return /*#__PURE__*/createElement$2(EmotionCacheContext.Provider, {
          value: cache
        }, func(props, cache));
      } else {
        return func(props, cache);
      }
    };
  };
}

var ThemeContext = /* #__PURE__ */createContext({});

if (process.env.NODE_ENV !== 'production') {
  ThemeContext.displayName = 'EmotionThemeContext';
}

var getLastPart = function getLastPart(functionName) {
  // The match may be something like 'Object.createEmotionProps' or
  // 'Loader.prototype.render'
  var parts = functionName.split('.');
  return parts[parts.length - 1];
};

var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
  // V8
  var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
  if (match) return getLastPart(match[1]); // Safari / Firefox

  match = /^([A-Za-z0-9$.]+)@/.exec(line);
  if (match) return getLastPart(match[1]);
  return undefined;
};

var internalReactFunctionNames = /* #__PURE__ */new Set(['renderWithHooks', 'processChild', 'finishClassComponent', 'renderToString']); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
  if (!stackTrace) return undefined;
  var lines = stackTrace.split('\n');

  for (var i = 0; i < lines.length; i++) {
    var functionName = getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"

    if (!functionName) continue; // If we reach one of these, we have gone too far and should quit

    if (internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
    // uppercase letter

    if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
  }

  return undefined;
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (process.env.NODE_ENV !== 'production' && typeof props.css === 'string' && // check if there is a css declaration
  props.css.indexOf(':') !== -1) {
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + props.css + "`");
  }

  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
  // the label hasn't already been computed

  if (process.env.NODE_ENV !== 'production' && !!props.css && (typeof props.css !== 'object' || typeof props.css.name !== 'string' || props.css.name.indexOf('-') === -1)) {
    var label = getLabelFromStackTrace(new Error().stack);
    if (label) newProps[labelPropName] = label;
  }

  return newProps;
};

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  var rules = useInsertionEffectAlwaysWithSyncFallback(function () {
    return insertStyles(cache, serialized, isStringTag);
  });

  if (!isBrowser && rules !== undefined) {
    var _ref2;

    var serializedNames = serialized.name;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      next = next.next;
    }

    return /*#__PURE__*/createElement$2("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref2.nonce = cache.sheet.nonce, _ref2));
  }

  return null;
};

var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles(registeredStyles, undefined, useContext(ThemeContext));

  if (process.env.NODE_ENV !== 'production' && serialized.name.indexOf('-') === -1) {
    var labelFromStack = props[labelPropName];

    if (labelFromStack) {
      serialized = serializeStyles([serialized, 'label:' + labelFromStack + ';']);
    }
  }

  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && (process.env.NODE_ENV === 'production' || key !== labelPropName)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  return /*#__PURE__*/createElement$2(Fragment, null, /*#__PURE__*/createElement$2(Insertion, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/createElement$2(WrappedComponent, newProps));
});

if (process.env.NODE_ENV !== 'production') {
  Emotion.displayName = 'EmotionCssPropInternal';
}

function jsx(type, props, key) {
  if (!hasOwnProperty.call(props, 'css')) {
    return jsx$1(type, props, key);
  }

  return jsx$1(Emotion, createEmotionProps(type, props), key);
}

/* eslint-disable @typescript-eslint/no-explicit-any */
const ResourcesContext = /*#__PURE__*/createContext(null);
const useResources = () => {
  const resources = useContext(ResourcesContext);
  if (!resources) throw new Error('useResources used outside of Provider');
  return resources;
};

const ConnectionContext = /*#__PURE__*/createContext(null);
const ConnectionProvider = ({
  children
}) => {
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.events) throw new Error('Missing events from resources');
  const manager = connectionManager(resources);
  return jsx(ConnectionContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const useConnection = () => {
  const context = useContext(ConnectionContext);
  if (context === undefined || context === null) {
    throw new Error('useConnection used outside of its Provider');
  }
  return context;
};
const connectionManager = ({
  events
}) => {
  const [connection, setConnection] = useState(false);
  useEffect(() => {
    const tracker = events.createTracker();
    tracker.on('connectivity:online', () => setConnection(false));
    tracker.on('connectivity:offline', () => setConnection(true));
    return () => {
      tracker.off();
    };
  }, [events]);
  return {
    connection
  };
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

const languageToLocale = {
  en: 'en-US',
  fr: 'fr',
  es: 'es',
  pt: 'pt',
  cn_s: 'zh-CN',
  cn_t: 'zh-HK',
  ta: 'ta'
};
const CurrentPersonContext = /*#__PURE__*/createContext(null);
const CurrentPersonProvider = ({
  children
}) => {
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.api || !resources.events) throw new Error('Missing events from resources');
  const manager = currentPersonManager(resources);
  return jsx(CurrentPersonContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const useCurrentPerson = () => {
  const context = useContext(CurrentPersonContext);
  if (context === undefined || context === null) {
    throw new Error('useCurrentPerson used outside of its Provider');
  }
  return context;
};
const currentPersonManager = ({
  api,
  events
}) => {
  const [personal, setPersonal] = useState({
    language: 'en'
  });
  const [org, setOrg] = useState({});
  const [group, setGroup] = useState({});
  useEffect(() => {
    getGroupData();
    getOrgData();
    getPersonal();
    events.on('mqtt:$/orggroup/staff/removed', () => setGroup({}));
    events.on('mqtt:$/org/managers/removed', () => setOrg({}));
    events.on('mqtt:$/orggroup/staff/added', getGroupData);
    events.on('mqtt:$/org/managers/added', getOrgData);
    events.on('mqtt:$/settings', getPersonal);
    function getGroupData() {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          const data = yield api.org.group.current.data();
          setGroup(data);
        } catch (error) {
          Sentry.captureException(error);
          console.error(error);
        }
      });
    }
    function getOrgData() {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          const data = yield api.org.staff.orgData();
          setOrg(data);
        } catch (error) {
          Sentry.captureException(error);
          console.error(error);
        }
      });
    }
    function getPersonal() {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          const data = yield api.people.data();
          const {
            timezone,
            language,
            autologout,
            available
          } = data;
          const locale = languageToLocale[language] || "en-US";
          setPersonal(Object.assign(Object.assign({}, data), {
            locale
          }));
          Sentry.setContext('config', {
            timezone,
            language,
            autologout,
            available
          });
        } catch (error) {
          Sentry.captureException(error);
          console.error(error);
        }
      });
    }
  }, [api, events]);
  return {
    personal,
    group,
    org
  };
};

const LocalizeContext = /*#__PURE__*/createContext(null);
const LocalizeProvider = ({
  children,
  map
}) => {
  const manager = localizeManager({
    map
  });
  return jsx(LocalizeContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const useLocalize = () => {
  const context = useContext(LocalizeContext);
  if (context === undefined || context === null) {
    throw new Error('useLocalize used outside of its Provider');
  }
  return context;
};
const localizeManager = ({
  map
}) => {
  const {
    personal: {
      language
    }
  } = useCurrentPerson();
  const doLocalize = useCallback((key, args) => localize(map[language || 'en'], key, args) || key, [language, map]);
  const doLocalizeFrom = useCallback((customMap, key, args) => {
    if (!customMap) return "";
    let localizedMap = typeof customMap === "object" ? customMap[language] : customMap;
    if (!localizedMap && localizedMap !== "") {
      localizedMap = customMap;
    }
    return localize(localizedMap, key, args) || key;
  }, [language]);
  return {
    language,
    localizeFrom: doLocalizeFrom,
    localize: doLocalize,
    localizationMap: map
  };
};

var aCallable$7 = aCallable$a;
var toObject$4 = toObject$8;
var IndexedObject = indexedObject;
var lengthOfArrayLike$6 = lengthOfArrayLike$8;

var $TypeError$a = TypeError;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod$1 = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable$7(callbackfn);
    var O = toObject$4(that);
    var self = IndexedObject(O);
    var length = lengthOfArrayLike$6(O);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw new $TypeError$a('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod$1(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod$1(true)
};

var fails$c = fails$o;

var arrayMethodIsStrict$2 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails$c(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};

var global$d = global$p;
var classof$8 = classofRaw$2;

var engineIsNode = classof$8(global$d.process) === 'process';

var $$e = _export;
var $reduce = arrayReduce.left;
var arrayMethodIsStrict$1 = arrayMethodIsStrict$2;
var CHROME_VERSION = engineV8Version;
var IS_NODE$4 = engineIsNode;

// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE$4 && CHROME_VERSION > 79 && CHROME_VERSION < 83;
var FORCED$1 = CHROME_BUG || !arrayMethodIsStrict$1('reduce');

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$$e({ target: 'Array', proto: true, forced: FORCED$1 }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});

var makeBuiltIn = makeBuiltIn$3.exports;
var defineProperty$1 = objectDefineProperty;

var defineBuiltInAccessor$4 = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty$1.f(target, name, descriptor);
};

var getBuiltIn$3 = getBuiltIn$7;
var defineBuiltInAccessor$3 = defineBuiltInAccessor$4;
var wellKnownSymbol$f = wellKnownSymbol$m;
var DESCRIPTORS$5 = descriptors;

var SPECIES$4 = wellKnownSymbol$f('species');

var setSpecies$2 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$3(CONSTRUCTOR_NAME);

  if (DESCRIPTORS$5 && Constructor && !Constructor[SPECIES$4]) {
    defineBuiltInAccessor$3(Constructor, SPECIES$4, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var isPrototypeOf$4 = objectIsPrototypeOf;

var $TypeError$9 = TypeError;

var anInstance$3 = function (it, Prototype) {
  if (isPrototypeOf$4(Prototype, it)) return it;
  throw new $TypeError$9('Incorrect invocation');
};

var wellKnownSymbol$e = wellKnownSymbol$m;

var TO_STRING_TAG$1 = wellKnownSymbol$e('toStringTag');
var test$1 = {};

test$1[TO_STRING_TAG$1] = 'z';

var toStringTagSupport = String(test$1) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$a = isCallable$p;
var classofRaw$1 = classofRaw$2;
var wellKnownSymbol$d = wellKnownSymbol$m;

var TO_STRING_TAG = wellKnownSymbol$d('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw$1(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$7 = TO_STRING_TAG_SUPPORT ? classofRaw$1 : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw$1(O)
    // ES3 arguments fallback
    : (result = classofRaw$1(O)) === 'Object' && isCallable$a(O.callee) ? 'Arguments' : result;
};

var uncurryThis$f = functionUncurryThis;
var fails$b = fails$o;
var isCallable$9 = isCallable$p;
var classof$6 = classof$7;
var getBuiltIn$2 = getBuiltIn$7;
var inspectSource$1 = inspectSource$3;

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn$2('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec$4 = uncurryThis$f(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.test(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable$9(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable$9(argument)) return false;
  switch (classof$6(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec$4(constructorRegExp, inspectSource$1(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$3 = !construct || fails$b(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var isConstructor$2 = isConstructor$3;
var tryToString$3 = tryToString$5;

var $TypeError$8 = TypeError;

// `Assert: IsConstructor(argument) is true`
var aConstructor$1 = function (argument) {
  if (isConstructor$2(argument)) return argument;
  throw new $TypeError$8(tryToString$3(argument) + ' is not a constructor');
};

var anObject$c = anObject$i;
var aConstructor = aConstructor$1;
var isNullOrUndefined$4 = isNullOrUndefined$7;
var wellKnownSymbol$c = wellKnownSymbol$m;

var SPECIES$3 = wellKnownSymbol$c('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor$1 = function (O, defaultConstructor) {
  var C = anObject$c(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined$4(S = anObject$c(C)[SPECIES$3]) ? defaultConstructor : aConstructor(S);
};

var NATIVE_BIND$1 = functionBindNative;

var FunctionPrototype = Function.prototype;
var apply$2 = FunctionPrototype.apply;
var call$f = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND$1 ? call$f.bind(apply$2) : function () {
  return call$f.apply(apply$2, arguments);
});

var classofRaw = classofRaw$2;
var uncurryThis$e = functionUncurryThis;

var functionUncurryThisClause = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis$e(fn);
};

var uncurryThis$d = functionUncurryThisClause;
var aCallable$6 = aCallable$a;
var NATIVE_BIND = functionBindNative;

var bind$8 = uncurryThis$d(uncurryThis$d.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable$6(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind$8(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var uncurryThis$c = functionUncurryThis;

var arraySlice$3 = uncurryThis$c([].slice);

var $TypeError$7 = TypeError;

var validateArgumentsLength$3 = function (passed, required) {
  if (passed < required) throw new $TypeError$7('Not enough arguments');
  return passed;
};

var userAgent$4 = engineUserAgent;

// eslint-disable-next-line redos/no-vulnerable -- safe
var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent$4);

var global$c = global$p;
var apply$1 = functionApply;
var bind$7 = functionBindContext;
var isCallable$8 = isCallable$p;
var hasOwn$5 = hasOwnProperty_1;
var fails$a = fails$o;
var html = html$2;
var arraySlice$2 = arraySlice$3;
var createElement = documentCreateElement$2;
var validateArgumentsLength$2 = validateArgumentsLength$3;
var IS_IOS$1 = engineIsIos;
var IS_NODE$3 = engineIsNode;

var set = global$c.setImmediate;
var clear = global$c.clearImmediate;
var process$3 = global$c.process;
var Dispatch = global$c.Dispatch;
var Function$1 = global$c.Function;
var MessageChannel = global$c.MessageChannel;
var String$1 = global$c.String;
var counter = 0;
var queue$2 = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;

fails$a(function () {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = global$c.location;
});

var run = function (id) {
  if (hasOwn$5(queue$2, id)) {
    var fn = queue$2[id];
    delete queue$2[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var eventListener = function (event) {
  run(event.data);
};

var globalPostMessageDefer = function (id) {
  // old engines have not location.origin
  global$c.postMessage(String$1(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength$2(arguments.length, 1);
    var fn = isCallable$8(handler) ? handler : Function$1(handler);
    var args = arraySlice$2(arguments, 1);
    queue$2[++counter] = function () {
      apply$1(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue$2[id];
  };
  // Node.js 0.8-
  if (IS_NODE$3) {
    defer = function (id) {
      process$3.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS$1) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = eventListener;
    defer = bind$7(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global$c.addEventListener &&
    isCallable$8(global$c.postMessage) &&
    !global$c.importScripts &&
    $location && $location.protocol !== 'file:' &&
    !fails$a(globalPostMessageDefer)
  ) {
    defer = globalPostMessageDefer;
    global$c.addEventListener('message', eventListener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task$1 = {
  set: set,
  clear: clear
};

var Queue$2 = function () {
  this.head = null;
  this.tail = null;
};

Queue$2.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    var tail = this.tail;
    if (tail) tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      var next = this.head = entry.next;
      if (next === null) this.tail = null;
      return entry.item;
    }
  }
};

var queue$1 = Queue$2;

var userAgent$3 = engineUserAgent;

var engineIsIosPebble = /ipad|iphone|ipod/i.test(userAgent$3) && typeof Pebble != 'undefined';

var userAgent$2 = engineUserAgent;

var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(userAgent$2);

var global$b = global$p;
var bind$6 = functionBindContext;
var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var macrotask = task$1.set;
var Queue$1 = queue$1;
var IS_IOS = engineIsIos;
var IS_IOS_PEBBLE = engineIsIosPebble;
var IS_WEBOS_WEBKIT = engineIsWebosWebkit;
var IS_NODE$2 = engineIsNode;

var MutationObserver = global$b.MutationObserver || global$b.WebKitMutationObserver;
var document$2 = global$b.document;
var process$2 = global$b.process;
var Promise$1 = global$b.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor$1(global$b, 'queueMicrotask');
var microtask$1 = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
var notify$1, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!microtask$1) {
  var queue = new Queue$1();

  var flush = function () {
    var parent, fn;
    if (IS_NODE$2 && (parent = process$2.domain)) parent.exit();
    while (fn = queue.get()) try {
      fn();
    } catch (error) {
      if (queue.head) notify$1();
      throw error;
    }
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE$2 && !IS_WEBOS_WEBKIT && MutationObserver && document$2) {
    toggle = true;
    node = document$2.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify$1 = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise$1;
    then = bind$6(promise.then, promise);
    notify$1 = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE$2) {
    notify$1 = function () {
      process$2.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // `webpack` dev server bug on IE global methods - use bind(fn, global)
    macrotask = bind$6(macrotask, global$b);
    notify$1 = function () {
      macrotask(flush);
    };
  }

  microtask$1 = function (fn) {
    if (!queue.head) notify$1();
    queue.add(fn);
  };
}

var microtask_1 = microtask$1;

var hostReportErrors$1 = function (a, b) {
  try {
    // eslint-disable-next-line no-console -- safe
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  } catch (error) { /* empty */ }
};

var perform$3 = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var global$a = global$p;

var promiseNativeConstructor = global$a.Promise;

/* global Deno -- Deno case */
var engineIsDeno = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';

var IS_DENO$1 = engineIsDeno;
var IS_NODE$1 = engineIsNode;

var engineIsBrowser = !IS_DENO$1 && !IS_NODE$1
  && typeof window == 'object'
  && typeof document == 'object';

var global$9 = global$p;
var NativePromiseConstructor$3 = promiseNativeConstructor;
var isCallable$7 = isCallable$p;
var isForced$1 = isForced_1;
var inspectSource = inspectSource$3;
var wellKnownSymbol$b = wellKnownSymbol$m;
var IS_BROWSER = engineIsBrowser;
var IS_DENO = engineIsDeno;
var V8_VERSION = engineV8Version;

NativePromiseConstructor$3 && NativePromiseConstructor$3.prototype;
var SPECIES$2 = wellKnownSymbol$b('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT$1 = isCallable$7(global$9.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR$5 = isForced$1('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor$3);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor$3);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor$3(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES$2] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (IS_BROWSER || IS_DENO) && !NATIVE_PROMISE_REJECTION_EVENT$1;
});

var promiseConstructorDetection = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR$5,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT$1,
  SUBCLASSING: SUBCLASSING
};

var newPromiseCapability$2 = {};

var aCallable$5 = aCallable$a;

var $TypeError$6 = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw new $TypeError$6('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable$5(resolve);
  this.reject = aCallable$5(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
newPromiseCapability$2.f = function (C) {
  return new PromiseCapability(C);
};

var $$d = _export;
var IS_NODE = engineIsNode;
var global$8 = global$p;
var call$e = functionCall;
var defineBuiltIn$7 = defineBuiltIn$b;
var setPrototypeOf$1 = objectSetPrototypeOf;
var setToStringTag$2 = setToStringTag$5;
var setSpecies$1 = setSpecies$2;
var aCallable$4 = aCallable$a;
var isCallable$6 = isCallable$p;
var isObject$5 = isObject$c;
var anInstance$2 = anInstance$3;
var speciesConstructor = speciesConstructor$1;
var task = task$1.set;
var microtask = microtask_1;
var hostReportErrors = hostReportErrors$1;
var perform$2 = perform$3;
var Queue = queue$1;
var InternalStateModule$3 = internalState;
var NativePromiseConstructor$2 = promiseNativeConstructor;
var PromiseConstructorDetection = promiseConstructorDetection;
var newPromiseCapabilityModule$3 = newPromiseCapability$2;

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR$4 = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule$3.getterFor(PROMISE);
var setInternalState$3 = InternalStateModule$3.set;
var NativePromisePrototype$1 = NativePromiseConstructor$2 && NativePromiseConstructor$2.prototype;
var PromiseConstructor = NativePromiseConstructor$2;
var PromisePrototype = NativePromisePrototype$1;
var TypeError$3 = global$8.TypeError;
var document$1 = global$8.document;
var process$1 = global$8.process;
var newPromiseCapability$1 = newPromiseCapabilityModule$3.f;
var newGenericPromiseCapability = newPromiseCapability$1;

var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global$8.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject$5(it) && isCallable$6(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state === FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(new TypeError$3('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call$e(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$1.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global$8.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global$8['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call$e(task, global$8, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform$2(function () {
        if (IS_NODE) {
          process$1.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call$e(task, global$8, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process$1.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind$5 = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw new TypeError$3("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call$e(then, value,
            bind$5(internalResolve, wrapper, state),
            bind$5(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR$4) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance$2(this, PromisePrototype);
    aCallable$4(executor);
    call$e(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind$5(internalResolve, state), bind$5(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState$3(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn$7(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability$1(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable$6(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable$6(onRejected) && onRejected;
    reaction.domain = IS_NODE ? process$1.domain : undefined;
    if (state.state === PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind$5(internalResolve, state);
    this.reject = bind$5(internalReject, state);
  };

  newPromiseCapabilityModule$3.f = newPromiseCapability$1 = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (isCallable$6(NativePromiseConstructor$2) && NativePromisePrototype$1 !== Object.prototype) {
    nativeThen = NativePromisePrototype$1.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn$7(NativePromisePrototype$1, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call$e(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype$1.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf$1) {
      setPrototypeOf$1(NativePromisePrototype$1, PromisePrototype);
    }
  }
}

$$d({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR$4 }, {
  Promise: PromiseConstructor
});

setToStringTag$2(PromiseConstructor, PROMISE, false);
setSpecies$1(PROMISE);

var wellKnownSymbol$a = wellKnownSymbol$m;
var Iterators$1 = iterators;

var ITERATOR$4 = wellKnownSymbol$a('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$2 = function (it) {
  return it !== undefined && (Iterators$1.Array === it || ArrayPrototype[ITERATOR$4] === it);
};

var classof$5 = classof$7;
var getMethod$4 = getMethod$6;
var isNullOrUndefined$3 = isNullOrUndefined$7;
var Iterators = iterators;
var wellKnownSymbol$9 = wellKnownSymbol$m;

var ITERATOR$3 = wellKnownSymbol$9('iterator');

var getIteratorMethod$4 = function (it) {
  if (!isNullOrUndefined$3(it)) return getMethod$4(it, ITERATOR$3)
    || getMethod$4(it, '@@iterator')
    || Iterators[classof$5(it)];
};

var call$d = functionCall;
var aCallable$3 = aCallable$a;
var anObject$b = anObject$i;
var tryToString$2 = tryToString$5;
var getIteratorMethod$3 = getIteratorMethod$4;

var $TypeError$5 = TypeError;

var getIterator$3 = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$3(argument) : usingIterator;
  if (aCallable$3(iteratorMethod)) return anObject$b(call$d(iteratorMethod, argument));
  throw new $TypeError$5(tryToString$2(argument) + ' is not iterable');
};

var call$c = functionCall;
var anObject$a = anObject$i;
var getMethod$3 = getMethod$6;

var iteratorClose$2 = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject$a(iterator);
  try {
    innerResult = getMethod$3(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call$c(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject$a(innerResult);
  return value;
};

var bind$4 = functionBindContext;
var call$b = functionCall;
var anObject$9 = anObject$i;
var tryToString$1 = tryToString$5;
var isArrayIteratorMethod$1 = isArrayIteratorMethod$2;
var lengthOfArrayLike$5 = lengthOfArrayLike$8;
var isPrototypeOf$3 = objectIsPrototypeOf;
var getIterator$2 = getIterator$3;
var getIteratorMethod$2 = getIteratorMethod$4;
var iteratorClose$1 = iteratorClose$2;

var $TypeError$4 = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

var iterate$2 = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind$4(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose$1(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject$9(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod$2(iterable);
    if (!iterFn) throw new $TypeError$4(tryToString$1(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod$1(iterFn)) {
      for (index = 0, length = lengthOfArrayLike$5(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf$3(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator$2(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call$b(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose$1(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf$3(ResultPrototype, result)) return result;
  } return new Result(false);
};

var wellKnownSymbol$8 = wellKnownSymbol$m;

var ITERATOR$2 = wellKnownSymbol$8('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$2] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration$1 = function (exec, SKIP_CLOSING) {
  try {
    if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  } catch (error) { return false; } // workaround of old WebKit + `eval` bug
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$2] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var NativePromiseConstructor$1 = promiseNativeConstructor;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$1;
var FORCED_PROMISE_CONSTRUCTOR$3 = promiseConstructorDetection.CONSTRUCTOR;

var promiseStaticsIncorrectIteration = FORCED_PROMISE_CONSTRUCTOR$3 || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor$1.all(iterable).then(undefined, function () { /* empty */ });
});

var $$c = _export;
var call$a = functionCall;
var aCallable$2 = aCallable$a;
var newPromiseCapabilityModule$2 = newPromiseCapability$2;
var perform$1 = perform$3;
var iterate$1 = iterate$2;
var PROMISE_STATICS_INCORRECT_ITERATION$1 = promiseStaticsIncorrectIteration;

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$$c({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION$1 }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$2.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform$1(function () {
      var $promiseResolve = aCallable$2(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate$1(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call$a($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$b = _export;
var FORCED_PROMISE_CONSTRUCTOR$2 = promiseConstructorDetection.CONSTRUCTOR;
var NativePromiseConstructor = promiseNativeConstructor;
var getBuiltIn$1 = getBuiltIn$7;
var isCallable$5 = isCallable$p;
var defineBuiltIn$6 = defineBuiltIn$b;

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$$b({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR$2, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (isCallable$5(NativePromiseConstructor)) {
  var method = getBuiltIn$1('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn$6(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}

var $$a = _export;
var call$9 = functionCall;
var aCallable$1 = aCallable$a;
var newPromiseCapabilityModule$1 = newPromiseCapability$2;
var perform = perform$3;
var iterate = iterate$2;
var PROMISE_STATICS_INCORRECT_ITERATION = promiseStaticsIncorrectIteration;

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$$a({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$1.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable$1(C.resolve);
      iterate(iterable, function (promise) {
        call$9($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$9 = _export;
var call$8 = functionCall;
var newPromiseCapabilityModule = newPromiseCapability$2;
var FORCED_PROMISE_CONSTRUCTOR$1 = promiseConstructorDetection.CONSTRUCTOR;

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$$9({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR$1 }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    call$8(capability.reject, undefined, r);
    return capability.promise;
  }
});

var anObject$8 = anObject$i;
var isObject$4 = isObject$c;
var newPromiseCapability = newPromiseCapability$2;

var promiseResolve$1 = function (C, x) {
  anObject$8(C);
  if (isObject$4(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var $$8 = _export;
var getBuiltIn = getBuiltIn$7;
var FORCED_PROMISE_CONSTRUCTOR = promiseConstructorDetection.CONSTRUCTOR;
var promiseResolve = promiseResolve$1;

getBuiltIn('Promise');

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$$8({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(this, x);
  }
});

var classof$4 = classofRaw$2;

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray$2 = Array.isArray || function isArray(argument) {
  return classof$4(argument) === 'Array';
};

var $TypeError$3 = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

var doesNotExceedSafeInteger$1 = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError$3('Maximum allowed index exceeded');
  return it;
};

var isArray$1 = isArray$2;
var lengthOfArrayLike$4 = lengthOfArrayLike$8;
var doesNotExceedSafeInteger = doesNotExceedSafeInteger$1;
var bind$3 = functionBindContext;

// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray$1 = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? bind$3(mapper, thisArg) : false;
  var element, elementLen;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      if (depth > 0 && isArray$1(element)) {
        elementLen = lengthOfArrayLike$4(element);
        targetIndex = flattenIntoArray$1(target, original, element, elementLen, targetIndex, depth - 1) - 1;
      } else {
        doesNotExceedSafeInteger(targetIndex + 1);
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
};

var flattenIntoArray_1 = flattenIntoArray$1;

var isArray = isArray$2;
var isConstructor$1 = isConstructor$3;
var isObject$3 = isObject$c;
var wellKnownSymbol$7 = wellKnownSymbol$m;

var SPECIES$1 = wellKnownSymbol$7('species');
var $Array$2 = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesConstructor$1 = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor$1(C) && (C === $Array$2 || isArray(C.prototype))) C = undefined;
    else if (isObject$3(C)) {
      C = C[SPECIES$1];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array$2 : C;
};

var arraySpeciesConstructor = arraySpeciesConstructor$1;

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate$1 = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};

var $$7 = _export;
var flattenIntoArray = flattenIntoArray_1;
var toObject$3 = toObject$8;
var lengthOfArrayLike$3 = lengthOfArrayLike$8;
var toIntegerOrInfinity$2 = toIntegerOrInfinity$5;
var arraySpeciesCreate = arraySpeciesCreate$1;

// `Array.prototype.flat` method
// https://tc39.es/ecma262/#sec-array.prototype.flat
$$7({ target: 'Array', proto: true }, {
  flat: function flat(/* depthArg = 1 */) {
    var depthArg = arguments.length ? arguments[0] : undefined;
    var O = toObject$3(this);
    var sourceLen = lengthOfArrayLike$3(O);
    var A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toIntegerOrInfinity$2(depthArg));
    return A;
  }
});

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables$1 = addToUnscopables$3;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('flat');

const MAX_REQUESTS$2 = 300;
const UserDataContext = /*#__PURE__*/createContext(null);
const UserDataProvider = ({
  fields,
  children
}) => {
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.events || !resources.api || !resources.config) throw new Error('Missing required resources {api, events, config}');
  const manager = userDataManager(resources, fields);
  return jsx(UserDataContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const useUserData = () => {
  const context = useContext(UserDataContext);
  if (context === undefined || context === null) {
    throw new Error('useUserData used outside of its Provider');
  }
  return context;
};
/**
 *
 * @param fields An array of fields to fetch for each user. Essentially a projection
 */
const userDataManager = ({
  api,
  events,
  config
}, fields) => {
  const [userList, setUserList] = useState(new Set());
  const [eventTracking, setEventTracking] = useState(new Set());
  const [dataTracking, setDataTracking] = useState(new Set());
  const [rawUserData, setRawUserData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const users = useMemo(() => rawUserData.reduce((result, userData) => {
    result[userData._id] = userData;
    return result;
  }, {}), [rawUserData]);
  useEffect(() => {
    const orgGroup = config === null || config === void 0 ? void 0 : config.orgGroup;
    const tracker = events.createTracker();
    const fetchData = user => __awaiter(void 0, void 0, void 0, function* () {
      try {
        setIsLoading(true);
        const responseData = yield api.org.users.data(user, fields);
        setRawUserData(prevRawUserData => prevRawUserData.map(userData => {
          if (userData._id === user) return responseData;
          return userData;
        }));
        setIsLoading(false);
      } catch (e) {
        Sentry.captureException(e);
        console.error(e);
        setIsLoading(false);
      }
    });
    const fetchAllData = usersToFetch => __awaiter(void 0, void 0, void 0, function* () {
      try {
        setIsLoading(true);
        const arrayOfUsers = Array.from(usersToFetch);
        const filtered = arrayOfUsers.filter(user => !dataTracking.has(user));
        const chunks = [];
        const total = filtered.length;
        let index = 0;
        while (index < total) {
          chunks.push(filtered.slice(index, index + MAX_REQUESTS$2));
          index += MAX_REQUESTS$2;
        }
        const chunkResponses = yield Promise.all(chunks.map(chunk => api.org.users.dataList(chunk)));
        setRawUserData(prevRawUserData => prevRawUserData.concat(chunkResponses.flat()));
        setDataTracking(prevDataTracking => new Set(Array.from(prevDataTracking).concat(Array.from(usersToFetch))));
        setIsLoading(false);
      } catch (e) {
        Sentry.captureException(e);
        console.error(e);
        setIsLoading(false);
      }
    });
    if (orgGroup) {
      userList.forEach(user => {
        if (!eventTracking.has(user)) {
          tracker.on(`mqtt:orggroup/${orgGroup}/u/${user}/settings`, () => fetchData(user));
          tracker.on(`mqtt:orggroup/${orgGroup}/u/${user}/careplan/patient/updated`, ({
            patientNumber
          }) => {
            setRawUserData(prevRawUserData => prevRawUserData.map(userData => {
              if (userData._id === user) return Object.assign(Object.assign({}, userData), {
                patientNumber
              });
              return userData;
            }));
          });
          tracker.on(`mqtt:orggroup/${orgGroup}/u/${user}/type/changed`, ({
            type
          }) => {
            setRawUserData(prevRawUserData => prevRawUserData.map(userData => {
              if (userData._id === user) return Object.assign(Object.assign({}, userData), {
                type
              });
              return userData;
            }));
          });
        }
      });
      setEventTracking(prevEventTracking => new Set(Array.from(prevEventTracking).concat(Array.from(userList))));
    }
    if (userList.size) fetchAllData(userList);
    return () => {
      setDataTracking(new Set());
      setEventTracking(new Set());
      tracker.off();
    };
  }, [api, config, events, userList]);
  const addUsers = usersToAdd => {
    if (!usersToAdd) throw new Error('No users provided');
    const add = [].concat(usersToAdd);
    setUserList(prevUserList => new Set(Array.from(prevUserList).concat(add)));
  };
  return {
    users,
    addUsers,
    isLoading
  };
};

const ConfigContext = /*#__PURE__*/createContext(null);
const useConfig = () => {
  const context = useContext(ConfigContext);
  if (context === undefined || context === null) throw new Error('Cannot useConfig outside of provider');
  return context;
};

/* eslint-disable @typescript-eslint/no-explicit-any */
const RoutesContext = /*#__PURE__*/createContext(null);
const useRoutes = () => {
  const context = useContext(RoutesContext);
  if (context === undefined || context === null) throw new Error('Cannot useRoutes outside of provider');
  return context;
};

var classof$3 = classof$7;

var $String = String;

var toString$a = function (argument) {
  if (classof$3(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};

var anObject$7 = anObject$i;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$7(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

var fails$9 = fails$o;
var global$7 = global$p;

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp$2 = global$7.RegExp;

var UNSUPPORTED_Y$2 = fails$9(function () {
  var re = $RegExp$2('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') !== null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY$1 = UNSUPPORTED_Y$2 || fails$9(function () {
  return !$RegExp$2('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y$2 || fails$9(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$2('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') !== null;
});

var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY$1,
  UNSUPPORTED_Y: UNSUPPORTED_Y$2
};

var fails$8 = fails$o;
var global$6 = global$p;

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = global$6.RegExp;

var regexpUnsupportedDotAll = fails$8(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.test('\n') && re.flags === 's');
});

var fails$7 = fails$o;
var global$5 = global$p;

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global$5.RegExp;

var regexpUnsupportedNcg = fails$7(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call$7 = functionCall;
var uncurryThis$b = functionUncurryThis;
var toString$9 = toString$a;
var regexpFlags = regexpFlags$1;
var stickyHelpers$1 = regexpStickyHelpers;
var shared = shared$4.exports;
var create$1 = objectCreate;
var getInternalState$1 = internalState.get;
var UNSUPPORTED_DOT_ALL$1 = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG$1 = regexpUnsupportedNcg;

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt$7 = uncurryThis$b(''.charAt);
var indexOf = uncurryThis$b(''.indexOf);
var replace$6 = uncurryThis$b(''.replace);
var stringSlice$7 = uncurryThis$b(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call$7(nativeExec, re1, 'a');
  call$7(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y$1 = stickyHelpers$1.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y$1 || UNSUPPORTED_DOT_ALL$1 || UNSUPPORTED_NCG$1;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState$1(re);
    var str = toString$9(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call$7(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y$1 && re.sticky;
    var flags = call$7(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace$6(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice$7(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$7(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call$7(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice$7(match.input, charsAdded);
        match[0] = stringSlice$7(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call$7(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create$1(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec$2 = patchedExec;

var $$6 = _export;
var exec$3 = regexpExec$2;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$$6({ target: 'RegExp', proto: true, forced: /./.exec !== exec$3 }, {
  exec: exec$3
});

// TODO: Remove from `core-js@4` since it's moved to entry points

var uncurryThis$a = functionUncurryThisClause;
var defineBuiltIn$5 = defineBuiltIn$b;
var regexpExec$1 = regexpExec$2;
var fails$6 = fails$o;
var wellKnownSymbol$6 = wellKnownSymbol$m;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$6;

var SPECIES = wellKnownSymbol$6('species');
var RegExpPrototype$3 = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol$6(KEY);

  var DELEGATES_TO_SYMBOL = !fails$6(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) !== 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$6(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () {
      execCalled = true;
      return null;
    };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = uncurryThis$a(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = uncurryThis$a(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec$1 || $exec === RegExpPrototype$3.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn$5(String.prototype, KEY, methods[0]);
    defineBuiltIn$5(RegExpPrototype$3, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty$1(RegExpPrototype$3[SYMBOL], 'sham', true);
};

var uncurryThis$9 = functionUncurryThis;
var toIntegerOrInfinity$1 = toIntegerOrInfinity$5;
var toString$8 = toString$a;
var requireObjectCoercible$4 = requireObjectCoercible$7;

var charAt$6 = uncurryThis$9(''.charAt);
var charCodeAt$1 = uncurryThis$9(''.charCodeAt);
var stringSlice$6 = uncurryThis$9(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString$8(requireObjectCoercible$4($this));
    var position = toIntegerOrInfinity$1(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt$1(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt$1(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt$6(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice$6(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};

var charAt$5 = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex$2 = function (S, index, unicode) {
  return index + (unicode ? charAt$5(S, index).length : 1);
};

var uncurryThis$8 = functionUncurryThis;
var toObject$2 = toObject$8;

var floor$3 = Math.floor;
var charAt$4 = uncurryThis$8(''.charAt);
var replace$5 = uncurryThis$8(''.replace);
var stringSlice$5 = uncurryThis$8(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var getSubstitution$1 = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject$2(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace$5(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt$4(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice$5(str, 0, position);
      case "'": return stringSlice$5(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice$5(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor$3(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt$4(ch, 1) : captures[f - 1] + charAt$4(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};

var call$6 = functionCall;
var anObject$6 = anObject$i;
var isCallable$4 = isCallable$p;
var classof$2 = classofRaw$2;
var regexpExec = regexpExec$2;

var $TypeError$2 = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable$4(exec)) {
    var result = call$6(exec, R, S);
    if (result !== null) anObject$6(result);
    return result;
  }
  if (classof$2(R) === 'RegExp') return call$6(regexpExec, R, S);
  throw new $TypeError$2('RegExp#exec called on incompatible receiver');
};

var apply = functionApply;
var call$5 = functionCall;
var uncurryThis$7 = functionUncurryThis;
var fixRegExpWellKnownSymbolLogic$2 = fixRegexpWellKnownSymbolLogic;
var fails$5 = fails$o;
var anObject$5 = anObject$i;
var isCallable$3 = isCallable$p;
var isNullOrUndefined$2 = isNullOrUndefined$7;
var toIntegerOrInfinity = toIntegerOrInfinity$5;
var toLength$1 = toLength$3;
var toString$7 = toString$a;
var requireObjectCoercible$3 = requireObjectCoercible$7;
var advanceStringIndex$1 = advanceStringIndex$2;
var getMethod$2 = getMethod$6;
var getSubstitution = getSubstitution$1;
var regExpExec$2 = regexpExecAbstract;
var wellKnownSymbol$5 = wellKnownSymbol$m;

var REPLACE = wellKnownSymbol$5('replace');
var max$1 = Math.max;
var min = Math.min;
var concat = uncurryThis$7([].concat);
var push$4 = uncurryThis$7([].push);
var stringIndexOf$2 = uncurryThis$7(''.indexOf);
var stringSlice$4 = uncurryThis$7(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails$5(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic$2('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible$3(this);
      var replacer = isNullOrUndefined$2(searchValue) ? undefined : getMethod$2(searchValue, REPLACE);
      return replacer
        ? call$5(replacer, searchValue, O, replaceValue)
        : call$5(nativeReplace, toString$7(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject$5(this);
      var S = toString$7(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf$2(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf$2(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable$3(replaceValue);
      if (!functionalReplace) replaceValue = toString$7(replaceValue);

      var global = rx.global;
      var fullUnicode;
      if (global) {
        fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }

      var results = [];
      var result;
      while (true) {
        result = regExpExec$2(rx, S);
        if (result === null) break;

        push$4(results, result);
        if (!global) break;

        var matchStr = toString$7(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex$1(S, toLength$1(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString$7(result[0]);
        var position = max$1(min(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        var replacement;
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push$4(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push$4(replacerArgs, namedCaptures);
          replacement = toString$7(apply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice$4(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }

      return accumulatedResult + stringSlice$4(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

var $$5 = _export;
var $includes = arrayIncludes.includes;
var fails$4 = fails$o;
var addToUnscopables = addToUnscopables$3;

// FF99+ bug
var BROKEN_ON_SPARSE = fails$4(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$$5({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');

var isObject$2 = isObject$c;
var classof$1 = classofRaw$2;
var wellKnownSymbol$4 = wellKnownSymbol$m;

var MATCH$2 = wellKnownSymbol$4('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject$2(it) && ((isRegExp = it[MATCH$2]) !== undefined ? !!isRegExp : classof$1(it) === 'RegExp');
};

var isRegExp$1 = isRegexp;

var $TypeError$1 = TypeError;

var notARegexp = function (it) {
  if (isRegExp$1(it)) {
    throw new $TypeError$1("The method doesn't accept regular expressions");
  } return it;
};

var wellKnownSymbol$3 = wellKnownSymbol$m;

var MATCH$1 = wellKnownSymbol$3('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH$1] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var $$4 = _export;
var uncurryThis$6 = functionUncurryThis;
var notARegExp = notARegexp;
var requireObjectCoercible$2 = requireObjectCoercible$7;
var toString$6 = toString$a;
var correctIsRegExpLogic = correctIsRegexpLogic;

var stringIndexOf$1 = uncurryThis$6(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$$4({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf$1(
      toString$6(requireObjectCoercible$2(this)),
      toString$6(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
var sameValue$1 = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x !== x && y !== y;
};

var call$4 = functionCall;
var fixRegExpWellKnownSymbolLogic$1 = fixRegexpWellKnownSymbolLogic;
var anObject$4 = anObject$i;
var isNullOrUndefined$1 = isNullOrUndefined$7;
var requireObjectCoercible$1 = requireObjectCoercible$7;
var sameValue = sameValue$1;
var toString$5 = toString$a;
var getMethod$1 = getMethod$6;
var regExpExec$1 = regexpExecAbstract;

// @@search logic
fixRegExpWellKnownSymbolLogic$1('search', function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible$1(this);
      var searcher = isNullOrUndefined$1(regexp) ? undefined : getMethod$1(regexp, SEARCH);
      return searcher ? call$4(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString$5(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (string) {
      var rx = anObject$4(this);
      var S = toString$5(string);
      var res = maybeCallNative(nativeSearch, rx, S);

      if (res.done) return res.value;

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec$1(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});

const PatientsContext = /*#__PURE__*/createContext(null);
const PatientsProvider = ({
  children
}) => {
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.api || !resources.events) throw new Error('Missing required resources {api, events, config}');
  const manager = patientsManager(resources);
  return jsx(PatientsContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const usePatients = () => {
  const context = useContext(PatientsContext);
  if (context === undefined || context === null) {
    throw new Error('usePatients used outside of its Provider');
  }
  return context;
};
const patientsManager = ({
  api,
  events,
  config
}) => {
  const [users, setUsers] = useState([]);
  useState([]);
  const [apiResponse, setApiResponse] = useState({
    status: 0,
    message: '',
    serverity: 'success',
    open: false
  });
  const [requestQuery, setRequestQuery] = useState({
    manageGroup: [],
    kitStates: [],
    patientStatus: [],
    page: 0,
    userStates: ['all_active'],
    query: ''
  });
  const [isLoading, setIsLoading] = useState(true);
  const builtQuery = useMemo(() => {
    let result = {};
    const {
      query,
      manageGroup,
      kitStates,
      patientStatus,
      userStates,
      page
    } = requestQuery;
    if (query) {
      const cleanQueryWithNoSpaces = query.replace(/\s/g, '');
      result = Object.assign(Object.assign({}, result), {
        $or: [{
          search: {
            $regex: cleanQueryWithNoSpaces,
            $options: 'i'
          }
        }, {
          searchr: {
            $regex: cleanQueryWithNoSpaces,
            $options: 'i'
          }
        }, {
          fname: {
            $regex: cleanQueryWithNoSpaces,
            $options: 'i'
          }
        }, {
          lname: {
            $regex: query,
            $options: 'i'
          }
        }, {
          healthCardNumber: {
            $regex: cleanQueryWithNoSpaces,
            $options: 'i'
          }
        }, {
          patientNumber: {
            $regex: cleanQueryWithNoSpaces,
            $options: 'i'
          }
        }]
      });
    }
    if (userStates.length > 0) {
      const hasAllActive = userStates.includes('all_active');
      const hasInActive = userStates.includes('inactive');
      let stateFilter = {};
      if (hasAllActive && !hasInActive) {
        stateFilter = {
          state: 'active'
        };
      } else if (hasAllActive && hasInActive) {
        stateFilter = {};
      } else {
        stateFilter = {
          state: {
            $in: userStates
          }
        };
      }
      result = Object.assign(Object.assign({}, result), stateFilter);
    }
    if (manageGroup.length > 0) {
      result = Object.assign(Object.assign({}, result), {
        manage_group: manageGroup
      });
    }
    if (patientStatus.length > 0) {
      result = Object.assign(Object.assign({}, result), {
        current_status: patientStatus
      });
    }
    if (kitStates.length > 0) {
      result['kit.state'] = kitStates;
    }
    return {
      query: result,
      page
    };
  }, [requestQuery]);
  useEffect(() => {
    const getPatients = () => __awaiter(void 0, void 0, void 0, function* () {
      try {
        setIsLoading(true);
        const usersResponse = yield api.org.users.patients('', builtQuery.query, {
          page: builtQuery.page,
          sort: {
            sortName: 1
          }
        });
        setIsLoading(false);
        setUsers(prevUsers => prevUsers.concat(usersResponse));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (e) {
        Sentry.captureException(e);
        console.error(e);
        setApiResponse({
          status: e.status || 500,
          message: e.response ? e.response.message : 'Error',
          open: true,
          serverity: 'error'
        });
        setIsLoading(false);
      }
    });
    getPatients();
  }, [builtQuery, api]);
  useEffect(() => {
    const tracker = events.createTracker();
    if (!(config === null || config === void 0 ? void 0 : config.orgGroup)) return;
    tracker.on(`mqtt:orggroup/${config.orgGroup}/users/added`, ({
      who
    }) => getPatient(who));
    tracker.on(`mqtt:orggroup/${config.orgGroup}/users/removed`, ({
      who
    }) => {
      setUsers(prevUsers => prevUsers.filter(user => who !== user._id));
    });
    const getPatient = id => __awaiter(void 0, void 0, void 0, function* () {
      try {
        setIsLoading(true);
        const response = yield api.org.users.patients('', {
          _id: id
        }, {
          page: 0
        });
        setIsLoading(false);
        if (response) {
          setUsers(prevUsers => [response[0]].concat(prevUsers));
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (e) {
        Sentry.captureException(e);
        console.error(e);
        setApiResponse({
          status: e.status || 500,
          message: e.response ? e.response.message : 'Error',
          open: true,
          serverity: 'error'
        });
      }
    });
    return () => {
      tracker.off();
    };
  }, [events, config]);
  useEffect(() => {
    const tracker = events.createTracker();
    if (!(config === null || config === void 0 ? void 0 : config.orgGroup)) return;
    users.forEach(user => {
      var _a;
      tracker.on(`mqtt:orggroup/${config.orgGroup}/u/${user._id}/settings`, settings => {
        setUsers(prevUsers => prevUsers.map(u => {
          if (u._id === user._id) {
            return Object.assign(Object.assign({}, u), settings);
          }
          return u;
        }));
      });
      tracker.on(`mqtt:orggroup/${config.orgGroup}/u/${user._id}/careplan/patient/updated`, ({
        patientNumber
      }) => {
        setUsers(prevUsers => prevUsers.map(u => {
          if (u._id === user._id) {
            return Object.assign(Object.assign({}, u), {
              patientNumber
            });
          }
          return u;
        }));
      });
      tracker.on(`mqtt:orggroup/${config.orgGroup}/u/${user._id}/type/changed`, ({
        type
      }) => {
        setUsers(prevUsers => prevUsers.map(u => {
          if (u._id === user._id) {
            return Object.assign(Object.assign({}, u), {
              type
            });
          }
          return u;
        }));
      });
      tracker.on(`mqtt:orggroup/${config.orgGroup}/u/${user._id}/state/updated`, ({
        state,
        reason
      }) => {
        setUsers(prevUsers => prevUsers.map(u => {
          if (u._id === user._id) {
            return Object.assign(Object.assign({}, u), {
              state,
              reason
            });
          }
          return u;
        }));
      });
      tracker.on(`mqtt:kit/assignment/${(_a = user.kit_assignment) === null || _a === void 0 ? void 0 : _a._id}/request`, () => updatePatient(user._id));
      tracker.on(`mqtt:orggroup/${config.orgGroup}/u/${user._id}/kit/state`, () => updatePatient(user._id));
      tracker.on(`mqtt:orggroup/${config.orgGroup}/u/${user._id}/kit/assignment/request`, () => updatePatient(user._id));
      tracker.on(`mqtt:orggroup/${config.orgGroup}/u/${user._id}/kit/assignment/update`, () => updatePatient(user._id));
      tracker.on(`mqtt:orggroup/${config.orgGroup}/u/${user._id}/kit/assignment/cancel`, () => updatePatient(user._id));
    });
    const updatePatient = id => __awaiter(void 0, void 0, void 0, function* () {
      try {
        setIsLoading(true);
        const response = yield api.org.users.patients('', {
          _id: id
        }, {
          page: 0
        });
        setIsLoading(false);
        if (response) {
          setUsers(prevUsers => {
            const index = prevUsers.findIndex(user => user._id === id);
            if (index > -1) {
              prevUsers[index] = response[0];
            }
            return [...prevUsers];
          });
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (e) {
        Sentry.captureException(e);
        console.error(e);
        setApiResponse({
          status: e.status || 500,
          message: e.response ? e.response.message : 'Error',
          open: true,
          serverity: 'error'
        });
      }
    });
    return () => {
      tracker.off();
    };
  }, [api, users, events]);
  const setManageGroupFilter = newManageGroup => {
    setUsers([]);
    setRequestQuery(prevQuery => Object.assign(Object.assign({}, prevQuery), {
      manageGroup: Array().concat(newManageGroup),
      page: 0
    }));
  };
  const setQueryFilter = newQueryFilter => {
    setUsers([]);
    setRequestQuery(prevQuery => Object.assign(Object.assign({}, prevQuery), {
      query: newQueryFilter,
      page: 0
    }));
  };
  const setUserStateFilter = newUserState => {
    setUsers([]);
    setRequestQuery(prevQuery => Object.assign(Object.assign({}, prevQuery), {
      userStates: Array().concat(newUserState),
      page: 0
    }));
  };
  const setKitStatesFilter = newKitState => {
    setUsers([]);
    setRequestQuery(prevQuery => Object.assign(Object.assign({}, prevQuery), {
      kitStates: Array().concat(newKitState),
      page: 0
    }));
  };
  const setPatientStatusFilter = patientStatus => {
    setUsers([]);
    setRequestQuery(prevQuery => Object.assign(Object.assign({}, prevQuery), {
      patientStatus: Array().concat(patientStatus),
      page: 0
    }));
  };
  const resetApiResponse = () => {
    setApiResponse({
      status: 0,
      message: '',
      serverity: 'error',
      open: false
    });
  };
  const fetchToken = useCallback(id => {
    return getToken(id);
    function getToken(id) {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          return yield api.org.users.token(id);
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
          setApiResponse({
            status: e.status || 500,
            message: e.response ? e.response.message : 'Error',
            open: true,
            serverity: 'error'
          });
        }
      });
    }
  }, [api]);
  const testMode = useCallback((id, enable) => {
    return test(id, enable);
    function test(id, enable) {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          if (enable) return yield api.org.users.testmode.enable(id);else return yield api.org.users.testmode.disable(id);
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
          setApiResponse({
            status: e.status || 500,
            message: e.response ? e.response.message : 'Error',
            open: true,
            serverity: 'error'
          });
        }
      });
    }
  }, [api]);
  const bulkTestMode = useCallback((ids, enable) => {
    return bulkTest(ids, enable);
    function bulkTest(ids, enable) {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          if (enable) yield api.org.users.testmode.enableBulk(ids);else yield api.org.users.testmode.disableBulk(ids);
          setApiResponse({
            status: 200,
            message: 'toast.testmode',
            serverity: 'success',
            open: true
          });
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
          setApiResponse({
            status: e.status || 500,
            message: e.response ? e.response.message : 'Error',
            open: true,
            serverity: 'error'
          });
        }
      });
    }
  }, [api]);
  const updatePatientState = useCallback((userId, newState, reason) => {
    return updatePatientState(userId, newState, reason);
    function updatePatientState(userId, newState, reason) {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          yield api.org.users.patientState(userId, newState, reason);
          setApiResponse({
            status: 200,
            message: 'toast.stateUpdate',
            serverity: 'success',
            open: true
          });
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
          setApiResponse({
            status: e.status || 500,
            message: e.response ? e.response.message : 'Error',
            open: true,
            serverity: 'error'
          });
        }
      });
    }
  }, [api]);
  const updatePatientStateBulk = useCallback((userIds, newState, reason) => {
    return updatePatientStateBulk(userIds, newState, reason);
    function updatePatientStateBulk(userIds, newState, reason) {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          yield api.org.users.patientStateBulk(userIds, newState, reason);
          setApiResponse({
            status: 200,
            message: 'toast.stateUpdates',
            serverity: 'success',
            open: true
          });
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
          setApiResponse({
            status: e.status || 500,
            message: e.response ? e.response.message : 'Error',
            open: true,
            serverity: 'error'
          });
        }
      });
    }
  }, [api]);
  const createUser = useCallback((data, createPatientNumber) => {
    if (createPatientNumber) {
      return createWithNumber(data, createPatientNumber);
    } else {
      return create(data);
    }
    function create(data) {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          if (data.user_type === 'aTouchAway') {
            yield api.org.users.create(null, null, null, null, null, null, data);
          } else if (data.user_type === 'Mobile') yield api.org.users.createMobile(null, null, null, null, null, null, data);else if (data.user_type === 'Simplified') yield api.org.users.createSimplified(null, null, null, null, null, null, data);
          setApiResponse({
            status: 200,
            message: 'toast.accountCreated',
            open: true,
            serverity: 'success'
          });
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
          setApiResponse({
            status: e.status || 500,
            message: e.response ? e.response.message : 'Error',
            open: true,
            serverity: 'error'
          });
        }
      });
    }
    function createWithNumber(data, patientNumber) {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          let res;
          if (data.user_type === 'aTouchAway') {
            res = yield api.org.users.create(null, null, null, null, null, null, data);
          } else if (data.user_type === 'Mobile') {
            res = yield api.org.users.createMobile(null, null, null, null, null, null, data);
          } else if (data.user_type === 'Simplified') {
            res = yield api.org.users.createSimplified(null, null, null, null, null, null, data);
          }
          if (res !== undefined) {
            const user_id = res === null || res === void 0 ? void 0 : res.id;
            yield api.org.users.careplan.number.update(user_id, patientNumber);
          }
          setApiResponse({
            status: 200,
            message: "User's account created successfully",
            serverity: 'success',
            open: true
          });
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
          setApiResponse({
            status: e.status || 500,
            message: e.response ? e.response.message : 'Error',
            open: true,
            serverity: 'error'
          });
        }
      });
    }
  }, [api]);
  const inviteUser = useCallback(data => {
    return invite(data);
    function invite({
      email,
      managers,
      fname,
      lname,
      patientNumber,
      manageGroup,
      language
    }) {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          yield api.org.users.invitation.send(email, managers, fname, lname, patientNumber, manageGroup, language);
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
          setApiResponse({
            status: e.status || 500,
            message: e.response ? e.response.message : 'Error',
            open: true,
            serverity: 'error'
          });
        }
      });
    }
  }, [api]);
  const updateUser = useCallback((id, data) => {
    return update(id, data);
    function update(id, data) {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          yield api.org.users.patient.update(id, data);
          setApiResponse({
            status: 200,
            message: 'toast.accountUpdated',
            open: true,
            serverity: 'success'
          });
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
          setApiResponse({
            status: e.status || 500,
            message: e.response ? e.response.message : 'Error',
            open: true,
            serverity: 'error'
          });
        }
      });
    }
  }, [api, users]);
  const removeUser = useCallback(id => {
    return remove(id);
    function remove(id) {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          yield api.org.users.remove(id);
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
          setApiResponse({
            status: e.status || 500,
            message: e.response ? e.response.message : 'Error',
            open: true,
            serverity: 'error'
          });
        }
      });
    }
  }, [api]);
  const anonymousId = id => id.slice(0, 4) + id.slice(-4);
  const nextPage = useCallback(() => {
    setRequestQuery(prevQuery => Object.assign(Object.assign({}, prevQuery), {
      page: prevQuery.page + 1
    }));
  }, []);
  const emr = useCallback(query => {
    return getEMR(query);
    function getEMR(query) {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          return yield api.org.users.emr(query);
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
          setApiResponse({
            status: e.status || 500,
            message: e.response ? e.response.message : 'Error',
            open: true,
            serverity: 'error'
          });
        }
      });
    }
  }, [api]);
  const searchPeople = useCallback((query, filter) => {
    return getPeople(query);
    function getPeople(query) {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          return yield api.people.search(query, filter);
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
          setApiResponse({
            status: e.status || 500,
            message: e.response ? e.response.message : 'Error',
            open: true,
            serverity: 'error'
          });
        }
      });
    }
  }, [api]);
  const updateInactive = useCallback((user, inactive, removeManagers, stopWorkflows, removeContacts) => {
    return update(user, inactive, removeManagers, stopWorkflows, removeContacts);
    function update(user, inactive, removeManagers, stopWorkflows, removeContacts) {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          const id = yield api.org.users.inactive.update(user, inactive, removeManagers, stopWorkflows, removeContacts);
          setApiResponse({
            status: 200,
            message: 'toast.stateUpdateSuccess',
            open: true,
            serverity: 'success'
          });
          return id;
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
          setApiResponse({
            status: e.status || 500,
            message: e.response ? e.response.message : 'Error',
            open: true,
            serverity: 'error'
          });
        }
      });
    }
  }, [api]);
  return {
    users,
    userStates: requestQuery.userStates,
    kitStates: requestQuery.kitStates,
    patientStatus: requestQuery.patientStatus,
    manageGroup: requestQuery.manageGroup,
    isLoading: isLoading,
    apiResponse: apiResponse,
    nextPage,
    setManageGroupFilter,
    setQueryFilter,
    setUserStateFilter,
    setKitStatesFilter,
    setPatientStatusFilter,
    fetchToken,
    emr,
    searchPeople,
    testMode,
    bulkTestMode,
    removeUser,
    anonymousId,
    createUser,
    inviteUser,
    updateUser,
    updateInactive,
    updatePatientState,
    updatePatientStateBulk,
    resetApiResponse,
    setApiResponse
  };
};

const useIntersectObserver = (ref, callback, options) => {
  const _a = options || {},
    {
      isLoading
    } = _a,
    observerOptions = __rest(_a, ["isLoading"]);
  const handleObserver = useCallback(entries => {
    const target = entries[0];
    if (target.isIntersecting && !isLoading) callback();
  }, [isLoading, callback]);
  useEffect(() => {
    const observer = new IntersectionObserver(handleObserver, observerOptions);
    if (ref.current) observer.observe(ref.current);
  }, [handleObserver]);
  return {};
};

var charAt$3 = stringMultibyte.charAt;
var toString$4 = toString$a;
var InternalStateModule$2 = internalState;
var defineIterator = iteratorDefine;
var createIterResultObject$1 = createIterResultObject$3;

var STRING_ITERATOR = 'String Iterator';
var setInternalState$2 = InternalStateModule$2.set;
var getInternalState = InternalStateModule$2.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState$2(this, {
    type: STRING_ITERATOR,
    string: toString$4(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return createIterResultObject$1(undefined, true);
  point = charAt$3(string, index);
  state.index += point.length;
  return createIterResultObject$1(point, false);
});

var fails$3 = fails$o;
var wellKnownSymbol$2 = wellKnownSymbol$m;
var DESCRIPTORS$4 = descriptors;
var IS_PURE = isPure;

var ITERATOR$1 = wellKnownSymbol$2('iterator');

var urlConstructorDetection = !fails$3(function () {
  // eslint-disable-next-line unicorn/relative-url-style -- required for testing
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var params = url.searchParams;
  var params2 = new URLSearchParams('a=1&a=2&b=3');
  var result = '';
  url.pathname = 'c%20d';
  params.forEach(function (value, key) {
    params['delete']('b');
    result += key + value;
  });
  params2['delete']('a', 2);
  // `undefined` case is a Chromium 117 bug
  // https://bugs.chromium.org/p/v8/issues/detail?id=14222
  params2['delete']('b', undefined);
  return (IS_PURE && (!url.toJSON || !params2.has('a', 1) || params2.has('a', 2) || !params2.has('a', undefined) || params2.has('b')))
    || (!params.size && (IS_PURE || !DESCRIPTORS$4))
    || !params.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || params.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !params[ITERATOR$1]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});

var anObject$3 = anObject$i;
var iteratorClose = iteratorClose$2;

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing$1 = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject$3(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};

var toPropertyKey = toPropertyKey$3;
var definePropertyModule = objectDefineProperty;
var createPropertyDescriptor$1 = createPropertyDescriptor$5;

var createProperty$2 = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor$1(0, value));
  else object[propertyKey] = value;
};

var bind$2 = functionBindContext;
var call$3 = functionCall;
var toObject$1 = toObject$8;
var callWithSafeIterationClosing = callWithSafeIterationClosing$1;
var isArrayIteratorMethod = isArrayIteratorMethod$2;
var isConstructor = isConstructor$3;
var lengthOfArrayLike$2 = lengthOfArrayLike$8;
var createProperty$1 = createProperty$2;
var getIterator$1 = getIterator$3;
var getIteratorMethod$1 = getIteratorMethod$4;

var $Array$1 = Array;

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
var arrayFrom$1 = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject$1(arrayLike);
  var IS_CONSTRUCTOR = isConstructor(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = bind$2(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
  var iteratorMethod = getIteratorMethod$1(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod && !(this === $Array$1 && isArrayIteratorMethod(iteratorMethod))) {
    iterator = getIterator$1(O, iteratorMethod);
    next = iterator.next;
    result = IS_CONSTRUCTOR ? new this() : [];
    for (;!(step = call$3(next, iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty$1(result, index, value);
    }
  } else {
    length = lengthOfArrayLike$2(O);
    result = IS_CONSTRUCTOR ? new this(length) : $Array$1(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty$1(result, index, value);
    }
  }
  result.length = index;
  return result;
};

var toAbsoluteIndex = toAbsoluteIndex$2;
var lengthOfArrayLike$1 = lengthOfArrayLike$8;
var createProperty = createProperty$2;

var $Array = Array;
var max = Math.max;

var arraySliceSimple = function (O, start, end) {
  var length = lengthOfArrayLike$1(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = $Array(max(fin - k, 0));
  var n = 0;
  for (; k < fin; k++, n++) createProperty(result, n, O[k]);
  result.length = n;
  return result;
};

// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js
var uncurryThis$5 = functionUncurryThis;

var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'
var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var baseMinusTMin = base - tMin;

var $RangeError = RangeError;
var exec$2 = uncurryThis$5(regexSeparators.exec);
var floor$2 = Math.floor;
var fromCharCode = String.fromCharCode;
var charCodeAt = uncurryThis$5(''.charCodeAt);
var join$2 = uncurryThis$5([].join);
var push$3 = uncurryThis$5([].push);
var replace$4 = uncurryThis$5(''.replace);
var split$2 = uncurryThis$5(''.split);
var toLowerCase$1 = uncurryThis$5(''.toLowerCase);

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */
var ucs2decode = function (string) {
  var output = [];
  var counter = 0;
  var length = string.length;
  while (counter < length) {
    var value = charCodeAt(string, counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = charCodeAt(string, counter++);
      if ((extra & 0xFC00) === 0xDC00) { // Low surrogate.
        push$3(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        push$3(output, value);
        counter--;
      }
    } else {
      push$3(output, value);
    }
  }
  return output;
};

/**
 * Converts a digit/integer into a basic code point.
 */
var digitToBasic = function (digit) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */
var adapt = function (delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor$2(delta / damp) : delta >> 1;
  delta += floor$2(delta / numPoints);
  while (delta > baseMinusTMin * tMax >> 1) {
    delta = floor$2(delta / baseMinusTMin);
    k += base;
  }
  return floor$2(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */
var encode = function (input) {
  var output = [];

  // Convert the input in UCS-2 to an array of Unicode code points.
  input = ucs2decode(input);

  // Cache the length.
  var inputLength = input.length;

  // Initialize the state.
  var n = initialN;
  var delta = 0;
  var bias = initialBias;
  var i, currentValue;

  // Handle the basic code points.
  for (i = 0; i < input.length; i++) {
    currentValue = input[i];
    if (currentValue < 0x80) {
      push$3(output, fromCharCode(currentValue));
    }
  }

  var basicLength = output.length; // number of basic code points.
  var handledCPCount = basicLength; // number of code points that have been handled;

  // Finish the basic string with a delimiter unless it's empty.
  if (basicLength) {
    push$3(output, delimiter);
  }

  // Main encoding loop:
  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next larger one:
    var m = maxInt;
    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    }

    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
    var handledCPCountPlusOne = handledCPCount + 1;
    if (m - n > floor$2((maxInt - delta) / handledCPCountPlusOne)) {
      throw new $RangeError(OVERFLOW_ERROR);
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue < n && ++delta > maxInt) {
        throw new $RangeError(OVERFLOW_ERROR);
      }
      if (currentValue === n) {
        // Represent delta as a generalized variable-length integer.
        var q = delta;
        var k = base;
        while (true) {
          var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
          if (q < t) break;
          var qMinusT = q - t;
          var baseMinusT = base - t;
          push$3(output, fromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
          q = floor$2(qMinusT / baseMinusT);
          k += base;
        }

        push$3(output, fromCharCode(digitToBasic(q)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
        delta = 0;
        handledCPCount++;
      }
    }

    delta++;
    n++;
  }
  return join$2(output, '');
};

var stringPunycodeToAscii = function (input) {
  var encoded = [];
  var labels = split$2(replace$4(toLowerCase$1(input), regexSeparators, '\u002E'), '.');
  var i, label;
  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    push$3(encoded, exec$2(regexNonASCII, label) ? 'xn--' + encode(label) : label);
  }
  return join$2(encoded, '.');
};

var defineBuiltIn$4 = defineBuiltIn$b;

var defineBuiltIns$1 = function (target, src, options) {
  for (var key in src) defineBuiltIn$4(target, key, src[key], options);
  return target;
};

var arraySlice$1 = arraySliceSimple;

var floor$1 = Math.floor;

var mergeSort = function (array, comparefn) {
  var length = array.length;
  var middle = floor$1(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge(
    array,
    mergeSort(arraySlice$1(array, 0, middle), comparefn),
    mergeSort(arraySlice$1(array, middle), comparefn),
    comparefn
  );
};

var insertionSort = function (array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];
    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }
    if (j !== i++) array[j] = element;
  } return array;
};

var merge = function (array, left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;

  while (lindex < llength || rindex < rlength) {
    array[lindex + rindex] = (lindex < llength && rindex < rlength)
      ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
      : lindex < llength ? left[lindex++] : right[rindex++];
  } return array;
};

var arraySort$1 = mergeSort;

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`

var $$3 = _export;
var global$4 = global$p;
var call$2 = functionCall;
var uncurryThis$4 = functionUncurryThis;
var DESCRIPTORS$3 = descriptors;
var USE_NATIVE_URL$1 = urlConstructorDetection;
var defineBuiltIn$3 = defineBuiltIn$b;
var defineBuiltInAccessor$2 = defineBuiltInAccessor$4;
var defineBuiltIns = defineBuiltIns$1;
var setToStringTag$1 = setToStringTag$5;
var createIteratorConstructor = iteratorCreateConstructor;
var InternalStateModule$1 = internalState;
var anInstance$1 = anInstance$3;
var isCallable$2 = isCallable$p;
var hasOwn$4 = hasOwnProperty_1;
var bind$1 = functionBindContext;
var classof = classof$7;
var anObject$2 = anObject$i;
var isObject$1 = isObject$c;
var $toString$2 = toString$a;
var create = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$5;
var getIterator = getIterator$3;
var getIteratorMethod = getIteratorMethod$4;
var createIterResultObject = createIterResultObject$3;
var validateArgumentsLength$1 = validateArgumentsLength$3;
var wellKnownSymbol$1 = wellKnownSymbol$m;
var arraySort = arraySort$1;

var ITERATOR = wellKnownSymbol$1('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState$1 = InternalStateModule$1.set;
var getInternalParamsState = InternalStateModule$1.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule$1.getterFor(URL_SEARCH_PARAMS_ITERATOR);
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Avoid NodeJS experimental warning
var safeGetBuiltIn = function (name) {
  if (!DESCRIPTORS$3) return global$4[name];
  var descriptor = getOwnPropertyDescriptor(global$4, name);
  return descriptor && descriptor.value;
};

var nativeFetch = safeGetBuiltIn('fetch');
var NativeRequest = safeGetBuiltIn('Request');
var Headers = safeGetBuiltIn('Headers');
var RequestPrototype = NativeRequest && NativeRequest.prototype;
var HeadersPrototype = Headers && Headers.prototype;
var RegExp$1 = global$4.RegExp;
var TypeError$2 = global$4.TypeError;
var decodeURIComponent = global$4.decodeURIComponent;
var encodeURIComponent$1 = global$4.encodeURIComponent;
var charAt$2 = uncurryThis$4(''.charAt);
var join$1 = uncurryThis$4([].join);
var push$2 = uncurryThis$4([].push);
var replace$3 = uncurryThis$4(''.replace);
var shift$1 = uncurryThis$4([].shift);
var splice = uncurryThis$4([].splice);
var split$1 = uncurryThis$4(''.split);
var stringSlice$3 = uncurryThis$4(''.slice);

var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function (bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp$1('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function (sequence) {
  try {
    return decodeURIComponent(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function (it) {
  var result = replace$3(it, plus, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent(result);
  } catch (error) {
    while (bytes) {
      result = replace$3(result, percentSequence(bytes--), percentDecode);
    }
    return result;
  }
};

var find = /[!'()~]|%20/g;

var replacements = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replacements[match];
};

var serialize = function (it) {
  return replace$3(encodeURIComponent$1(it), find, replacer);
};

var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState$1(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    target: getInternalParamsState(params).entries,
    index: 0,
    kind: kind
  });
}, URL_SEARCH_PARAMS, function next() {
  var state = getInternalIteratorState(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  var entry = target[index];
  switch (state.kind) {
    case 'keys': return createIterResultObject(entry.key, false);
    case 'values': return createIterResultObject(entry.value, false);
  } return createIterResultObject([entry.key, entry.value], false);
}, true);

var URLSearchParamsState = function (init) {
  this.entries = [];
  this.url = null;

  if (init !== undefined) {
    if (isObject$1(init)) this.parseObject(init);
    else this.parseQuery(typeof init == 'string' ? charAt$2(init, 0) === '?' ? stringSlice$3(init, 1) : init : $toString$2(init));
  }
};

URLSearchParamsState.prototype = {
  type: URL_SEARCH_PARAMS,
  bindURL: function (url) {
    this.url = url;
    this.update();
  },
  parseObject: function (object) {
    var entries = this.entries;
    var iteratorMethod = getIteratorMethod(object);
    var iterator, next, step, entryIterator, entryNext, first, second;

    if (iteratorMethod) {
      iterator = getIterator(object, iteratorMethod);
      next = iterator.next;
      while (!(step = call$2(next, iterator)).done) {
        entryIterator = getIterator(anObject$2(step.value));
        entryNext = entryIterator.next;
        if (
          (first = call$2(entryNext, entryIterator)).done ||
          (second = call$2(entryNext, entryIterator)).done ||
          !call$2(entryNext, entryIterator).done
        ) throw new TypeError$2('Expected sequence with length 2');
        push$2(entries, { key: $toString$2(first.value), value: $toString$2(second.value) });
      }
    } else for (var key in object) if (hasOwn$4(object, key)) {
      push$2(entries, { key: key, value: $toString$2(object[key]) });
    }
  },
  parseQuery: function (query) {
    if (query) {
      var entries = this.entries;
      var attributes = split$1(query, '&');
      var index = 0;
      var attribute, entry;
      while (index < attributes.length) {
        attribute = attributes[index++];
        if (attribute.length) {
          entry = split$1(attribute, '=');
          push$2(entries, {
            key: deserialize(shift$1(entry)),
            value: deserialize(join$1(entry, '='))
          });
        }
      }
    }
  },
  serialize: function () {
    var entries = this.entries;
    var result = [];
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      push$2(result, serialize(entry.key) + '=' + serialize(entry.value));
    } return join$1(result, '&');
  },
  update: function () {
    this.entries.length = 0;
    this.parseQuery(this.url.query);
  },
  updateURL: function () {
    if (this.url) this.url.update();
  }
};

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance$1(this, URLSearchParamsPrototype);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  var state = setInternalState$1(this, new URLSearchParamsState(init));
  if (!DESCRIPTORS$3) this.size = state.entries.length;
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

defineBuiltIns(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    var state = getInternalParamsState(this);
    validateArgumentsLength$1(arguments.length, 2);
    push$2(state.entries, { key: $toString$2(name), value: $toString$2(value) });
    if (!DESCRIPTORS$3) this.length++;
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name /* , value */) {
    var state = getInternalParamsState(this);
    var length = validateArgumentsLength$1(arguments.length, 1);
    var entries = state.entries;
    var key = $toString$2(name);
    var $value = length < 2 ? undefined : arguments[1];
    var value = $value === undefined ? $value : $toString$2($value);
    var index = 0;
    while (index < entries.length) {
      var entry = entries[index];
      if (entry.key === key && (value === undefined || entry.value === value)) {
        splice(entries, index, 1);
        if (value !== undefined) break;
      } else index++;
    }
    if (!DESCRIPTORS$3) this.size = entries.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    var entries = getInternalParamsState(this).entries;
    validateArgumentsLength$1(arguments.length, 1);
    var key = $toString$2(name);
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    var entries = getInternalParamsState(this).entries;
    validateArgumentsLength$1(arguments.length, 1);
    var key = $toString$2(name);
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) push$2(result, entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name /* , value */) {
    var entries = getInternalParamsState(this).entries;
    var length = validateArgumentsLength$1(arguments.length, 1);
    var key = $toString$2(name);
    var $value = length < 2 ? undefined : arguments[1];
    var value = $value === undefined ? $value : $toString$2($value);
    var index = 0;
    while (index < entries.length) {
      var entry = entries[index++];
      if (entry.key === key && (value === undefined || entry.value === value)) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    var state = getInternalParamsState(this);
    validateArgumentsLength$1(arguments.length, 1);
    var entries = state.entries;
    var found = false;
    var key = $toString$2(name);
    var val = $toString$2(value);
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) splice(entries, index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) push$2(entries, { key: key, value: val });
    if (!DESCRIPTORS$3) this.size = entries.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    arraySort(state.entries, function (a, b) {
      return a.key > b.key ? 1 : -1;
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bind$1(callback, arguments.length > 1 ? arguments[1] : undefined);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
defineBuiltIn$3(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries, { name: 'entries' });

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
defineBuiltIn$3(URLSearchParamsPrototype, 'toString', function toString() {
  return getInternalParamsState(this).serialize();
}, { enumerable: true });

// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if (DESCRIPTORS$3) defineBuiltInAccessor$2(URLSearchParamsPrototype, 'size', {
  get: function size() {
    return getInternalParamsState(this).entries.length;
  },
  configurable: true,
  enumerable: true
});

setToStringTag$1(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

$$3({ global: true, constructor: true, forced: !USE_NATIVE_URL$1 }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!USE_NATIVE_URL$1 && isCallable$2(Headers)) {
  var headersHas = uncurryThis$4(HeadersPrototype.has);
  var headersSet = uncurryThis$4(HeadersPrototype.set);

  var wrapRequestOptions = function (init) {
    if (isObject$1(init)) {
      var body = init.body;
      var headers;
      if (classof(body) === URL_SEARCH_PARAMS) {
        headers = init.headers ? new Headers(init.headers) : new Headers();
        if (!headersHas(headers, 'content-type')) {
          headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
        return create(init, {
          body: createPropertyDescriptor(0, $toString$2(body)),
          headers: createPropertyDescriptor(0, headers)
        });
      }
    } return init;
  };

  if (isCallable$2(nativeFetch)) {
    $$3({ global: true, enumerable: true, dontCallGetSet: true, forced: true }, {
      fetch: function fetch(input /* , init */) {
        return nativeFetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
      }
    });
  }

  if (isCallable$2(NativeRequest)) {
    var RequestConstructor = function Request(input /* , init */) {
      anInstance$1(this, RequestPrototype);
      return new NativeRequest(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
    };

    RequestPrototype.constructor = RequestConstructor;
    RequestConstructor.prototype = RequestPrototype;

    $$3({ global: true, constructor: true, dontCallGetSet: true, forced: true }, {
      Request: RequestConstructor
    });
  }
}

var web_urlSearchParams_constructor = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
};

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`

var $$2 = _export;
var DESCRIPTORS$2 = descriptors;
var USE_NATIVE_URL = urlConstructorDetection;
var global$3 = global$p;
var bind = functionBindContext;
var uncurryThis$3 = functionUncurryThis;
var defineBuiltIn$2 = defineBuiltIn$b;
var defineBuiltInAccessor$1 = defineBuiltInAccessor$4;
var anInstance = anInstance$3;
var hasOwn$3 = hasOwnProperty_1;
var assign = objectAssign;
var arrayFrom = arrayFrom$1;
var arraySlice = arraySliceSimple;
var codeAt = stringMultibyte.codeAt;
var toASCII = stringPunycodeToAscii;
var $toString$1 = toString$a;
var setToStringTag = setToStringTag$5;
var validateArgumentsLength = validateArgumentsLength$3;
var URLSearchParamsModule = web_urlSearchParams_constructor;
var InternalStateModule = internalState;

var setInternalState = InternalStateModule.set;
var getInternalURLState = InternalStateModule.getterFor('URL');
var URLSearchParams$1 = URLSearchParamsModule.URLSearchParams;
var getInternalSearchParamsState = URLSearchParamsModule.getState;

var NativeURL = global$3.URL;
var TypeError$1 = global$3.TypeError;
var parseInt = global$3.parseInt;
var floor = Math.floor;
var pow = Math.pow;
var charAt$1 = uncurryThis$3(''.charAt);
var exec$1 = uncurryThis$3(/./.exec);
var join = uncurryThis$3([].join);
var numberToString = uncurryThis$3(1.0.toString);
var pop = uncurryThis$3([].pop);
var push$1 = uncurryThis$3([].push);
var replace$2 = uncurryThis$3(''.replace);
var shift = uncurryThis$3([].shift);
var split = uncurryThis$3(''.split);
var stringSlice$2 = uncurryThis$3(''.slice);
var toLowerCase = uncurryThis$3(''.toLowerCase);
var unshift = uncurryThis$3([].unshift);

var INVALID_AUTHORITY = 'Invalid authority';
var INVALID_SCHEME = 'Invalid scheme';
var INVALID_HOST = 'Invalid host';
var INVALID_PORT = 'Invalid port';

var ALPHA = /[a-z]/i;
// eslint-disable-next-line regexp/no-obscure-range -- safe
var ALPHANUMERIC = /[\d+-.a-z]/i;
var DIGIT = /\d/;
var HEX_START = /^0x/i;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\da-f]+$/i;
/* eslint-disable regexp/no-control-character -- safe */
var FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var LEADING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+/;
var TRAILING_C0_CONTROL_OR_SPACE = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/;
var TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable regexp/no-control-character -- safe */
var EOF;

// https://url.spec.whatwg.org/#ipv4-number-parser
var parseIPv4 = function (input) {
  var parts = split(input, '.');
  var partsLength, numbers, index, part, radix, number, ipv4;
  if (parts.length && parts[parts.length - 1] === '') {
    parts.length--;
  }
  partsLength = parts.length;
  if (partsLength > 4) return input;
  numbers = [];
  for (index = 0; index < partsLength; index++) {
    part = parts[index];
    if (part === '') return input;
    radix = 10;
    if (part.length > 1 && charAt$1(part, 0) === '0') {
      radix = exec$1(HEX_START, part) ? 16 : 8;
      part = stringSlice$2(part, radix === 8 ? 1 : 2);
    }
    if (part === '') {
      number = 0;
    } else {
      if (!exec$1(radix === 10 ? DEC : radix === 8 ? OCT : HEX, part)) return input;
      number = parseInt(part, radix);
    }
    push$1(numbers, number);
  }
  for (index = 0; index < partsLength; index++) {
    number = numbers[index];
    if (index === partsLength - 1) {
      if (number >= pow(256, 5 - partsLength)) return null;
    } else if (number > 255) return null;
  }
  ipv4 = pop(numbers);
  for (index = 0; index < numbers.length; index++) {
    ipv4 += numbers[index] * pow(256, 3 - index);
  }
  return ipv4;
};

// https://url.spec.whatwg.org/#concept-ipv6-parser
// eslint-disable-next-line max-statements -- TODO
var parseIPv6 = function (input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

  var chr = function () {
    return charAt$1(input, pointer);
  };

  if (chr() === ':') {
    if (charAt$1(input, 1) !== ':') return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }
  while (chr()) {
    if (pieceIndex === 8) return;
    if (chr() === ':') {
      if (compress !== null) return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }
    value = length = 0;
    while (length < 4 && exec$1(HEX, chr())) {
      value = value * 16 + parseInt(chr(), 16);
      pointer++;
      length++;
    }
    if (chr() === '.') {
      if (length === 0) return;
      pointer -= length;
      if (pieceIndex > 6) return;
      numbersSeen = 0;
      while (chr()) {
        ipv4Piece = null;
        if (numbersSeen > 0) {
          if (chr() === '.' && numbersSeen < 4) pointer++;
          else return;
        }
        if (!exec$1(DIGIT, chr())) return;
        while (exec$1(DIGIT, chr())) {
          number = parseInt(chr(), 10);
          if (ipv4Piece === null) ipv4Piece = number;
          else if (ipv4Piece === 0) return;
          else ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255) return;
          pointer++;
        }
        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen === 2 || numbersSeen === 4) pieceIndex++;
      }
      if (numbersSeen !== 4) return;
      break;
    } else if (chr() === ':') {
      pointer++;
      if (!chr()) return;
    } else if (chr()) return;
    address[pieceIndex++] = value;
  }
  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;
    while (pieceIndex !== 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex !== 8) return;
  return address;
};

var findLongestZeroSequence = function (ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index = 0;
  for (; index < 8; index++) {
    if (ipv6[index] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }
      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null) currStart = index;
      ++currLength;
    }
  }
  if (currLength > maxLength) {
    maxIndex = currStart;
    maxLength = currLength;
  }
  return maxIndex;
};

// https://url.spec.whatwg.org/#host-serializing
var serializeHost = function (host) {
  var result, index, compress, ignore0;
  // ipv4
  if (typeof host == 'number') {
    result = [];
    for (index = 0; index < 4; index++) {
      unshift(result, host % 256);
      host = floor(host / 256);
    } return join(result, '.');
  // ipv6
  } else if (typeof host == 'object') {
    result = '';
    compress = findLongestZeroSequence(host);
    for (index = 0; index < 8; index++) {
      if (ignore0 && host[index] === 0) continue;
      if (ignore0) ignore0 = false;
      if (compress === index) {
        result += index ? ':' : '::';
        ignore0 = true;
      } else {
        result += numberToString(host[index], 16);
        if (index < 7) result += ':';
      }
    }
    return '[' + result + ']';
  } return host;
};

var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
  ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1
});
var pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
  '#': 1, '?': 1, '{': 1, '}': 1
});
var userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
  '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1
});

var percentEncode = function (chr, set) {
  var code = codeAt(chr, 0);
  return code > 0x20 && code < 0x7F && !hasOwn$3(set, chr) ? chr : encodeURIComponent(chr);
};

// https://url.spec.whatwg.org/#special-scheme
var specialSchemes = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
};

// https://url.spec.whatwg.org/#windows-drive-letter
var isWindowsDriveLetter = function (string, normalized) {
  var second;
  return string.length === 2 && exec$1(ALPHA, charAt$1(string, 0))
    && ((second = charAt$1(string, 1)) === ':' || (!normalized && second === '|'));
};

// https://url.spec.whatwg.org/#start-with-a-windows-drive-letter
var startsWithWindowsDriveLetter = function (string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter(stringSlice$2(string, 0, 2)) && (
    string.length === 2 ||
    ((third = charAt$1(string, 2)) === '/' || third === '\\' || third === '?' || third === '#')
  );
};

// https://url.spec.whatwg.org/#single-dot-path-segment
var isSingleDot = function (segment) {
  return segment === '.' || toLowerCase(segment) === '%2e';
};

// https://url.spec.whatwg.org/#double-dot-path-segment
var isDoubleDot = function (segment) {
  segment = toLowerCase(segment);
  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};

// States:
var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};

var URLState = function (url, isBase, base) {
  var urlString = $toString$1(url);
  var baseState, failure, searchParams;
  if (isBase) {
    failure = this.parse(urlString);
    if (failure) throw new TypeError$1(failure);
    this.searchParams = null;
  } else {
    if (base !== undefined) baseState = new URLState(base, true);
    failure = this.parse(urlString, null, baseState);
    if (failure) throw new TypeError$1(failure);
    searchParams = getInternalSearchParamsState(new URLSearchParams$1());
    searchParams.bindURL(this);
    this.searchParams = searchParams;
  }
};

URLState.prototype = {
  type: 'URL',
  // https://url.spec.whatwg.org/#url-parsing
  // eslint-disable-next-line max-statements -- TODO
  parse: function (input, stateOverride, base) {
    var url = this;
    var state = stateOverride || SCHEME_START;
    var pointer = 0;
    var buffer = '';
    var seenAt = false;
    var seenBracket = false;
    var seenPasswordToken = false;
    var codePoints, chr, bufferCodePoints, failure;

    input = $toString$1(input);

    if (!stateOverride) {
      url.scheme = '';
      url.username = '';
      url.password = '';
      url.host = null;
      url.port = null;
      url.path = [];
      url.query = null;
      url.fragment = null;
      url.cannotBeABaseURL = false;
      input = replace$2(input, LEADING_C0_CONTROL_OR_SPACE, '');
      input = replace$2(input, TRAILING_C0_CONTROL_OR_SPACE, '$1');
    }

    input = replace$2(input, TAB_AND_NEW_LINE, '');

    codePoints = arrayFrom(input);

    while (pointer <= codePoints.length) {
      chr = codePoints[pointer];
      switch (state) {
        case SCHEME_START:
          if (chr && exec$1(ALPHA, chr)) {
            buffer += toLowerCase(chr);
            state = SCHEME;
          } else if (!stateOverride) {
            state = NO_SCHEME;
            continue;
          } else return INVALID_SCHEME;
          break;

        case SCHEME:
          if (chr && (exec$1(ALPHANUMERIC, chr) || chr === '+' || chr === '-' || chr === '.')) {
            buffer += toLowerCase(chr);
          } else if (chr === ':') {
            if (stateOverride && (
              (url.isSpecial() !== hasOwn$3(specialSchemes, buffer)) ||
              (buffer === 'file' && (url.includesCredentials() || url.port !== null)) ||
              (url.scheme === 'file' && !url.host)
            )) return;
            url.scheme = buffer;
            if (stateOverride) {
              if (url.isSpecial() && specialSchemes[url.scheme] === url.port) url.port = null;
              return;
            }
            buffer = '';
            if (url.scheme === 'file') {
              state = FILE;
            } else if (url.isSpecial() && base && base.scheme === url.scheme) {
              state = SPECIAL_RELATIVE_OR_AUTHORITY;
            } else if (url.isSpecial()) {
              state = SPECIAL_AUTHORITY_SLASHES;
            } else if (codePoints[pointer + 1] === '/') {
              state = PATH_OR_AUTHORITY;
              pointer++;
            } else {
              url.cannotBeABaseURL = true;
              push$1(url.path, '');
              state = CANNOT_BE_A_BASE_URL_PATH;
            }
          } else if (!stateOverride) {
            buffer = '';
            state = NO_SCHEME;
            pointer = 0;
            continue;
          } else return INVALID_SCHEME;
          break;

        case NO_SCHEME:
          if (!base || (base.cannotBeABaseURL && chr !== '#')) return INVALID_SCHEME;
          if (base.cannotBeABaseURL && chr === '#') {
            url.scheme = base.scheme;
            url.path = arraySlice(base.path);
            url.query = base.query;
            url.fragment = '';
            url.cannotBeABaseURL = true;
            state = FRAGMENT;
            break;
          }
          state = base.scheme === 'file' ? FILE : RELATIVE;
          continue;

        case SPECIAL_RELATIVE_OR_AUTHORITY:
          if (chr === '/' && codePoints[pointer + 1] === '/') {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
            pointer++;
          } else {
            state = RELATIVE;
            continue;
          } break;

        case PATH_OR_AUTHORITY:
          if (chr === '/') {
            state = AUTHORITY;
            break;
          } else {
            state = PATH;
            continue;
          }

        case RELATIVE:
          url.scheme = base.scheme;
          if (chr === EOF) {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = base.query;
          } else if (chr === '/' || (chr === '\\' && url.isSpecial())) {
            state = RELATIVE_SLASH;
          } else if (chr === '?') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = '';
            state = QUERY;
          } else if (chr === '#') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = base.query;
            url.fragment = '';
            state = FRAGMENT;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.path.length--;
            state = PATH;
            continue;
          } break;

        case RELATIVE_SLASH:
          if (url.isSpecial() && (chr === '/' || chr === '\\')) {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          } else if (chr === '/') {
            state = AUTHORITY;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            state = PATH;
            continue;
          } break;

        case SPECIAL_AUTHORITY_SLASHES:
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          if (chr !== '/' || charAt$1(buffer, pointer + 1) !== '/') continue;
          pointer++;
          break;

        case SPECIAL_AUTHORITY_IGNORE_SLASHES:
          if (chr !== '/' && chr !== '\\') {
            state = AUTHORITY;
            continue;
          } break;

        case AUTHORITY:
          if (chr === '@') {
            if (seenAt) buffer = '%40' + buffer;
            seenAt = true;
            bufferCodePoints = arrayFrom(buffer);
            for (var i = 0; i < bufferCodePoints.length; i++) {
              var codePoint = bufferCodePoints[i];
              if (codePoint === ':' && !seenPasswordToken) {
                seenPasswordToken = true;
                continue;
              }
              var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
              if (seenPasswordToken) url.password += encodedCodePoints;
              else url.username += encodedCodePoints;
            }
            buffer = '';
          } else if (
            chr === EOF || chr === '/' || chr === '?' || chr === '#' ||
            (chr === '\\' && url.isSpecial())
          ) {
            if (seenAt && buffer === '') return INVALID_AUTHORITY;
            pointer -= arrayFrom(buffer).length + 1;
            buffer = '';
            state = HOST;
          } else buffer += chr;
          break;

        case HOST:
        case HOSTNAME:
          if (stateOverride && url.scheme === 'file') {
            state = FILE_HOST;
            continue;
          } else if (chr === ':' && !seenBracket) {
            if (buffer === '') return INVALID_HOST;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PORT;
            if (stateOverride === HOSTNAME) return;
          } else if (
            chr === EOF || chr === '/' || chr === '?' || chr === '#' ||
            (chr === '\\' && url.isSpecial())
          ) {
            if (url.isSpecial() && buffer === '') return INVALID_HOST;
            if (stateOverride && buffer === '' && (url.includesCredentials() || url.port !== null)) return;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PATH_START;
            if (stateOverride) return;
            continue;
          } else {
            if (chr === '[') seenBracket = true;
            else if (chr === ']') seenBracket = false;
            buffer += chr;
          } break;

        case PORT:
          if (exec$1(DIGIT, chr)) {
            buffer += chr;
          } else if (
            chr === EOF || chr === '/' || chr === '?' || chr === '#' ||
            (chr === '\\' && url.isSpecial()) ||
            stateOverride
          ) {
            if (buffer !== '') {
              var port = parseInt(buffer, 10);
              if (port > 0xFFFF) return INVALID_PORT;
              url.port = (url.isSpecial() && port === specialSchemes[url.scheme]) ? null : port;
              buffer = '';
            }
            if (stateOverride) return;
            state = PATH_START;
            continue;
          } else return INVALID_PORT;
          break;

        case FILE:
          url.scheme = 'file';
          if (chr === '/' || chr === '\\') state = FILE_SLASH;
          else if (base && base.scheme === 'file') {
            switch (chr) {
              case EOF:
                url.host = base.host;
                url.path = arraySlice(base.path);
                url.query = base.query;
                break;
              case '?':
                url.host = base.host;
                url.path = arraySlice(base.path);
                url.query = '';
                state = QUERY;
                break;
              case '#':
                url.host = base.host;
                url.path = arraySlice(base.path);
                url.query = base.query;
                url.fragment = '';
                state = FRAGMENT;
                break;
              default:
                if (!startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
                  url.host = base.host;
                  url.path = arraySlice(base.path);
                  url.shortenPath();
                }
                state = PATH;
                continue;
            }
          } else {
            state = PATH;
            continue;
          } break;

        case FILE_SLASH:
          if (chr === '/' || chr === '\\') {
            state = FILE_HOST;
            break;
          }
          if (base && base.scheme === 'file' && !startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
            if (isWindowsDriveLetter(base.path[0], true)) push$1(url.path, base.path[0]);
            else url.host = base.host;
          }
          state = PATH;
          continue;

        case FILE_HOST:
          if (chr === EOF || chr === '/' || chr === '\\' || chr === '?' || chr === '#') {
            if (!stateOverride && isWindowsDriveLetter(buffer)) {
              state = PATH;
            } else if (buffer === '') {
              url.host = '';
              if (stateOverride) return;
              state = PATH_START;
            } else {
              failure = url.parseHost(buffer);
              if (failure) return failure;
              if (url.host === 'localhost') url.host = '';
              if (stateOverride) return;
              buffer = '';
              state = PATH_START;
            } continue;
          } else buffer += chr;
          break;

        case PATH_START:
          if (url.isSpecial()) {
            state = PATH;
            if (chr !== '/' && chr !== '\\') continue;
          } else if (!stateOverride && chr === '?') {
            url.query = '';
            state = QUERY;
          } else if (!stateOverride && chr === '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr !== EOF) {
            state = PATH;
            if (chr !== '/') continue;
          } break;

        case PATH:
          if (
            chr === EOF || chr === '/' ||
            (chr === '\\' && url.isSpecial()) ||
            (!stateOverride && (chr === '?' || chr === '#'))
          ) {
            if (isDoubleDot(buffer)) {
              url.shortenPath();
              if (chr !== '/' && !(chr === '\\' && url.isSpecial())) {
                push$1(url.path, '');
              }
            } else if (isSingleDot(buffer)) {
              if (chr !== '/' && !(chr === '\\' && url.isSpecial())) {
                push$1(url.path, '');
              }
            } else {
              if (url.scheme === 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
                if (url.host) url.host = '';
                buffer = charAt$1(buffer, 0) + ':'; // normalize windows drive letter
              }
              push$1(url.path, buffer);
            }
            buffer = '';
            if (url.scheme === 'file' && (chr === EOF || chr === '?' || chr === '#')) {
              while (url.path.length > 1 && url.path[0] === '') {
                shift(url.path);
              }
            }
            if (chr === '?') {
              url.query = '';
              state = QUERY;
            } else if (chr === '#') {
              url.fragment = '';
              state = FRAGMENT;
            }
          } else {
            buffer += percentEncode(chr, pathPercentEncodeSet);
          } break;

        case CANNOT_BE_A_BASE_URL_PATH:
          if (chr === '?') {
            url.query = '';
            state = QUERY;
          } else if (chr === '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr !== EOF) {
            url.path[0] += percentEncode(chr, C0ControlPercentEncodeSet);
          } break;

        case QUERY:
          if (!stateOverride && chr === '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr !== EOF) {
            if (chr === "'" && url.isSpecial()) url.query += '%27';
            else if (chr === '#') url.query += '%23';
            else url.query += percentEncode(chr, C0ControlPercentEncodeSet);
          } break;

        case FRAGMENT:
          if (chr !== EOF) url.fragment += percentEncode(chr, fragmentPercentEncodeSet);
          break;
      }

      pointer++;
    }
  },
  // https://url.spec.whatwg.org/#host-parsing
  parseHost: function (input) {
    var result, codePoints, index;
    if (charAt$1(input, 0) === '[') {
      if (charAt$1(input, input.length - 1) !== ']') return INVALID_HOST;
      result = parseIPv6(stringSlice$2(input, 1, -1));
      if (!result) return INVALID_HOST;
      this.host = result;
    // opaque host
    } else if (!this.isSpecial()) {
      if (exec$1(FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return INVALID_HOST;
      result = '';
      codePoints = arrayFrom(input);
      for (index = 0; index < codePoints.length; index++) {
        result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
      }
      this.host = result;
    } else {
      input = toASCII(input);
      if (exec$1(FORBIDDEN_HOST_CODE_POINT, input)) return INVALID_HOST;
      result = parseIPv4(input);
      if (result === null) return INVALID_HOST;
      this.host = result;
    }
  },
  // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
  cannotHaveUsernamePasswordPort: function () {
    return !this.host || this.cannotBeABaseURL || this.scheme === 'file';
  },
  // https://url.spec.whatwg.org/#include-credentials
  includesCredentials: function () {
    return this.username !== '' || this.password !== '';
  },
  // https://url.spec.whatwg.org/#is-special
  isSpecial: function () {
    return hasOwn$3(specialSchemes, this.scheme);
  },
  // https://url.spec.whatwg.org/#shorten-a-urls-path
  shortenPath: function () {
    var path = this.path;
    var pathSize = path.length;
    if (pathSize && (this.scheme !== 'file' || pathSize !== 1 || !isWindowsDriveLetter(path[0], true))) {
      path.length--;
    }
  },
  // https://url.spec.whatwg.org/#concept-url-serializer
  serialize: function () {
    var url = this;
    var scheme = url.scheme;
    var username = url.username;
    var password = url.password;
    var host = url.host;
    var port = url.port;
    var path = url.path;
    var query = url.query;
    var fragment = url.fragment;
    var output = scheme + ':';
    if (host !== null) {
      output += '//';
      if (url.includesCredentials()) {
        output += username + (password ? ':' + password : '') + '@';
      }
      output += serializeHost(host);
      if (port !== null) output += ':' + port;
    } else if (scheme === 'file') output += '//';
    output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
    if (query !== null) output += '?' + query;
    if (fragment !== null) output += '#' + fragment;
    return output;
  },
  // https://url.spec.whatwg.org/#dom-url-href
  setHref: function (href) {
    var failure = this.parse(href);
    if (failure) throw new TypeError$1(failure);
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-origin
  getOrigin: function () {
    var scheme = this.scheme;
    var port = this.port;
    if (scheme === 'blob') try {
      return new URLConstructor(scheme.path[0]).origin;
    } catch (error) {
      return 'null';
    }
    if (scheme === 'file' || !this.isSpecial()) return 'null';
    return scheme + '://' + serializeHost(this.host) + (port !== null ? ':' + port : '');
  },
  // https://url.spec.whatwg.org/#dom-url-protocol
  getProtocol: function () {
    return this.scheme + ':';
  },
  setProtocol: function (protocol) {
    this.parse($toString$1(protocol) + ':', SCHEME_START);
  },
  // https://url.spec.whatwg.org/#dom-url-username
  getUsername: function () {
    return this.username;
  },
  setUsername: function (username) {
    var codePoints = arrayFrom($toString$1(username));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.username = '';
    for (var i = 0; i < codePoints.length; i++) {
      this.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-password
  getPassword: function () {
    return this.password;
  },
  setPassword: function (password) {
    var codePoints = arrayFrom($toString$1(password));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.password = '';
    for (var i = 0; i < codePoints.length; i++) {
      this.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-host
  getHost: function () {
    var host = this.host;
    var port = this.port;
    return host === null ? ''
      : port === null ? serializeHost(host)
      : serializeHost(host) + ':' + port;
  },
  setHost: function (host) {
    if (this.cannotBeABaseURL) return;
    this.parse(host, HOST);
  },
  // https://url.spec.whatwg.org/#dom-url-hostname
  getHostname: function () {
    var host = this.host;
    return host === null ? '' : serializeHost(host);
  },
  setHostname: function (hostname) {
    if (this.cannotBeABaseURL) return;
    this.parse(hostname, HOSTNAME);
  },
  // https://url.spec.whatwg.org/#dom-url-port
  getPort: function () {
    var port = this.port;
    return port === null ? '' : $toString$1(port);
  },
  setPort: function (port) {
    if (this.cannotHaveUsernamePasswordPort()) return;
    port = $toString$1(port);
    if (port === '') this.port = null;
    else this.parse(port, PORT);
  },
  // https://url.spec.whatwg.org/#dom-url-pathname
  getPathname: function () {
    var path = this.path;
    return this.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
  },
  setPathname: function (pathname) {
    if (this.cannotBeABaseURL) return;
    this.path = [];
    this.parse(pathname, PATH_START);
  },
  // https://url.spec.whatwg.org/#dom-url-search
  getSearch: function () {
    var query = this.query;
    return query ? '?' + query : '';
  },
  setSearch: function (search) {
    search = $toString$1(search);
    if (search === '') {
      this.query = null;
    } else {
      if (charAt$1(search, 0) === '?') search = stringSlice$2(search, 1);
      this.query = '';
      this.parse(search, QUERY);
    }
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-searchparams
  getSearchParams: function () {
    return this.searchParams.facade;
  },
  // https://url.spec.whatwg.org/#dom-url-hash
  getHash: function () {
    var fragment = this.fragment;
    return fragment ? '#' + fragment : '';
  },
  setHash: function (hash) {
    hash = $toString$1(hash);
    if (hash === '') {
      this.fragment = null;
      return;
    }
    if (charAt$1(hash, 0) === '#') hash = stringSlice$2(hash, 1);
    this.fragment = '';
    this.parse(hash, FRAGMENT);
  },
  update: function () {
    this.query = this.searchParams.serialize() || null;
  }
};

// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var URLConstructor = function URL(url /* , base */) {
  var that = anInstance(this, URLPrototype);
  var base = validateArgumentsLength(arguments.length, 1) > 1 ? arguments[1] : undefined;
  var state = setInternalState(that, new URLState(url, false, base));
  if (!DESCRIPTORS$2) {
    that.href = state.serialize();
    that.origin = state.getOrigin();
    that.protocol = state.getProtocol();
    that.username = state.getUsername();
    that.password = state.getPassword();
    that.host = state.getHost();
    that.hostname = state.getHostname();
    that.port = state.getPort();
    that.pathname = state.getPathname();
    that.search = state.getSearch();
    that.searchParams = state.getSearchParams();
    that.hash = state.getHash();
  }
};

var URLPrototype = URLConstructor.prototype;

var accessorDescriptor = function (getter, setter) {
  return {
    get: function () {
      return getInternalURLState(this)[getter]();
    },
    set: setter && function (value) {
      return getInternalURLState(this)[setter](value);
    },
    configurable: true,
    enumerable: true
  };
};

if (DESCRIPTORS$2) {
  // `URL.prototype.href` accessors pair
  // https://url.spec.whatwg.org/#dom-url-href
  defineBuiltInAccessor$1(URLPrototype, 'href', accessorDescriptor('serialize', 'setHref'));
  // `URL.prototype.origin` getter
  // https://url.spec.whatwg.org/#dom-url-origin
  defineBuiltInAccessor$1(URLPrototype, 'origin', accessorDescriptor('getOrigin'));
  // `URL.prototype.protocol` accessors pair
  // https://url.spec.whatwg.org/#dom-url-protocol
  defineBuiltInAccessor$1(URLPrototype, 'protocol', accessorDescriptor('getProtocol', 'setProtocol'));
  // `URL.prototype.username` accessors pair
  // https://url.spec.whatwg.org/#dom-url-username
  defineBuiltInAccessor$1(URLPrototype, 'username', accessorDescriptor('getUsername', 'setUsername'));
  // `URL.prototype.password` accessors pair
  // https://url.spec.whatwg.org/#dom-url-password
  defineBuiltInAccessor$1(URLPrototype, 'password', accessorDescriptor('getPassword', 'setPassword'));
  // `URL.prototype.host` accessors pair
  // https://url.spec.whatwg.org/#dom-url-host
  defineBuiltInAccessor$1(URLPrototype, 'host', accessorDescriptor('getHost', 'setHost'));
  // `URL.prototype.hostname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hostname
  defineBuiltInAccessor$1(URLPrototype, 'hostname', accessorDescriptor('getHostname', 'setHostname'));
  // `URL.prototype.port` accessors pair
  // https://url.spec.whatwg.org/#dom-url-port
  defineBuiltInAccessor$1(URLPrototype, 'port', accessorDescriptor('getPort', 'setPort'));
  // `URL.prototype.pathname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-pathname
  defineBuiltInAccessor$1(URLPrototype, 'pathname', accessorDescriptor('getPathname', 'setPathname'));
  // `URL.prototype.search` accessors pair
  // https://url.spec.whatwg.org/#dom-url-search
  defineBuiltInAccessor$1(URLPrototype, 'search', accessorDescriptor('getSearch', 'setSearch'));
  // `URL.prototype.searchParams` getter
  // https://url.spec.whatwg.org/#dom-url-searchparams
  defineBuiltInAccessor$1(URLPrototype, 'searchParams', accessorDescriptor('getSearchParams'));
  // `URL.prototype.hash` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hash
  defineBuiltInAccessor$1(URLPrototype, 'hash', accessorDescriptor('getHash', 'setHash'));
}

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
defineBuiltIn$2(URLPrototype, 'toJSON', function toJSON() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });

// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
defineBuiltIn$2(URLPrototype, 'toString', function toString() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });

if (NativeURL) {
  var nativeCreateObjectURL = NativeURL.createObjectURL;
  var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
  // `URL.createObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
  if (nativeCreateObjectURL) defineBuiltIn$2(URLConstructor, 'createObjectURL', bind(nativeCreateObjectURL, NativeURL));
  // `URL.revokeObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
  if (nativeRevokeObjectURL) defineBuiltIn$2(URLConstructor, 'revokeObjectURL', bind(nativeRevokeObjectURL, NativeURL));
}

setToStringTag(URLConstructor, 'URL');

$$2({ global: true, constructor: true, forced: !USE_NATIVE_URL, sham: !DESCRIPTORS$2 }, {
  URL: URLConstructor
});

const RawReportContext = /*#__PURE__*/createContext(null);
const RawReportProvider = ({
  children
}) => {
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.events || !resources.api || !resources.config) throw new Error('Missing required resources {api, events, config}');
  const manager = rawReportManager(resources);
  return jsx(RawReportContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const useRawReport = () => {
  const context = useContext(RawReportContext);
  if (context == null) {
    throw new Error('useRawReport used outside of its Provider');
  }
  return context;
};
const rawReportManager = ({
  api,
  events,
  config
}) => {
  const [rawReport, setRawReport] = useState(null);
  const [reportSchema, setReportSchema] = useState(null);
  const [loading, setLoading] = useState(false);
  const [generatingReport, setGeneratingReport] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [selectedOrgGroup, setSelectedOrgGroup] = useState(null);
  const {
    personal
  } = useCurrentPerson();
  const changeReportSchema = newReportSchema => {
    setReportSchema(newReportSchema);
  };
  useEffect(() => {
    const fetchRawReportData = () => __awaiter(void 0, void 0, void 0, function* () {
      setLoading(true);
      try {
        if (reportSchema != null) {
          const params = reportSchema.type === 'group' ? {
            orgGroup: selectedOrgGroup === null || selectedOrgGroup === void 0 ? void 0 : selectedOrgGroup._id
          } : {
            patient: selectedPatient === null || selectedPatient === void 0 ? void 0 : selectedPatient._id
          };
          const retrievedRawReport = yield api.org.customReports.raw(JSON.stringify(reportSchema), JSON.stringify(params));
          setRawReport(retrievedRawReport);
        }
      } catch (e) {
        Sentry.captureException(e);
        console.error(e);
      }
      setLoading(false);
    });
    fetchRawReportData();
  }, [api, config, events, reportSchema, selectedPatient]);
  const generateReport = downloadType => __awaiter(void 0, void 0, void 0, function* () {
    if (downloadType === 'xlsx') return generateXLSX();
    if (downloadType === 'csv') return generateCSV();
    if (downloadType === 'pdf') return generatePDF();
    // if (downloadType === 'pbix') return generatePBIX();
    throw new Error('Invalid download type');
  });
  const generateXLSX = () => __awaiter(void 0, void 0, void 0, function* () {
    if (!rawReport || loading) return;
    setGeneratingReport(true);
    try {
      const workbook = yield ReportGenerator.render.asXLSX(rawReport, personal);
      const filename = `${rawReport.name || 'XLSX Report'} ${new Date().toDateString()}.xlsx`;
      const wbout = XLSX.write(workbook, {
        bookType: 'xlsx',
        bookSST: false,
        type: 'array'
      });
      const blob = new Blob([wbout], {
        type: 'application/octet-stream'
      });
      downloadBlob(blob, filename);
    } catch (err) {
      Sentry.captureException(err);
    }
    setGeneratingReport(false);
  });
  const generateCSV = () => __awaiter(void 0, void 0, void 0, function* () {
    if (!rawReport || loading) return;
    setGeneratingReport(true);
    try {
      const csvFiles = yield ReportGenerator.render.asCSV(rawReport);
      const zip = new JSZip();
      csvFiles.forEach((csvFile, index) => {
        var _a, _b;
        const csvBlob = new Blob([csvFile], {
          type: 'text/csv'
        });
        const csvBlobFilename = `${((_b = (_a = rawReport.sections) === null || _a === void 0 ? void 0 : _a[index]) === null || _b === void 0 ? void 0 : _b.title) || `csv_${index + 1}`}.csv`;
        zip.file(csvBlobFilename, csvBlob);
      });
      const filename = `${rawReport.name || 'CSV Report'} ${new Date().toDateString()}.zip`;
      const blob = yield zip.generateAsync({
        type: 'blob'
      });
      downloadBlob(blob, filename);
    } catch (err) {
      Sentry.captureException(err);
    }
    setGeneratingReport(false);
  });
  const generatePDF = () => __awaiter(void 0, void 0, void 0, function* () {
    if (!rawReport || loading) return;
    setGeneratingReport(true);
    try {
      yield api.org.customReports.pdf(rawReport);
    } catch (err) {
      Sentry.captureException(err);
    }
    setGeneratingReport(false);
  });
  return {
    rawReport,
    selectedPatient,
    selectedOrgGroup,
    setSelectedPatient,
    setSelectedOrgGroup,
    changeReportSchema,
    loading,
    generatingReport,
    currentReportSchema: reportSchema,
    generateReport,
    generatePDF,
    generateXLSX,
    generateCSV
    // generatePBIX,
  };
};
function downloadBlob(blob, fileName) {
  const element = document.createElement('a');
  element.href = URL.createObjectURL(blob);
  element.download = fileName;
  document.body.appendChild(element); // Required for this to work in FireFox
  element.click();
}

var call$1 = functionCall;
var hasOwn$2 = hasOwnProperty_1;
var isPrototypeOf$2 = objectIsPrototypeOf;
var regExpFlags = regexpFlags$1;

var RegExpPrototype$2 = RegExp.prototype;

var regexpGetFlags = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype$2) && !hasOwn$2(R, 'flags') && isPrototypeOf$2(RegExpPrototype$2, R)
    ? call$1(regExpFlags, R) : flags;
};

var PROPER_FUNCTION_NAME = functionName.PROPER;
var defineBuiltIn$1 = defineBuiltIn$b;
var anObject$1 = anObject$i;
var $toString = toString$a;
var fails$2 = fails$o;
var getRegExpFlags$1 = regexpGetFlags;

var TO_STRING = 'toString';
var RegExpPrototype$1 = RegExp.prototype;
var nativeToString = RegExpPrototype$1[TO_STRING];

var NOT_GENERIC = fails$2(function () { return nativeToString.call({ source: 'a', flags: 'b' }) !== '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name !== TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn$1(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject$1(this);
    var pattern = $toString(R.source);
    var flags = $toString(getRegExpFlags$1(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}

const OrgSchemasContext = /*#__PURE__*/createContext(null);
const OrgSchemasProvider = ({
  children
}) => {
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.events || !resources.api || !resources.config) throw new Error('Missing required resources {api, events, config}');
  const manager = orgSchemasManager(resources);
  return jsx(OrgSchemasContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const useOrgSchemas = () => {
  const context = useContext(OrgSchemasContext);
  if (context == null) {
    throw new Error('useOrgSchemass used outside of its Provider');
  }
  return context;
};
const orgSchemasManager = ({
  api,
  events,
  config
}) => {
  const [workflowSchemas, setWorkflowSchemas] = useState(null);
  const [formSchemas, setFormSchemas] = useState(null);
  const [customIndicators, setCustomIndicators] = useState(null);
  const workflowSchemasMap = dbEntriesToMap$3(workflowSchemas);
  const formSchemasMap = dbEntriesToMap$3(formSchemas);
  const customIndicatorsMap = dbEntriesToMap$3(customIndicators);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchRawReportData = () => __awaiter(void 0, void 0, void 0, function* () {
      setLoading(true);
      try {
        const [workflowSchemas, formSchemas, customIndicators] = yield Promise.all([api.org.workflow.definitions(), api.org.forms.listType('user'), api.org.indicators()]);
        setWorkflowSchemas(workflowSchemas);
        setFormSchemas(formSchemas);
        setCustomIndicators(customIndicators);
      } catch (e) {
        Sentry.captureException(e);
        console.error(e);
      }
      setLoading(false);
    });
    fetchRawReportData();
  }, [api, config, events]);
  return {
    workflowSchemas,
    workflowSchemasMap,
    formSchemas,
    formSchemasMap,
    customIndicators,
    customIndicatorsMap,
    loading
  };
};
function dbEntriesToMap$3(entries) {
  if (entries == null) {
    return null;
  }
  const results = {};
  return entries.reduce((map, entry) => {
    map[entry._id.toString()] = entry;
    return map;
  }, results);
}

const ReportSchemaContext = /*#__PURE__*/React__default.createContext(null);
const ReportSchemaProvider = ({
  children,
  schemaId
}) => {
  const resources = React__default.useContext(ResourcesContext);
  if (!resources || !resources.events || !resources.api || !resources.config) throw new Error('Missing required resources {api, events, config}');
  const manager = reportSchemaManager(resources, schemaId);
  return jsx(ReportSchemaContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const useReportSchema = () => {
  const context = React__default.useContext(ReportSchemaContext);
  if (context == null) {
    throw new Error('useReportSchema used outside of its Provider');
  }
  return context;
};
const reportSchemaManager = ({
  api,
  events,
  config
}, initialSchemaId) => {
  const [reportSchema, setReportSchema] = React__default.useState(null);
  const [schemaId, setSchemaId] = React__default.useState(initialSchemaId || null);
  const [loading, setLoading] = React__default.useState(true);
  const [saving, setSaving] = React__default.useState(false);
  const [lastSavedSchema, setLastSavedSchema] = React__default.useState(null);
  React__default.useEffect(() => {
    const fetchReportSchema = () => __awaiter(void 0, void 0, void 0, function* () {
      try {
        if (!schemaId) {
          setLoading(false);
          return;
        }
        setLoading(true);
        const dbEntry = yield api.org.customReports.get(schemaId);
        setReportSchema(dbEntry.schema);
        setLastSavedSchema(dbEntry.schema);
        setLoading(false);
      } catch (e) {
        Sentry.captureException(e);
        console.error(e);
        setLoading(false);
      }
    });
    fetchReportSchema();
  }, [api, config, events, schemaId]);
  React__default.useEffect(() => {
    setSchemaId(initialSchemaId || null);
  }, [initialSchemaId]);
  const setSections = newSections => {
    const newSchema = Object.assign({}, reportSchema);
    newSchema.sections = newSections;
    setReportSchema(newSchema);
  };
  const setSection = (newSection, index) => {
    if (loading) return;
    if (!reportSchema) throw new Error(`Report schema failed to load. Cannot call setSection`);
    if (index > reportSchema.sections.length) {
      throw new Error(`Tried to set section with index ${index} even though this report only has ${reportSchema.sections.length} sections`);
    }
    const newSchema = Object.assign({}, reportSchema);
    newSchema.sections[index] = newSection;
    setReportSchema(newSchema);
  };
  const renameSection = (newName, index) => {
    if (loading) return;
    if (!reportSchema) throw new Error(`Report schema failed to load. Cannot call renameSection`);
    if (index > reportSchema.sections.length) {
      throw new Error(`Tried to set section with index ${index} even though this report only has ${reportSchema.sections.length} sections`);
    }
    const newSchema = Object.assign({}, reportSchema);
    newSchema.sections[index].title = newName;
    setReportSchema(newSchema);
  };
  const renameReport = newName => {
    if (loading) return;
    if (!reportSchema) throw new Error(`Report schema failed to load. Cannot call renameReport`);
    const newSchema = Object.assign({}, reportSchema);
    newSchema.name = newName;
    setReportSchema(newSchema);
  };
  const addSections = newSections => {
    if (loading) return;
    if (!reportSchema) throw new Error(`Report schema failed to load. Cannot call addSections`);
    const newSchema = Object.assign({}, reportSchema);
    newSchema.sections = reportSchema.sections.concat(newSections // It doesn't like this without the cast because it wants all the sections to be the same type, but that doesn't matter
    );
    setReportSchema(newSchema);
  };
  const addNonRefinableSection = section => {
    if (loading) return;
    if (!reportSchema) throw new Error(`Report schema failed to load. Cannot call addNonRefinableSection`);
    const sectionIsNonRefinable = section === 'end' || section === 'info' || section === 'notes' || section === 'comment';
    if (sectionIsNonRefinable) {
      const sectionDefinition = {
        type: section
      };
      const sectionSchema = buildSection(sectionDefinition);
      if (sectionSchema) addSections(sectionSchema);
    } else {
      throw new Error(`Cannot add section of type ${section}. It must be refined first (i.e., certain parameters must be chosen before it can be added to the schema)`);
    }
  };
  const deleteSection = index => {
    if (loading) return;
    if (!reportSchema) throw new Error(`Report schema failed to load. Cannot call deleteSection`);
    if (index > reportSchema.sections.length) {
      throw new Error(`Tried to delete section with index ${index} even though this report only has ${reportSchema.sections.length} sections`);
    }
    const newSchema = Object.assign({}, reportSchema);
    newSchema.sections = reportSchema.sections.filter((_, i) => i !== index);
    setReportSchema(newSchema);
  };
  const saveSchema = () => __awaiter(void 0, void 0, void 0, function* () {
    if (loading || saving) return;
    if (!reportSchema) throw new Error(`Report schema failed to load. Cannot call saveSchema`);
    try {
      setSaving(true);
      yield api.org.customReports.update(schemaId, reportSchema);
      setLastSavedSchema(reportSchema);
      setSaving(false);
    } catch (e) {
      Sentry.captureException(e);
      console.error(e);
    }
  });
  const createEmptySchema = (type, name) => __awaiter(void 0, void 0, void 0, function* () {
    const reportSchema = {
      type,
      name,
      organization: '',
      sections: []
    };
    return createNewSchema(reportSchema);
  });
  const createNewSchema = schema => __awaiter(void 0, void 0, void 0, function* () {
    try {
      setLoading(true);
      const results = yield api.org.customReports.create(schema);
      if (!results) throw new Error("Couldn't save schema");
      setSchemaId(results._id.toString());
      return results._id.toString();
    } catch (e) {
      Sentry.captureException(e);
      console.error(e);
      return null;
    }
  });
  return {
    reportSchema,
    lastSavedSchema,
    loading,
    saving,
    saveSchema,
    setSchemaId,
    setReportSchema,
    setSections,
    setSection,
    addSections,
    renameSection,
    renameReport,
    addNonRefinableSection,
    deleteSection,
    createEmptySchema,
    createNewSchema
  };
};

const PAGE_LIMIT$6 = 32;
const ItemModelsContext = /*#__PURE__*/createContext(null);
const ItemModelsProvider = ({
  children
}) => {
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.events || !resources.api || !resources.config) throw new Error('Missing required resources {api, events, config}');
  const manager = itemModelsManager(resources);
  return jsx(ItemModelsContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const useItemModels = () => {
  const context = useContext(ItemModelsContext);
  if (context === undefined || context === null) {
    throw new Error('useItemModels used outside of its Provider');
  }
  return context;
};
const itemModelsManager = ({
  api,
  events
}) => {
  const [itemModels, setItemModels] = useState([]);
  const [itemMakes, setItemMakes] = useState([]);
  const [itemClasses, setItemClasses] = useState([]);
  const [classFilter, setClassFilter] = useState([]);
  const [makeFilter, setMakeFilter] = useState([]);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    fetchItemMakes();
    fetchItemClasses();
    function fetchItemMakes() {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          const itemMakesResponse = yield api.item.makes();
          setItemMakes(itemMakesResponse);
        } catch (e) {
          console.error(e);
          Sentry.captureException(e);
          if (e instanceof Error) setError(e.message);
        }
      });
    }
    function fetchItemClasses() {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          const itemClassesResponse = yield api.item.classes();
          setItemClasses(itemClassesResponse);
        } catch (e) {
          console.error(e);
          Sentry.captureException(e);
          if (e instanceof Error) setError(e.message);
        }
      });
    }
  }, [api]);
  useEffect(() => {
    const tracker = events.createTracker();
    itemModels.forEach(itemModel => {
      tracker.on(`mqtt:item/model/${itemModel._id}/update`, () => replaceItemModel(itemModel._id));
    });
    function replaceItemModel(id) {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          const itemModelResponse = (yield api.item.models({
            _id: id
          }))[0];
          setItemModels(prevModels => prevModels.map(model => {
            if (model._id === id) {
              return Object.assign(Object.assign({}, model), itemModelResponse);
            }
            return model;
          }));
        } catch (e) {
          console.error(e);
          Sentry.captureException(e);
          if (e instanceof Error) setError(e.message);
        }
      });
    }
    return () => {
      tracker.off();
    };
  }, [itemModels]);
  useEffect(() => {
    fetchItemModels();
    function buildQuery() {
      let query = {};
      if (classFilter.length > 0) {
        query = {
          itemClass: {
            $in: classFilter
          }
        };
      }
      if (makeFilter.length > 0) {
        query = Object.assign(Object.assign({}, query), {
          make: {
            $in: makeFilter
          }
        });
      }
      if (search) {
        const cleanSearch = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        query = Object.assign(Object.assign({}, query), {
          $or: [{
            modelName: {
              $regex: cleanSearch,
              $options: 'i'
            }
          }, {
            modelNumber: {
              $regex: cleanSearch,
              $options: 'i'
            }
          }]
        });
      }
      return query;
    }
    function fetchItemModels() {
      return __awaiter(this, void 0, void 0, function* () {
        const pagination = {
          page,
          limit: PAGE_LIMIT$6
        };
        const query = buildQuery();
        try {
          setIsLoading(true);
          const itemModelsResponse = yield api.item.models(query, pagination);
          setItemModels(prevItemModels => prevItemModels.concat(itemModelsResponse));
          setIsLoading(false);
        } catch (e) {
          setIsLoading(false);
          console.error(e);
          Sentry.captureException(e);
          if (e instanceof Error) setError(e.message);
        }
      });
    }
  }, [api, makeFilter, classFilter, search, page]);
  const filterByMake = make => {
    setItemModels([]);
    setMakeFilter(make);
  };
  const filterByClass = value => {
    setItemModels([]);
    setClassFilter(value);
  };
  const filterBySearch = search => {
    setItemModels([]);
    setSearch(search);
  };
  const nextPage = () => {
    setPage(prevPage => prevPage + 1);
  };
  return {
    nextPage,
    filterByMake,
    filterByClass,
    filterBySearch,
    error,
    isLoading,
    itemModels,
    itemMakes,
    itemClasses
  };
};

const PAGE_LIMIT$5 = 32;
const KitModelsContext = /*#__PURE__*/createContext(null);
const KitModelsProvider = ({
  children
}) => {
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.events || !resources.api || !resources.config) throw new Error('Missing required resources {api, events, config}');
  const manager = KitModelsManager(resources);
  return jsx(KitModelsContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const useKitModels = () => {
  const context = useContext(KitModelsContext);
  if (context === undefined || context === null) {
    throw new Error('useKitModels used outside of its Provider');
  }
  return context;
};
const KitModelsManager = ({
  api,
  events
}) => {
  const [kitModels, setKitModels] = useState([]);
  const [itemClasses, setItemClasses] = useState([]);
  const [request, setRequest] = useState({
    page: 0,
    item: [],
    search: ''
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  useEffect(() => {
    fetchItemClasses();
    function fetchItemClasses() {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          const itemClassesResponse = yield api.item.classes(); //?
          setItemClasses(itemClassesResponse);
        } catch (e) {
          console.error(e);
          Sentry.captureException(e);
          if (e instanceof Error) setError(e.message);
        }
      });
    }
  }, [api]);
  useEffect(() => {
    const tracker = events.createTracker();
    kitModels.forEach(kitModel => {
      tracker.on(`mqtt:kit/model/${kitModel._id}/update`, () => replaceKitModel(kitModel._id));
    });
    function replaceKitModel(id) {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          const kitModelResponse = (yield api.kit.models({
            _id: id
          }))[0];
          setKitModels(prevKitModels => prevKitModels.map(model => {
            if (model._id === id) {
              return Object.assign(Object.assign({}, model), kitModelResponse);
            }
            return model;
          }));
        } catch (e) {
          console.error(e);
          Sentry.captureException(e);
          if (e instanceof Error) setError(e.message);
        }
      });
    }
    return () => {
      tracker.off();
    };
  }, [kitModels]);
  useEffect(() => {
    fetchKitModels();
    function buildQuery() {
      const {
        item,
        search,
        page
      } = request;
      let query = {};
      if (item.length > 0) {
        query = {
          'itemModelDetails.itemClass': {
            $in: item
          }
        };
      }
      if (search) {
        const cleanSearch = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        query = Object.assign(Object.assign({}, query), {
          $or: [{
            modelNumber: {
              $regex: cleanSearch,
              $options: 'i'
            }
          }, {
            modelName: {
              $regex: cleanSearch,
              $options: 'i'
            }
          }]
        });
      }
      const pagination = {
        page,
        limit: PAGE_LIMIT$5
      };
      return {
        query,
        pagination
      };
    }
    function fetchKitModels() {
      return __awaiter(this, void 0, void 0, function* () {
        const makeQuery = buildQuery();
        try {
          setIsLoading(true);
          const kitModelsResponse = yield api.kit.models(makeQuery.query, makeQuery.pagination);
          setKitModels(prevKitModels => prevKitModels.concat(kitModelsResponse));
          setIsLoading(false);
        } catch (e) {
          setIsLoading(false);
          console.error(e);
          Sentry.captureException(e);
          if (e instanceof Error) setError(e.message);
        }
      });
    }
  }, [api, events, request]);
  const filterByItem = item => {
    setKitModels([]);
    setRequest(prevQuery => Object.assign(Object.assign({}, prevQuery), {
      item,
      page: 0
    }));
  };
  const filterBySearch = search => {
    setKitModels([]);
    setRequest(prevQuery => Object.assign(Object.assign({}, prevQuery), {
      search,
      page: 0
    }));
  };
  const nextPage = useCallback(() => {
    setRequest(prevQuery => Object.assign(Object.assign({}, prevQuery), {
      page: prevQuery.page + 1
    }));
  }, []);
  return {
    nextPage,
    filterBySearch,
    filterByItem,
    isLoading,
    itemClasses,
    error,
    kitModels
  };
};

const OrganizationNamesContext = /*#__PURE__*/createContext(null);
const OrganizationNamesProvider = ({
  children
}) => {
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.events || !resources.api || !resources.config) throw new Error('Missing required resources {api, events, config}');
  const manager = OrganizationNamesManager(resources);
  return jsx(OrganizationNamesContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const useOrganizationNames = () => {
  const context = useContext(OrganizationNamesContext);
  if (context === undefined || context === null) {
    throw new Error('useOrganizationNames used outside of its Provider');
  }
  return context;
};
const OrganizationNamesManager = ({
  api
}) => {
  const [orgIds, setOrgIds] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const organizationMap = useMemo(() => organizations.reduce((result, org) => {
    result[org._id] = org;
    return result;
  }, {}), [organizations]) || {};
  useEffect(() => {
    if (orgIds.length) {
      fetchOrganizations(orgIds);
    }
    function fetchOrganizations(ids) {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          const response = yield api.org.names(ids);
          setOrganizations(prevOrganizations => prevOrganizations.concat(response));
        } catch (e) {
          console.error(e);
          Sentry.captureException(e);
        }
      });
    }
  }, [api, orgIds]);
  const trackOrgs = useCallback(ids => {
    if (!ids || !ids.length) return;
    setOrgIds(prevOrgIds => Array.from(new Set(prevOrgIds.concat(ids))));
  }, []);
  return {
    trackOrgs,
    organizationMap,
    organizations
  };
};

const KitStates = ['assigned', 'shipping', 'received', 'setup', 'return-prep', 'returning', 'returned', 'dismantling', 'dismantled'];
const PatientStates = ['new', 'consented', 'waiting-for-onboarding', 'on-boarded', 'active-care', 'maintenance', 'discharged', 'inactive', 'on-hold'];
const PAGE_LIMIT$4 = 15;
const KitAssignmentContext = /*#__PURE__*/createContext(null);
const KitAssignmentProvider = ({
  children
}) => {
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.events || !resources.api || !resources.config) throw new Error('Missing required resources {api, events, config}');
  const manager = KitAssignmentManager(resources);
  return jsx(KitAssignmentContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const useKitAssignment = () => {
  const context = useContext(KitAssignmentContext);
  if (context === undefined || context === null) {
    throw new Error('useKitAssignment used outside of its Provider');
  }
  return context;
};
const KitAssignmentManager = ({
  api,
  events
}) => {
  const [kitAssignments, setKitAssignments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  const [request, setRequest] = useState({
    page: 0,
    kitFilter: [],
    patientFilter: [],
    orgFilter: [],
    search: ''
  });
  const {
    trackOrgs
  } = useOrganizationNames();
  useEffect(() => {
    fetchKitAssignmentData();
    function buildQuery() {
      const {
        page,
        kitFilter,
        patientFilter,
        orgFilter,
        search
      } = request;
      let query = {};
      const searchConditions = [];
      if (patientFilter.length > 0) {
        query = {
          'patient.state': {
            $in: patientFilter
          }
        };
      }
      if (orgFilter.length > 0) {
        query = Object.assign(Object.assign({}, query), {
          organizationId: orgFilter
        });
      }
      if (kitFilter.length > 0) {
        query = Object.assign(Object.assign({}, query), {
          kitStates: kitFilter
        });
      }
      const noSpaceSearchFields = ['patient.fname', 'patient.lname', 'patient.search', 'patient.searchr', 'patient.patientNumber'];
      const escapedSearchFields = ['kitModel.modelNumber', 'kitModel.modelName', 'kit.serialNumber'];
      const shippingAddressFields = ['shippingAddress.phone', 'shippingAddress.phone2'];
      const isObjectId = /^[0-9a-fA-F]{24}$/.test(search);
      if (isObjectId) {
        query = Object.assign(Object.assign({}, query), {
          _id: search
        });
      } else {
        const cleanSearchWithNoSpaces = search.replace(/\W/g, '');
        const searchWithEscapedCharacters = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        if (search) {
          noSpaceSearchFields.forEach(field => {
            searchConditions.push({
              [field]: {
                $regex: cleanSearchWithNoSpaces,
                $options: 'i'
              }
            });
          });
          escapedSearchFields.forEach(field => {
            searchConditions.push({
              [field]: {
                $regex: searchWithEscapedCharacters,
                $options: 'i'
              }
            });
          });
          const isNumericSearch = /^\d+$/.test(search);
          if (isNumericSearch) {
            const normalizedPhoneSearch = search.replace(/\D/g, '');
            const phoneSearchPattern = normalizedPhoneSearch.split('').join('\\D*');
            shippingAddressFields.forEach(field => {
              searchConditions.push({
                [field]: {
                  $regex: phoneSearchPattern,
                  $options: 'i'
                }
              });
            });
          }
        }
        if (searchConditions.length > 0) {
          query.$or = searchConditions;
        }
      }
      const pagination = {
        page,
        limit: PAGE_LIMIT$4
      };
      return {
        query,
        pagination
      };
    }
    function fetchKitAssignmentData() {
      return __awaiter(this, void 0, void 0, function* () {
        const makeQuery = buildQuery();
        try {
          setIsLoading(true);
          const kitAssignmentResponse = yield api.kit.assignments(makeQuery.query, makeQuery.pagination);
          setKitAssignments(prevKitAssignments => {
            const newAssignments = prevKitAssignments.concat(kitAssignmentResponse);
            const ids = new Set(newAssignments.map(assignment => assignment._id));
            // Filter out any assignments that are already in the state
            return newAssignments.filter(assignment => {
              if (ids.has(assignment._id)) {
                ids.delete(assignment._id);
                return true;
              }
              return false;
            });
          });
          setIsLoading(false);
          const orgsToTrack = kitAssignmentResponse.map(assignment => {
            var _a;
            return (_a = assignment === null || assignment === void 0 ? void 0 : assignment.patient) === null || _a === void 0 ? void 0 : _a.organization;
          }).filter(k => !!k);
          trackOrgs(orgsToTrack);
        } catch (e) {
          setIsLoading(false);
          console.error(e);
          Sentry.captureException(e);
          if (e instanceof Error) setError(e.message);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [api, request]);
  useEffect(() => {
    const tracker = events.createTracker();
    kitAssignments.forEach(kitAssignment => {
      tracker.on(`mqtt:kit/assignment/${kitAssignment._id}/request`, () => replaceKitAssignment(kitAssignment._id));
      tracker.on(`mqtt:kit/assignment/${kitAssignment._id}/update`, () => replaceKitAssignment(kitAssignment._id));
      tracker.on(`mqtt:kit/assignment/${kitAssignment._id}/cancel`, () => {
        setKitAssignments(prevKitAssignments => prevKitAssignments.filter(assignment => assignment._id === kitAssignment._id));
      });
      if (kitAssignment.kitId) tracker.on(`mqtt:kit/${kitAssignment.kitId}/state`, ({
        toState
      }) => {
        setKitAssignments(prevAssignments => prevAssignments.map(assignment => {
          if (assignment.kit && assignment._id === kitAssignment._id) {
            return Object.assign(Object.assign({}, assignment), {
              kit: Object.assign(Object.assign({}, assignment === null || assignment === void 0 ? void 0 : assignment.kit), {
                state: toState
              })
            });
          }
          return assignment;
        }));
      });
    });
    function replaceKitAssignment(id) {
      var _a;
      return __awaiter(this, void 0, void 0, function* () {
        try {
          const kitAssignmentResponse = (yield api.kit.assignments({
            _id: id
          }))[0];
          setKitAssignments(prevKitAssignments => prevKitAssignments.map(asmnt => {
            if (asmnt._id === id) {
              return Object.assign(Object.assign({}, asmnt), kitAssignmentResponse);
            }
            return asmnt;
          }));
          trackOrgs([(_a = kitAssignmentResponse === null || kitAssignmentResponse === void 0 ? void 0 : kitAssignmentResponse.patient) === null || _a === void 0 ? void 0 : _a.organization]);
        } catch (e) {
          console.error(e);
          Sentry.captureException(e);
          if (e instanceof Error) setError(e.message);
        }
      });
    }
    return () => {
      tracker.off();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [api, events, kitAssignments]);
  const AssignKit = useCallback((assignmentId, kitId) => __awaiter(void 0, void 0, void 0, function* () {
    const update = kitId ? {
      kitId: kitId
    } : {};
    try {
      yield api.kit.assignment.update(assignmentId, update);
    } catch (e) {
      console.error(e);
      Sentry.captureException(e);
      if (e instanceof Error) setError(e.message);
    }
  }), [api]);
  const AddNote = useCallback((assignmentId, sender, note) => __awaiter(void 0, void 0, void 0, function* () {
    const update = {
      notes: [{
        sender,
        comment: note,
        timestamp: new Date()
      }]
    };
    try {
      yield api.kit.assignment.update(assignmentId, update);
    } catch (e) {
      console.error(e);
      Sentry.captureException(e);
      if (e instanceof Error) setError(e.message);
    }
  }), [api]);
  const fetchAssignment = useCallback(assignmentId => __awaiter(void 0, void 0, void 0, function* () {
    try {
      const found = kitAssignments.find(element => element._id === assignmentId);
      if (!found) {
        const assignment = yield api.kit.assignments({
          _id: assignmentId
        });
        setKitAssignments(prevAssignments => {
          const exists = prevAssignments.find(prevAssignment => prevAssignment._id === assignment._id);
          if (!exists) {
            return prevAssignments.concat(assignment);
          }
          return prevAssignments;
        });
      }
    } catch (e) {
      console.error(e);
      Sentry.captureException(e);
      if (e instanceof Error) setError(e.message);
    }
  }), [api, kitAssignments]);
  const filterBySearch = useCallback(search => {
    setKitAssignments([]);
    setRequest(prevQuery => Object.assign(Object.assign({}, prevQuery), {
      search,
      page: 0
    }));
  }, []);
  const filterByKitState = useCallback(state => {
    const kitState = state.map(s => s.replace(/ /g, '-').toLowerCase());
    setKitAssignments([]);
    setRequest(prevQuery => Object.assign(Object.assign({}, prevQuery), {
      kitFilter: kitState,
      page: 0
    }));
  }, []);
  const filterByPatientState = useCallback(state => {
    const patientState = state.map(s => s.replace(/ /g, '-').toLowerCase());
    setKitAssignments([]);
    setRequest(prevQuery => Object.assign(Object.assign({}, prevQuery), {
      patientFilter: patientState,
      page: 0
    }));
  }, []);
  const filterByOrg = useCallback(orgId => {
    setKitAssignments([]);
    setRequest(prevQuery => Object.assign(Object.assign({}, prevQuery), {
      orgFilter: orgId,
      page: 0
    }));
  }, []);
  const nextPage = useCallback(() => {
    setRequest(prevQuery => Object.assign(Object.assign({}, prevQuery), {
      page: prevQuery.page + 1
    }));
  }, []);
  return {
    kitAssignments,
    isLoading,
    AssignKit,
    fetchAssignment,
    AddNote,
    filterByKitState,
    filterByPatientState,
    filterByOrg,
    nextPage,
    filterBySearch,
    error
  };
};

var isCallable$1 = isCallable$p;
var isObject = isObject$c;
var setPrototypeOf = objectSetPrototypeOf;

// makes subclassing work correct for wrapped built-ins
var inheritIfRequired$1 = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable$1(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};

var defineProperty = objectDefineProperty.f;

var proxyAccessor$1 = function (Target, Source, key) {
  key in Target || defineProperty(Target, key, {
    configurable: true,
    get: function () { return Source[key]; },
    set: function (it) { Source[key] = it; }
  });
};

var DESCRIPTORS$1 = descriptors;
var global$2 = global$p;
var uncurryThis$2 = functionUncurryThis;
var isForced = isForced_1;
var inheritIfRequired = inheritIfRequired$1;
var createNonEnumerableProperty = createNonEnumerableProperty$6;
var getOwnPropertyNames = objectGetOwnPropertyNames.f;
var isPrototypeOf$1 = objectIsPrototypeOf;
var isRegExp = isRegexp;
var toString$3 = toString$a;
var getRegExpFlags = regexpGetFlags;
var stickyHelpers = regexpStickyHelpers;
var proxyAccessor = proxyAccessor$1;
var defineBuiltIn = defineBuiltIn$b;
var fails$1 = fails$o;
var hasOwn$1 = hasOwnProperty_1;
var enforceInternalState = internalState.enforce;
var setSpecies = setSpecies$2;
var wellKnownSymbol = wellKnownSymbol$m;
var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG = regexpUnsupportedNcg;

var MATCH = wellKnownSymbol('match');
var NativeRegExp = global$2.RegExp;
var RegExpPrototype = NativeRegExp.prototype;
var SyntaxError = global$2.SyntaxError;
var exec = uncurryThis$2(RegExpPrototype.exec);
var charAt = uncurryThis$2(''.charAt);
var replace$1 = uncurryThis$2(''.replace);
var stringIndexOf = uncurryThis$2(''.indexOf);
var stringSlice$1 = uncurryThis$2(''.slice);
// TODO: Use only proper RegExpIdentifierName
var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var MISSED_STICKY = stickyHelpers.MISSED_STICKY;
var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;

var BASE_FORCED = DESCRIPTORS$1 &&
  (!CORRECT_NEW || MISSED_STICKY || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG || fails$1(function () {
    re2[MATCH] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return NativeRegExp(re1) !== re1 || NativeRegExp(re2) === re2 || String(NativeRegExp(re1, 'i')) !== '/a/i';
  }));

var handleDotAll = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var brackets = false;
  var chr;
  for (; index <= length; index++) {
    chr = charAt(string, index);
    if (chr === '\\') {
      result += chr + charAt(string, ++index);
      continue;
    }
    if (!brackets && chr === '.') {
      result += '[\\s\\S]';
    } else {
      if (chr === '[') {
        brackets = true;
      } else if (chr === ']') {
        brackets = false;
      } result += chr;
    }
  } return result;
};

var handleNCG = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var named = [];
  var names = {};
  var brackets = false;
  var ncg = false;
  var groupid = 0;
  var groupname = '';
  var chr;
  for (; index <= length; index++) {
    chr = charAt(string, index);
    if (chr === '\\') {
      chr += charAt(string, ++index);
    } else if (chr === ']') {
      brackets = false;
    } else if (!brackets) switch (true) {
      case chr === '[':
        brackets = true;
        break;
      case chr === '(':
        if (exec(IS_NCG, stringSlice$1(string, index + 1))) {
          index += 2;
          ncg = true;
        }
        result += chr;
        groupid++;
        continue;
      case chr === '>' && ncg:
        if (groupname === '' || hasOwn$1(names, groupname)) {
          throw new SyntaxError('Invalid capture group name');
        }
        names[groupname] = true;
        named[named.length] = [groupname, groupid];
        ncg = false;
        groupname = '';
        continue;
    }
    if (ncg) groupname += chr;
    else result += chr;
  } return [result, named];
};

// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if (isForced('RegExp', BASE_FORCED)) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = isPrototypeOf$1(RegExpPrototype, this);
    var patternIsRegExp = isRegExp(pattern);
    var flagsAreUndefined = flags === undefined;
    var groups = [];
    var rawPattern = pattern;
    var rawFlags, dotAll, sticky, handled, result, state;

    if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
      return pattern;
    }

    if (patternIsRegExp || isPrototypeOf$1(RegExpPrototype, pattern)) {
      pattern = pattern.source;
      if (flagsAreUndefined) flags = getRegExpFlags(rawPattern);
    }

    pattern = pattern === undefined ? '' : toString$3(pattern);
    flags = flags === undefined ? '' : toString$3(flags);
    rawPattern = pattern;

    if (UNSUPPORTED_DOT_ALL && 'dotAll' in re1) {
      dotAll = !!flags && stringIndexOf(flags, 's') > -1;
      if (dotAll) flags = replace$1(flags, /s/g, '');
    }

    rawFlags = flags;

    if (MISSED_STICKY && 'sticky' in re1) {
      sticky = !!flags && stringIndexOf(flags, 'y') > -1;
      if (sticky && UNSUPPORTED_Y) flags = replace$1(flags, /y/g, '');
    }

    if (UNSUPPORTED_NCG) {
      handled = handleNCG(pattern);
      pattern = handled[0];
      groups = handled[1];
    }

    result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype, RegExpWrapper);

    if (dotAll || sticky || groups.length) {
      state = enforceInternalState(result);
      if (dotAll) {
        state.dotAll = true;
        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
      }
      if (sticky) state.sticky = true;
      if (groups.length) state.groups = groups;
    }

    if (pattern !== rawPattern) try {
      // fails in old engines, but we have no alternatives for unsupported regex syntax
      createNonEnumerableProperty(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
    } catch (error) { /* empty */ }

    return result;
  };

  for (var keys = getOwnPropertyNames(NativeRegExp), index = 0; keys.length > index;) {
    proxyAccessor(RegExpWrapper, NativeRegExp, keys[index++]);
  }

  RegExpPrototype.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype;
  defineBuiltIn(global$2, 'RegExp', RegExpWrapper, { constructor: true });
}

// https://tc39.es/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');

var call = functionCall;
var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var anObject = anObject$i;
var isNullOrUndefined = isNullOrUndefined$7;
var toLength = toLength$3;
var toString$2 = toString$a;
var requireObjectCoercible = requireObjectCoercible$7;
var getMethod = getMethod$6;
var advanceStringIndex = advanceStringIndex$2;
var regExpExec = regexpExecAbstract;

// @@match logic
fixRegExpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, MATCH);
      return matcher ? call(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString$2(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject(this);
      var S = toString$2(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = toString$2(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});

const PatientGroupContext = /*#__PURE__*/React__default.createContext(null);
const PatientGroupProvider = ({
  children
}) => {
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.events || !resources.api || !resources.config) {
    throw new Error('PatientGroupProvider must be used within a ResourcesProvider');
  }
  const PatientGroup = PatientGroupManager(resources);
  return jsx(PatientGroupContext.Provider, Object.assign({
    value: PatientGroup
  }, {
    children: children
  }));
};
const usePatientGroup = () => {
  const context = useContext(PatientGroupContext);
  if (context === undefined || context === null) {
    throw new Error('usePatientGroup used outside of its Provider');
  }
  return context;
};
const PatientGroupManager = ({
  api,
  events,
  config
}) => {
  const {
    setApiResponse
  } = usePatients();
  const [query, setQuery] = useState('');
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [rawPatientGroupData, setRawPatientGroupData] = useState([]);
  useEffect(() => {
    const fetchPatientGroup = () => __awaiter(void 0, void 0, void 0, function* () {
      setLoading(true);
      const PatientGroup = yield api.org.managergroups.list(page);
      const terms = query.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&').split(' ').join('');
      const regex = new RegExp(terms, 'i');
      const filtered = PatientGroup.filter(item => {
        const name = item.name;
        const matches = name.split(' ').join('').match(regex);
        if (matches) return item;
        return false;
      });
      setRawPatientGroupData(filtered);
      setLoading(false);
    });
    fetchPatientGroup();
  }, [api, events, config, query, page]);
  const assignUsersToManageGroup = useCallback((users, manageGroup) => {
    return assign(users, manageGroup);
    function assign(users, manageGroup) {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          yield api.org.managergroups.assignUsersToManageGroup(users, manageGroup);
          setApiResponse({
            status: 200,
            message: "User's group update successfully",
            open: true,
            serverity: 'success'
          });
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
          setApiResponse({
            status: e.status || 500,
            message: e.response ? e.response.message : 'Error',
            open: true,
            serverity: 'error'
          });
        }
      });
    }
  }, [api]);
  const removeUsersFromManageGroups = useCallback(users => {
    return remove(users);
    function remove(users) {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          yield api.org.managergroups.removeUsersFromManageGroups(users);
          setApiResponse({
            status: 200,
            message: "User's group update successfully",
            open: true,
            serverity: 'success'
          });
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
          setApiResponse({
            status: e.status || 500,
            message: e.response ? e.response.message : 'Error',
            open: true,
            serverity: 'error'
          });
        }
      });
    }
  }, [api]);
  return {
    rawPatientGroupData,
    query,
    page,
    loading,
    setQuery,
    setPage,
    assignUsersToManageGroup,
    removeUsersFromManageGroups
  };
};

const KitContext = /*#__PURE__*/createContext(null);
const PAGE_LIMIT$3 = 1000;
const KitProvider = ({
  children
}) => {
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.events || !resources.api || !resources.config) throw new Error('Missing required resources {api, events, config}');
  const manager = KitManager(resources);
  return jsx(KitContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const useKit = () => {
  const context = useContext(KitContext);
  if (context === undefined || context === null) {
    throw new Error('useKit used outside of its Provider');
  }
  return context;
};
const KitManager = ({
  api,
  events
}) => {
  const [kits, setKits] = useState([]);
  const [kitModelFilter, setKitModelFilter] = useState('');
  const [kitStateFilter, setKitStateFilter] = useState('');
  const [page, setPage] = useState(0);
  const [error, setError] = useState('');
  const [apiResponse, setApiResponse] = useState({
    message: '',
    response: {},
    status: 0,
    severity: 'success',
    open: false
  });
  useEffect(() => {
    fetchKitData();
    function buildQuery() {
      let query = {};
      if (kitModelFilter) {
        query = {
          modelId: kitModelFilter
        };
      }
      if (kitStateFilter) {
        query = Object.assign(Object.assign({}, query), {
          state: kitStateFilter
        });
      }
      return query;
    }
    function fetchKitData() {
      return __awaiter(this, void 0, void 0, function* () {
        const pagination = {
          page,
          limit: PAGE_LIMIT$3
        };
        const query = buildQuery();
        try {
          const kitResponse = yield api.kit.kits(query, pagination);
          setKits(prevKits => prevKits.concat(kitResponse));
        } catch (e) {
          console.error(e);
          Sentry.captureException(e);
          if (e instanceof Error) setError(e.message);
        }
      });
    }
  }, [api, events, kitModelFilter, kitStateFilter, page]);
  useEffect(() => {
    const tracker = events.createTracker();
    kits.forEach(kit => {
      if (kit._id) tracker.on(`mqtt:kit/${kit._id}/state`, ({
        toState
      }) => {
        setKits(prevKits => prevKits.map(k => {
          if (k._id === kit._id) {
            return Object.assign(Object.assign({}, k), {
              state: toState
            });
          }
          return k;
        }));
      });
    });
    return () => {
      tracker.off();
    };
  }, [kits, events]);
  const addKit = useCallback((kitModelId, items) => __awaiter(void 0, void 0, void 0, function* () {
    try {
      yield api.kit.create(kitModelId, items);
    } catch (e) {
      console.error(e);
      Sentry.captureException(e);
      if (e instanceof Error) setError(e.message);
    }
  }), [api]);
  const deleteKit = useCallback(kitId => __awaiter(void 0, void 0, void 0, function* () {
    try {
      yield api.kit.delete(kitId);
    } catch (e) {
      console.error(e);
      Sentry.captureException(e);
      if (e instanceof Error) setError(e.message);
    }
  }), [api]);
  const changeKitState = useCallback((kitId, nextState) => __awaiter(void 0, void 0, void 0, function* () {
    try {
      yield api.kit.state(kitId, nextState);
    } catch (e) {
      console.error(e);
      Sentry.captureException(e);
      if (e instanceof Error) setError(e.message);
    }
  }), [api]);
  const filterKits = useCallback((kitModelId, kitState) => {
    setKits([]);
    if (kitModelId) {
      setKitModelFilter(kitModelId);
    }
    if (kitState) {
      setKitStateFilter(kitState);
    }
  }, []);
  const requestKit = useCallback(({
    kitModelId,
    patientId,
    shippingAddress,
    note,
    requestByDate
  }) => {
    const kitRequest = {
      kitModelId,
      patientId,
      shippingAddress,
      note,
      requestByDate
    };
    function sendKitRequest(kitRequest) {
      return __awaiter(this, void 0, void 0, function* () {
        let apiResponse;
        try {
          const {
            assignment
          } = yield api.kit.request(kitRequest);
          apiResponse = {
            status: 200,
            message: 'Kit request sent',
            severity: 'success',
            open: true,
            response: assignment
          };
        } catch (e) {
          console.error(e);
          Sentry.captureException(e);
          apiResponse = {
            status: e.status,
            message: e.response ? e.response.message : 'Error requesting kit',
            open: true,
            response: e.response,
            severity: 'error'
          };
        }
        setApiResponse(apiResponse);
        return apiResponse;
      });
    }
    return sendKitRequest(kitRequest);
  }, [api]);
  const getKitByAssignmentId = useCallback(assignmentId => __awaiter(void 0, void 0, void 0, function* () {
    try {
      const assignment = yield api.kit.assignments({
        _id: assignmentId
      });
      const kitId = assignment[0].kitId;
      if (kitId) {
        const kit = yield api.kit.kits({
          _id: kitId
        });
        const foundKit = kit[0];
        if (foundKit) {
          return foundKit;
        }
      }
    } catch (e) {
      console.error(e);
      Sentry.captureException(e);
      if (e instanceof Error) setError(e.message);
    }
    return false;
  }), [api]);
  const cancelRequest = useCallback(assignmentId => {
    api.kit.assignment.cancel(assignmentId);
  }, [api]);
  const nextPage = useCallback(() => {
    setPage(prevPage => prevPage + 1);
  }, []);
  return {
    kits,
    apiResponse,
    getKitByAssignmentId,
    addKit,
    deleteKit,
    changeKitState,
    filterKits,
    nextPage,
    requestKit,
    cancelRequest,
    error
  };
};

var tryToString = tryToString$5;

var $TypeError = TypeError;

var deletePropertyOrThrow$1 = function (O, P) {
  if (!delete O[P]) throw new $TypeError('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
};

var userAgent$1 = engineUserAgent;

var firefox = userAgent$1.match(/firefox\/(\d+)/i);

var engineFfVersion = !!firefox && +firefox[1];

var UA = engineUserAgent;

var engineIsIeOrEdge = /MSIE|Trident/.test(UA);

var userAgent = engineUserAgent;

var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);

var engineWebkitVersion = !!webkit && +webkit[1];

var $$1 = _export;
var uncurryThis$1 = functionUncurryThis;
var aCallable = aCallable$a;
var toObject = toObject$8;
var lengthOfArrayLike = lengthOfArrayLike$8;
var deletePropertyOrThrow = deletePropertyOrThrow$1;
var toString$1 = toString$a;
var fails = fails$o;
var internalSort = arraySort$1;
var arrayMethodIsStrict = arrayMethodIsStrict$2;
var FF = engineFfVersion;
var IE_OR_EDGE = engineIsIeOrEdge;
var V8 = engineV8Version;
var WEBKIT = engineWebkitVersion;

var test = [];
var nativeSort = uncurryThis$1(test.sort);
var push = uncurryThis$1(test.push);

// IE8-
var FAILS_ON_UNDEFINED = fails(function () {
  test.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails(function () {
  test.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict('sort');

var STABLE_SORT = !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 70;
  if (FF && FF > 3) return;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 603;

  var result = '';
  var code, chr, value, index;

  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66: case 69: case 70: case 72: value = 3; break;
      case 68: case 71: value = 4; break;
      default: value = 2;
    }

    for (index = 0; index < 47; index++) {
      test.push({ k: chr + index, v: value });
    }
  }

  test.sort(function (a, b) { return b.v - a.v; });

  for (index = 0; index < test.length; index++) {
    chr = test[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});

var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString$1(x) > toString$1(y) ? 1 : -1;
  };
};

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$$1({ target: 'Array', proto: true, forced: FORCED }, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aCallable(comparefn);

    var array = toObject(this);

    if (STABLE_SORT) return comparefn === undefined ? nativeSort(array) : nativeSort(array, comparefn);

    var items = [];
    var arrayLength = lengthOfArrayLike(array);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) push(items, array[index]);
    }

    internalSort(items, getSortCompare(comparefn));

    itemsLength = lengthOfArrayLike(items);
    index = 0;

    while (index < itemsLength) array[index] = items[index++];
    while (index < arrayLength) deletePropertyOrThrow(array, index++);

    return array;
  }
});

const AllPatientsContext = /*#__PURE__*/createContext(null);
const AllPatientsProvider = _a => {
  var {
      children
    } = _a,
    params = __rest(_a, ["children"]);
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.events || !resources.api || !resources.config) throw new Error('Missing required resources {api, events, config}');
  const manager = allPatientsManager(resources, params);
  return jsx(AllPatientsContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const useAllPatients = () => {
  const context = useContext(AllPatientsContext);
  if (context == null) {
    throw new Error('useAllPatients used outside of its Provider');
  }
  return context;
};
const allPatientsManager = ({
  api,
  events,
  config
}, params) => {
  const {
    orgGroup: initialOrgGroup,
    fields: initialFields
  } = params || {};
  const [orgGroup, setOrgGroup] = useState(initialOrgGroup);
  const [fields, setFields] = useState(initialFields);
  const [patients, setAllPatients] = useState(null);
  const [patientsMap, setAllPatientsMap] = useState(null);
  const [patientsByName, setAllPatientsByName] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchAllPatientsData = () => __awaiter(void 0, void 0, void 0, function* () {
      try {
        setLoading(true);
        let retrievedAllPatients = yield api.org.patients.list({
          orgGroup,
          fields
        });
        if (retrievedAllPatients == null) {
          retrievedAllPatients = [];
        }
        setAllPatients(retrievedAllPatients);
        setAllPatientsMap(dbEntriesToMap$2(retrievedAllPatients));
        const patientsByNameResult = getPatientsByName(retrievedAllPatients);
        setAllPatientsByName(patientsByNameResult);
        setLoading(false);
      } catch (e) {
        Sentry.captureException(e);
        console.error(e);
        setLoading(false);
      }
    });
    fetchAllPatientsData();
  }, [api, config, events, initialFields, fields, initialOrgGroup, orgGroup]);
  return {
    patientsByName,
    patients,
    patientsMap,
    loading,
    setFields,
    setOrgGroup
  };
};
function dbEntriesToMap$2(entries) {
  if (entries == null) {
    return null;
  }
  const results = {};
  return entries.reduce((map, entry) => {
    map[entry._id.toString()] = entry;
    return map;
  }, results);
}
function getPatientsByName(patients) {
  if (patients == null) {
    return null;
  }
  return patients.sort((a, b) => `${a === null || a === void 0 ? void 0 : a.lname}, ${a === null || a === void 0 ? void 0 : a.fname}`.localeCompare(`${b.lname}, ${b.fname}`));
}

const OrgGroupsContext = /*#__PURE__*/createContext(null);
const OrgGroupsProvider = ({
  children
}) => {
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.events || !resources.api || !resources.config) throw new Error('Missing required resources {api, events, config}');
  const manager = orgGroupsManager(resources);
  return jsx(OrgGroupsContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const useOrgGroups = () => {
  const context = useContext(OrgGroupsContext);
  if (context == null) {
    throw new Error('useOrgGroupss used outside of its Provider');
  }
  return context;
};
const orgGroupsManager = ({
  api,
  events,
  config
}) => {
  const [orgGroups, setOrgGroups] = useState(null);
  const [orgGroupsMap, setOrgGroupsMap] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchOrgGroups = () => __awaiter(void 0, void 0, void 0, function* () {
      setLoading(true);
      try {
        const orgGroups = yield api.org.group.list();
        setOrgGroups(orgGroups);
        setOrgGroupsMap(dbEntriesToMap$1(orgGroups));
      } catch (e) {
        Sentry.captureException(e);
        console.error(e);
      }
      setLoading(false);
    });
    fetchOrgGroups();
  }, [api, config, events]);
  return {
    orgGroups,
    orgGroupsMap,
    loading
  };
};
function dbEntriesToMap$1(entries) {
  if (entries == null) {
    return null;
  }
  const results = {};
  return entries.reduce((map, entry) => {
    map[entry._id.toString()] = entry;
    return map;
  }, results);
}

const CustomReportsListContext = /*#__PURE__*/createContext(null);
const CustomReportsListProvider = ({
  children
}) => {
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.events || !resources.api || !resources.config) throw new Error('Missing required resources {api, events, config}');
  const manager = customReportsListManager(resources);
  return jsx(CustomReportsListContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const useCustomReportsList = () => {
  const context = useContext(CustomReportsListContext);
  if (context == null) {
    throw new Error('useCustomReports used outside of its Provider');
  }
  return context;
};
const customReportsListManager = ({
  api,
  events,
  config
}) => {
  const [customReports, setCustomReports] = useState(null);
  const [customReportsMap, setCustomReportsMap] = useState(null);
  const [loading, setLoading] = useState(true);
  const customReportsByName = React__default.useMemo(() => (customReports || []).sort((a, b) => (a.schema.name || '').localeCompare(b.schema.name || '')), [customReports]);
  useEffect(() => {
    const fetchCustomReportsData = () => __awaiter(void 0, void 0, void 0, function* () {
      try {
        setLoading(true);
        let retrievedCustomReports = yield api.org.customReports.list();
        if (retrievedCustomReports == null) {
          retrievedCustomReports = [];
        }
        setCustomReports(retrievedCustomReports);
        const customReportsMap = dbEntriesToMap(retrievedCustomReports);
        setCustomReportsMap(customReportsMap);
        setLoading(false);
      } catch (e) {
        Sentry.captureException(e);
        console.error(e);
        setLoading(false);
      }
    });
    fetchCustomReportsData();
  }, [api, config, events]);
  return {
    customReportsByName,
    customReports,
    customReportsMap,
    loading
  };
};
function dbEntriesToMap(entries) {
  if (entries == null) {
    return null;
  }
  const results = {};
  return entries.reduce((map, entry) => {
    map[entry._id.toString()] = entry;
    return map;
  }, results);
}

const MAX_REQUESTS$1 = 300;
const PeopleContext = /*#__PURE__*/createContext(null);
const PeopleProvider = ({
  children
}) => {
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.events || !resources.api || !resources.config) throw new Error('Missing required resources {api, events, config}');
  const manager = peopleManager(resources);
  return jsx(PeopleContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const usePeople = () => {
  const context = useContext(PeopleContext);
  if (context === undefined || context === null) {
    throw new Error('usePeople used outside of its Provider');
  }
  return context;
};
const peopleManager = ({
  api,
  events,
  config
}) => {
  const [rawPeople, setRawPeople] = useState([]);
  const [dataPeople, setDataPeople] = useState([]);
  const people = useMemo(() => dataPeople.reduce((result, person) => {
    result[person._id] = person;
    return result;
  }, {}), [dataPeople]);
  useEffect(() => {
    const fetchData = () => __awaiter(void 0, void 0, void 0, function* () {
      try {
        const chunks = [];
        const total = rawPeople.length;
        let group = 0;
        while (group < total) {
          chunks.push(rawPeople.slice(group, group + MAX_REQUESTS$1));
          group += MAX_REQUESTS$1;
        }
        const responses = yield Promise.all(chunks.map(api.people.public));
        setDataPeople(responses.flat());
      } catch (e) {
        Sentry.captureException(e);
        console.error(e);
      }
    });
    if (rawPeople.length) fetchData();
  }, [api, rawPeople]);
  useEffect(() => {
    const tracker = events.createTracker();
    const orgGroup = config === null || config === void 0 ? void 0 : config.orgGroup;
    dataPeople.forEach(user => {
      tracker.on(`mqtt:${orgGroup ? 'orggroup/' + orgGroup + '/' : ''}u/${user._id}/settings`, () => fetchPerson(user._id));
    });
    function fetchPerson(personId) {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          const response = yield api.people.public([personId]);
          setDataPeople(prevDataPeople => {
            const personIndex = prevDataPeople.findIndex(person => person._id === personId);
            prevDataPeople[personIndex] = response[0];
            return [...prevDataPeople];
          });
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
        }
      });
    }
    return () => {
      tracker.off();
    };
  }, [dataPeople]);
  const trackPerson = useCallback(userId => {
    const toTrack = [].concat(userId);
    const filtered = toTrack.filter(person => !rawPeople.includes(person));
    if (filtered.length) {
      setRawPeople(prevPeople => prevPeople.concat(filtered));
    }
  }, [rawPeople]);
  return {
    people,
    trackPerson
  };
};

const AdminOrganizationContext = /*#__PURE__*/createContext(null);
const AdminOrganizationProvider = ({
  children
}) => {
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.events || !resources.api) throw new Error('Missing {api, events} from resources');
  const manager = adminOrganizationManager(resources);
  return jsx(AdminOrganizationContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const useAdminOrganization = () => {
  const context = useContext(AdminOrganizationContext);
  if (context === undefined || context === null) {
    throw new Error('useAdminOrganization used outside of its Provider');
  }
  return context;
};
const adminOrganizationManager = ({
  events,
  api
}) => {
  const [requestQuery, setRequestQuery] = useState({
    page: 0,
    query: ''
  });
  const [rawOrganizations, setOrganizations] = useState([]);
  const [logisticsOrganizations, setLogisticsOrganizations] = useState([]);
  const {
    people,
    trackPerson
  } = usePeople();
  const organizations = useMemo(() => rawOrganizations.map(org => Object.assign(Object.assign({}, org), people[org.administrator] && {
    administratorData: people[org.administrator]
  })), [rawOrganizations, people]);
  useEffect(() => {
    function fetchOrganizations() {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          const response = yield api.admin.org.list(requestQuery.query, requestQuery.page);
          setOrganizations(prevOrganizations => prevOrganizations.concat(response));
          trackPerson(response.map(org => org.administrator));
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
        }
      });
    }
    fetchOrganizations();
  }, [api, requestQuery]);
  useEffect(() => {
    const tracker = events.createTracker();
    if (rawOrganizations.length) {
      rawOrganizations.forEach(organization => {
        events.on(`mqtt:org/${organization._id}/updated`, () => fetchOrganization(organization._id));
        events.on(`mqtt:org/${organization._id}/administrator/added`, () => fetchOrganization(organization._id));
        events.on(`mqtt:org/${organization._id}/administrator/removed`, () => fetchOrganization(organization._id));
        events.on(`mqtt:org/${organization._id}/feature/flags/updated`, () => {
          fetchOrganization(organization._id);
        });
      });
    }
    tracker.on('mqtt:orgs/created', org => setOrganizations(prevOrganizations => [org].concat(prevOrganizations)));
    function fetchOrganization(id) {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          const response = yield api.admin.org.data(id);
          if (response) {
            setOrganizations(prevOrganizations => prevOrganizations.map(org => {
              if (org._id === id) {
                return response;
              }
              return org;
            }));
            if (response.administrator) trackPerson(response.administrator);
          }
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
        }
      });
    }
    return () => {
      tracker.off();
    };
  }, [rawOrganizations, events]);
  useEffect(() => {
    function fetchLogisticsOrganizations() {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          const response = yield api.admin.org.logistics.getLogisticsOrgs();
          setLogisticsOrganizations(response);
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
        }
      });
    }
    fetchLogisticsOrganizations();
  }, [api, organizations]);
  const filterByQuery = query => {
    setOrganizations([]);
    setRequestQuery({
      query,
      page: 0
    });
  };
  const nextPage = useCallback(() => setRequestQuery(prevQuery => Object.assign(Object.assign({}, prevQuery), {
    page: prevQuery.page + 1
  })), []);
  const updateOrg = (id, orgData) => {
    updateOrgRequest();
    function updateOrgRequest() {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          yield api.admin.org.update(id, orgData);
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
        }
      });
    }
  };
  const createOrg = orgData => {
    createOrgRequest();
    function createOrgRequest() {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          yield api.admin.org.create(orgData);
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
        }
      });
    }
  };
  const updateFeatureFlags = (id, flags) => {
    updateFeatureFlagsRequest();
    function updateFeatureFlagsRequest() {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          yield api.admin.org.featureFlags(id, flags);
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
        }
      });
    }
  };
  const updateAdministrator = (id, person) => {
    updateAdministratorRequest();
    function updateAdministratorRequest() {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          yield api.admin.org.administrator.set(id, person);
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
        }
      });
    }
  };
  const setLogistics = (org, isLogisticsOrg) => {
    setLogisticsRequest();
    function setLogisticsRequest() {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          yield api.admin.org.logistics.setLogisticsOrg(org, isLogisticsOrg);
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
        }
      });
    }
  };
  const assignLogistics = (org, logistics) => {
    assignLogisticsRequest();
    function assignLogisticsRequest() {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          yield api.admin.org.logistics.assignLogisticsOrg(org, logistics);
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
        }
      });
    }
  };
  return {
    organizations,
    logisticsOrganizations,
    nextPage,
    filterByQuery,
    createOrg,
    updateOrg,
    updateFeatureFlags,
    updateAdministrator,
    setLogistics,
    assignLogistics
  };
};

var $ = _export;
var DESCRIPTORS = descriptors;
var global$1 = global$p;
var uncurryThis = functionUncurryThis;
var hasOwn = hasOwnProperty_1;
var isCallable = isCallable$p;
var isPrototypeOf = objectIsPrototypeOf;
var toString = toString$a;
var defineBuiltInAccessor = defineBuiltInAccessor$4;
var copyConstructorProperties = copyConstructorProperties$2;

var NativeSymbol = global$1.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('description detection')) === 'Symbol(description detection)';
  var thisSymbolValue = uncurryThis(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis(''.replace);
  var stringSlice = uncurryThis(''.slice);

  defineBuiltInAccessor(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}

const WorkflowDefinitionsContext = /*#__PURE__*/createContext(null);
const WorkflowDefinitionsProvider = ({
  children
}) => {
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.events || !resources.api || !resources.config) throw new Error('Missing required resources {api, events, config}');
  const manager = workflowDefinitionsManager(resources);
  return jsx(WorkflowDefinitionsContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const useWorkflowDefinitions = () => {
  const context = useContext(WorkflowDefinitionsContext);
  if (context === undefined || context === null) {
    throw new Error('useWorkflowDefinitions used outside of Provider');
  }
  return context;
};
const workflowDefinitionsManager = ({
  api,
  events,
  config
}) => {
  const [definitions, setDefinitions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const {
    personal: {
      locale,
      language
    }
  } = useCurrentPerson();
  const definitionsMap = useMemo(() => definitions.reduce((result, definition) => {
    result[definition._id] = definition;
    return result;
  }, {}), [definitions]);
  const sortedDefinitions = useMemo(() => definitions.sort((a, b) => {
    var _a, _b, _c, _d, _e;
    return (_c = (_b = (_a = a === null || a === void 0 ? void 0 : a.schema) === null || _a === void 0 ? void 0 : _a.description) === null || _b === void 0 ? void 0 : _b[language]) === null || _c === void 0 ? void 0 : _c.localeCompare((_e = (_d = b === null || b === void 0 ? void 0 : b.schema) === null || _d === void 0 ? void 0 : _d.description) === null || _e === void 0 ? void 0 : _e[language], locale);
  }), [definitions, language]);
  useEffect(() => {
    fetchDefinitions();
    function fetchDefinitions() {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          const response = yield api.org.workflow.definitions();
          setDefinitions(response);
          setIsLoading(false);
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
          setIsLoading(false);
        }
      });
    }
  }, [api]);
  useEffect(() => {
    const tracker = events.createTracker();
    if (config && config.orgGroup) {
      tracker.on(`mqtt:orggroup/${config.orgGroup}/workflow/definitions/created`, workflow => setDefinitions(prevDefinitions => prevDefinitions.concat(workflow)));
    }
    return () => {
      tracker.off();
    };
  }, [events, config]);
  return {
    definitionsMap,
    sortedDefinitions,
    definitions,
    isLoading
  };
};

const OwnerOngoingWorkflowsContext = /*#__PURE__*/createContext(null);
const OngoingProvider = ({
  children,
  owner,
  resources
}) => {
  const manager = ownerOngoingWorkflowsManager(resources, owner);
  return jsx(OwnerOngoingWorkflowsContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const OwnerOngoingWorkflowsProvider = ({
  children,
  owner
}) => {
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.events || !resources.api || !resources.config) throw new Error('Missing required resources {api, events, config}');
  if (!owner) throw new Error('Missing required owner');
  return jsx(WorkflowDefinitionsProvider, {
    children: jsx(OngoingProvider, Object.assign({
      resources: resources,
      owner: owner
    }, {
      children: children
    }))
  });
};
const useOwnerOngoingWorkflows = () => {
  const context = useContext(OwnerOngoingWorkflowsContext);
  if (context === undefined || context === null) {
    throw new Error('useOwnerOngoingWorkflows used outside of Provider');
  }
  return context;
};
const ownerOngoingWorkflowsManager = ({
  api,
  events,
  config
}, owner) => {
  const [ongoingList, setOngoingList] = useState([]);
  const [requestQuery, setRequestQuery] = useState({
    owner: owner,
    page: 0
  });
  const {
    definitionsMap
  } = useWorkflowDefinitions();
  const ongoingWithDefinitions = useMemo(() => ongoingList.filter(ongoing => definitionsMap[ongoing.workflow]).map(ongoing => Object.assign(Object.assign({}, ongoing), {
    workflowData: definitionsMap[ongoing.workflow]
  })), [ongoingList, definitionsMap]);
  const activeOngoingList = useMemo(() => ongoingWithDefinitions.filter(ongoing => ongoing.active), [ongoingWithDefinitions]);
  const inactiveOngoingList = useMemo(() => ongoingWithDefinitions.filter(ongoing => !ongoing.active), [ongoingWithDefinitions]);
  useEffect(() => {
    if (requestQuery.owner) fetchOngoing();
    function fetchOngoing() {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          const response = yield api.org.workflow.list.ongoing(requestQuery.owner, requestQuery.page);
          setOngoingList(prevOngoing => prevOngoing.concat(response));
        } catch (e) {
          console.error(e);
          Sentry.captureException(e);
        }
      });
    }
  }, [requestQuery]);
  useEffect(() => {
    const tracker = events.createTracker();
    if (requestQuery.owner && config && config.orgGroup) {
      events.on(`mqtt:orggroup/${config.orgGroup}/u/${requestQuery.owner}/workflow/created`, ongoing => {
        setOngoingList(prevOngoingList => [ongoing].concat(prevOngoingList));
      });
      events.on(`mqtt:orggroup/${config.orgGroup}/u/${requestQuery.owner}/workflow/ongoing/state/updated`, update => {
        setOngoingList(prevOngoingList => prevOngoingList.map(ongoing => {
          if (ongoing._id === update.ongoing) {
            return Object.assign(Object.assign({}, ongoing), {
              state: update.state
            });
          } else {
            return ongoing;
          }
        }));
      });
      events.on(`mqtt:orggroup/${config.orgGroup}/u/${requestQuery.owner}/workflow/ongoing/actors/added`, actorUpdate => {
        setOngoingList(prevOngoingList => prevOngoingList.map(ongoing => {
          if (ongoing._id === actorUpdate.ongoing) {
            return Object.assign(Object.assign({}, ongoing), {
              actors: ongoing.actors.concat(Object.assign({
                actor: actorUpdate.actor,
                who: actorUpdate.who
              }, actorUpdate.type && {
                type: actorUpdate.type
              }))
            });
          } else {
            return ongoing;
          }
        }));
      });
      events.on(`mqtt:orggroup/${config.orgGroup}/u/${requestQuery.owner}/workflow/ongoing/actors/removed`, actorUpdate => {
        setOngoingList(prevOngoingList => prevOngoingList.map(ongoing => {
          if (ongoing._id === actorUpdate.ongoing) {
            return Object.assign(Object.assign({}, ongoing), {
              actors: ongoing.actors.filter(actor => actor.who !== actorUpdate.who)
            });
          } else {
            return ongoing;
          }
        }));
      });
      events.on(`mqtt:orggroup/${config.orgGroup}/u/${requestQuery.owner}/workflow/finished`, data => {
        setOngoingList(prevOngoingList => prevOngoingList.map(ongoing => {
          if (ongoing._id === data._id) {
            return Object.assign(Object.assign({}, ongoing), {
              active: false
            });
          } else {
            return ongoing;
          }
        }));
      });
    }
    return () => {
      tracker.off();
    };
  }, [requestQuery.owner, config]);
  const nextPage = () => setRequestQuery(prevRequestQuery => Object.assign(Object.assign({}, prevRequestQuery), {
    page: prevRequestQuery.page + 1
  }));
  const clearList = useCallback(() => {
    setOngoingList([]);
    setRequestQuery({
      page: 0,
      owner: ''
    });
  }, []);
  const startWorkflow = useCallback((label, workflowId, actors, defaults) => {
    if (requestQuery.owner) start();
    function start() {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          yield api.org.workflow.ongoings.start(requestQuery.owner, label, workflowId, actors, defaults);
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
        }
      });
    }
  }, [requestQuery.owner]);
  const finishWorkflow = useCallback(ongoingId => {
    if (requestQuery.owner) finish();
    function finish() {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          yield api.org.workflow.ongoings.finish(requestQuery.owner, ongoingId);
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
        }
      });
    }
  }, [requestQuery.owner]);
  const updateWorkflow = useCallback((actors, data, ongoingId) => {
    if (requestQuery.owner) update();
    function update() {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          yield api.org.workflow.ongoings.update(requestQuery.owner, ongoingId, actors, data);
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
        }
      });
    }
  }, [requestQuery.owner]);
  return {
    ongoingWithDefinitions,
    ongoingList,
    activeOngoingList,
    inactiveOngoingList,
    nextPage,
    clearList,
    startWorkflow,
    finishWorkflow,
    updateWorkflow
  };
};

const OngoingWorkflowActions = /*#__PURE__*/createContext(null);
const OngoingWorkflowActionsProvider = ({
  children
}) => {
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.events || !resources.api || !resources.config) throw new Error("Missing required resources {api, events, config}");
  const manager = OngoingWorkflowActionsManager(resources);
  return jsx(OngoingWorkflowActions.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const useOngoingWorkflowActions = () => {
  const context = useContext(OngoingWorkflowActions);
  if (context === undefined || context === null) {
    throw new Error('useOngoingWorkflowActions used outside of Provider');
  }
  return context;
};
const OngoingWorkflowActionsManager = ({
  api
}) => {
  const [requestQuery, setRequestQuery] = useState({
    page: 0,
    ongoing: ""
  });
  const [actions, setActions] = useState([]);
  const {
    people,
    trackPerson
  } = usePeople();
  const actionsWithOwners = useMemo(() => actions.map(action => {
    return Object.assign(Object.assign({}, action), {
      owner: action.owner.map(who => people[who])
    });
  }), [people, actions]);
  useEffect(() => {
    if (requestQuery.ongoing) fetchActions();
    function fetchActions() {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          const response = yield api.org.workflow.list.actions(requestQuery.ongoing, requestQuery.page);
          if (!response || !response.length) return;
          const peopleToTrack = response.reduce((result, action) => {
            result = result.concat(action.owner);
            return result;
          }, []);
          trackPerson(peopleToTrack);
          setActions(prevActions => prevActions.concat(response));
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
        }
      });
    }
  }, [requestQuery, api]);
  const setOngoingWorkflow = useCallback(ongoingId => {
    setActions([]);
    setRequestQuery({
      page: 0,
      ongoing: ongoingId
    });
  }, []);
  const nextPage = useCallback(() => {
    setRequestQuery(prevRequestQuery => Object.assign(Object.assign({}, prevRequestQuery), {
      page: prevRequestQuery.page + 1
    }));
  }, []);
  const clearList = useCallback(() => {
    setActions([]);
    setRequestQuery({
      page: 0,
      ongoing: ""
    });
  }, []);
  return {
    actions,
    actionsWithOwners,
    setOngoingWorkflow,
    nextPage,
    clearList
  };
};

const PatientAllManagersContext = /*#__PURE__*/createContext(null);
const PatientAllManagersProvider = ({
  children
}) => {
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.api || !resources.events) throw new Error('Missing required resources {api, events, config}');
  const manager = PatientAllManagersManager(resources);
  return jsx(PatientAllManagersContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const useAllPatientManagers = () => {
  const context = useContext(PatientAllManagersContext);
  if (context === undefined || context === null) {
    throw new Error('useAllPatientManagers used outside of Provider');
  }
  return context;
};
const PatientAllManagersManager = ({
  api,
  events,
  config
}) => {
  const [rawManagers, setRawManagers] = useState([]);
  const [who, setWho] = useState('');
  const {
    people,
    trackPerson
  } = usePeople();
  const managers = useMemo(() => rawManagers.filter(managerId => people[managerId]).map(managerId => people[managerId]), [rawManagers, people]);
  useEffect(() => {
    if (who) fetchManagers();
    function fetchManagers() {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          const response = yield api.org.manage.managers(who);
          if (response && response.length) {
            trackPerson(response);
            setRawManagers(response);
          }
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
        }
      });
    }
  }, [who, api]);
  useEffect(() => {
    const tracker = events.createTracker();
    if (who && (config === null || config === void 0 ? void 0 : config.orgGroup)) {
      tracker.on(`mqtt:orggroup/${config === null || config === void 0 ? void 0 : config.orgGroup}/u/${who}/manage/manager/added`, ({
        manager
      }) => {
        trackPerson(manager);
        setRawManagers(prevRawManagers => prevRawManagers.concat(manager));
      });
      tracker.on(`mqtt:orggroup/${config === null || config === void 0 ? void 0 : config.orgGroup}/u/${who}/manage/manager/removed`, ({
        manager
      }) => {
        setRawManagers(prevRawManagers => prevRawManagers.filter(rawManager => rawManager !== manager));
      });
    }
    return () => {
      tracker.off();
    };
  }, [who, events]);
  const setPatient = who => {
    setRawManagers([]);
    setWho(who);
  };
  return {
    managers,
    rawManagers,
    setPatient
  };
};

const PatientGroupManagersContext = /*#__PURE__*/createContext(null);
const PatientGroupManagersProvider = ({
  children
}) => {
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.api) throw new Error('Missing required resources {api, events, config}');
  const manager = PatientGroupManagersManager(resources);
  return jsx(PatientGroupManagersContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const usePatientGroupManagers = () => {
  const context = useContext(PatientGroupManagersContext);
  if (context === undefined || context === null) {
    throw new Error('useAllPatientManagers used outside of Provider');
  }
  return context;
};
const PatientGroupManagersManager = ({
  api
}) => {
  const [rawManagers, setRawManagers] = useState([]);
  const [who, setWho] = useState('');
  const {
    people,
    trackPerson
  } = usePeople();
  const managers = useMemo(() => rawManagers.filter(managerId => people[managerId]).map(managerId => people[managerId]), [rawManagers, people]);
  useEffect(() => {
    if (who) fetchManagers();
    function fetchManagers() {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          const response = yield api.org.manage.patientGroup.managers(who);
          if (response && response.length) {
            trackPerson(response);
            setRawManagers(response);
          }
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
        }
      });
    }
  }, [who, api]);
  const setPatient = who => {
    setRawManagers([]);
    setWho(who);
  };
  return {
    managers,
    rawManagers,
    setPatient
  };
};

const PatientAllContactsContext = /*#__PURE__*/createContext(null);
const PatientAllContactsProvider = ({
  children
}) => {
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.api || !resources.events) throw new Error('Missing required resources {api, events, config}');
  const manager = PatientAllContactsManager(resources);
  return jsx(PatientAllContactsContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const useAllPatientContacts = () => {
  const context = useContext(PatientAllContactsContext);
  if (context === undefined || context === null) {
    throw new Error('useAllPatientContacts used outside of Provider');
  }
  return context;
};
const PatientAllContactsManager = ({
  api,
  events,
  config
}) => {
  const [rawContacts, setRawContacts] = useState([]);
  const [who, setWho] = useState('');
  const {
    people,
    trackPerson
  } = usePeople();
  const contacts = useMemo(() => rawContacts.filter(contactId => people[contactId]).map(contactId => people[contactId]), [rawContacts, people]);
  useEffect(() => {
    if (who) fetchContacts();
    function fetchContacts() {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          const response = yield api.org.users.contacts.list(null, null, who);
          if (response && response.length) {
            trackPerson(response);
            setRawContacts(response);
          }
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
        }
      });
    }
  }, [who, api]);
  useEffect(() => {
    const tracker = events.createTracker();
    if (who && (config === null || config === void 0 ? void 0 : config.orgGroup)) {
      tracker.on(`mqtt:orggroup/${config === null || config === void 0 ? void 0 : config.orgGroup}/u/${who}/contacts/added`, ({
        user
      }) => {
        trackPerson(user);
        setRawContacts(prevRawContacts => prevRawContacts.concat(user));
      });
      tracker.on(`mqtt:orggroup/${config === null || config === void 0 ? void 0 : config.orgGroup}/u/${who}/contacts/removed`, ({
        user
      }) => {
        setRawContacts(prevRawContacts => prevRawContacts.filter(contact => contact !== user));
      });
    }
    return () => {
      tracker.off();
    };
  }, [who, events]);
  const setPatient = who => {
    setRawContacts([]);
    setWho(who);
  };
  return {
    contacts,
    rawContacts,
    setPatient
  };
};

const OwnContactsContext = /*#__PURE__*/createContext(null);
const OwnContactsProvider = ({
  children
}) => {
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.api || !resources.events) throw new Error('Missing required resources {api, events, config}');
  const manager = OwnContactsManager(resources);
  return jsx(OwnContactsContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const useOwnContacts = () => {
  const context = useContext(OwnContactsContext);
  if (context === undefined || context === null) {
    throw new Error('useOwnContacts used outside of Provider');
  }
  return context;
};
const OwnContactsManager = ({
  api,
  events
}) => {
  const [rawContacts, setRawContacts] = useState([]);
  const {
    people,
    trackPerson
  } = usePeople();
  const contacts = useMemo(() => rawContacts.filter(contactId => people[contactId]).map(contactId => people[contactId]), [rawContacts, people]);
  useEffect(() => {
    fetchContacts();
    function fetchContacts() {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          const response = yield api.contacts.list();
          if (response && response.length) {
            trackPerson(response);
            setRawContacts(response);
          }
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
        }
      });
    }
  }, [api]);
  useEffect(() => {
    const tracker = events.createTracker();
    tracker.on(`mqtt:$/contacts/added`, ({
      user
    }) => {
      trackPerson(user);
      setRawContacts(prevRawContacts => prevRawContacts.concat(user));
    });
    tracker.on(`mqtt:$/contacts/removed`, ({
      user
    }) => {
      setRawContacts(prevRawContacts => prevRawContacts.filter(contact => contact !== user));
    });
    return () => {
      tracker.off();
    };
  }, [events]);
  return {
    contacts,
    rawContacts
  };
};

const ItemContext = /*#__PURE__*/createContext(null);
const PAGE_LIMIT$2 = 500;
const SCHEMA = {
  stock: {
    fields: ['count']
  },
  lot: {
    fields: ['lot', 'expiry', 'count']
  },
  serialized: {
    fields: ['serialNumber']
  },
  tablet: {
    fields: ['serialNumber', 'IMEI']
  },
  sensor: {
    fields: ['serialNumber', 'mac']
  },
  sim: {
    fields: ['sim']
  }
};
const ItemProvider = ({
  children
}) => {
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.events || !resources.api || !resources.config) throw new Error('Missing required resources {api, events, config}');
  const manager = ItemManager(resources);
  return jsx(ItemContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const useItem = () => {
  const context = useContext(ItemContext);
  if (context === undefined || context === null) {
    throw new Error('useItem used outside of its Provider');
  }
  return context;
};
const ItemManager = ({
  api,
  events
}) => {
  const [items, setItems] = useState([]);
  const [itemModelFilter, setItemModelFilter] = useState([]);
  const [itemQuery, setItemQuery] = useState({});
  const [page, setPage] = useState(0);
  useEffect(() => {
    fetchItems();
    function buildQuery() {
      let query = itemQuery;
      if (itemModelFilter.length > 0) {
        if (itemModelFilter.length === 1) {
          query = Object.assign(Object.assign({}, query), {
            itemModelId: itemModelFilter[0]
          });
        }
        query = Object.assign(Object.assign({}, query), {
          itemModelIds: itemModelFilter
        });
      }
      return query;
    }
    function fetchItems() {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          const query = buildQuery();
          const pagination = {
            page: page,
            limit: PAGE_LIMIT$2
          };
          const kitResponse = yield api.item.items(query, pagination);
          setItems(kitResponse);
        } catch (e) {
          console.error(e);
          Sentry.captureException(e);
        }
      });
    }
  }, [api, page, itemModelFilter]);
  useEffect(() => {
    const tracker = events.createTracker();
    items.forEach(item => {
      if (item._id) tracker.on(`mqtt:item/${item._id}/update`, ({
        update
      }) => {
        setItems(previtems => previtems.map(k => {
          if (k._id === item._id) {
            return Object.assign(Object.assign({}, k), update);
          }
          return k;
        }));
      });
    });
    return () => {
      tracker.off();
    };
  }, [items]);
  const CreateItem = (itemModelId, uniqueFields) => {
    try {
      api.item.create(itemModelId, uniqueFields);
    } catch (e) {
      console.error(e);
      Sentry.captureException(e);
    }
  };
  const SpecialFields = itemModelSchema => {
    return SCHEMA[itemModelSchema].fields;
  };
  const SetPage = page => {
    setPage(page);
  };
  const ItemModelFilter = useCallback(modelIds => {
    const idArray = [...modelIds];
    setItemModelFilter(idArray);
  }, []);
  const QueryItems = useCallback(query => {
    setItemQuery(query);
  }, []);
  return {
    items,
    CreateItem,
    SpecialFields,
    ItemModelFilter,
    QueryItems,
    SetPage
  };
};

const MAX_REQUESTS = 300;
const UserPublicDataContext = /*#__PURE__*/createContext(null);
const UserPublicDataProvider = ({
  children
}) => {
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.events || !resources.api) throw new Error('Missing required resources {api, events}');
  const manager = userPublicDataManager(resources);
  return jsx(UserPublicDataContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const useUserPublicData = () => {
  const context = useContext(UserPublicDataContext);
  if (context === undefined || context === null) {
    throw new Error('useUserPublicData used outside of its Provider');
  }
  return context;
};
const userPublicDataManager = ({
  api,
  events
}) => {
  const [userList, setUserList] = useState(new Set());
  const [eventTracking, setEventTracking] = useState(new Set());
  const [dataTracking, setDataTracking] = useState(new Set());
  const [rawUserPublicData, setRawUserPublicData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const users = useMemo(() => rawUserPublicData.reduce((result, userData) => {
    result[userData._id] = userData;
    return result;
  }, {}), [rawUserPublicData]);
  useEffect(() => {
    const tracker = events.createTracker();
    const fetchData = user => __awaiter(void 0, void 0, void 0, function* () {
      try {
        setIsLoading(true);
        const responseData = yield api.people.public([user]);
        setRawUserPublicData(prevRawUserPublicData => prevRawUserPublicData.map(userData => {
          if (userData._id === user) return responseData[0];
          return userData;
        }));
        setIsLoading(false);
      } catch (e) {
        Sentry.captureException(e);
        console.error(e);
        setIsLoading(false);
      }
    });
    const fetchAllData = usersToFetch => __awaiter(void 0, void 0, void 0, function* () {
      try {
        setIsLoading(true);
        const arrayOfUsers = Array.from(usersToFetch);
        const filtered = arrayOfUsers.filter(user => !dataTracking.has(user));
        const chunks = [];
        const total = filtered.length;
        let index = 0;
        while (index < total) {
          chunks.push(filtered.slice(index, index + MAX_REQUESTS));
          index += MAX_REQUESTS;
        }
        const chunkResponses = yield Promise.all(chunks.map(chunk => api.people.public(chunk)));
        setRawUserPublicData(prevRawUserPublicData => prevRawUserPublicData.concat(chunkResponses.flat()));
        setDataTracking(prevDataTracking => new Set(Array.from(prevDataTracking).concat(Array.from(usersToFetch))));
        setIsLoading(false);
      } catch (e) {
        Sentry.captureException(e);
        console.error(e);
        setIsLoading(false);
      }
    });
    userList.forEach(user => {
      if (!eventTracking.has(user)) {
        tracker.on(`mqtt:u/${user}/settings`, () => fetchData(user));
      }
    });
    setEventTracking(prevEventTracking => new Set(Array.from(prevEventTracking).concat(Array.from(userList))));
    if (userList.size) fetchAllData(userList);
    return () => {
      setDataTracking(new Set());
      setEventTracking(new Set());
      tracker.off();
    };
  }, [api, events, userList]);
  const addUsers = usersToAdd => {
    if (!usersToAdd) throw new Error('No users provided');
    const add = [].concat(usersToAdd);
    setUserList(prevUserList => new Set(Array.from(prevUserList).concat(Array.from(add))));
  };
  return {
    users,
    addUsers,
    isLoading
  };
};

const processRawBanners$1 = (users, rawBanners, bannerTypes, ongoingMap) => {
  return rawBanners.reduce((result, banner) => {
    if (banner.type.includes("banner")) {
      const rawBanner = banner;
      const {
          content
        } = rawBanner,
        rest = __rest(rawBanner, ["content"]);
      const update = Object.assign(Object.assign({}, rest), {
        to: users[rawBanner.to],
        from: users[rawBanner.from],
        kind: "banner"
      });
      if (content) {
        const {
            acknowledge,
            to,
            from
          } = content,
          otherContent = __rest(content, ["acknowledge", "to", "from"]);
        update.content = Object.assign({}, otherContent);
        if (to) {
          update.content.to = users[to];
        }
        if (from) {
          update.content.from = users[from];
        }
        if (acknowledge) {
          update.content.acknowledge = users[acknowledge];
        }
        result = result.concat(update);
      }
    } else if (banner.type.includes("workflow:action")) {
      const rawAction = banner;
      const ongoingData = ongoingMap[rawAction.ongoingWorkflow];
      const update = Object.assign(Object.assign({}, rawAction), {
        ongoingWorkflowData: ongoingData,
        kind: "workflow:action"
      });
      result = result.concat(update);
    }
    return result;
  }, []);
};

const WorkflowDefinitionTrackerContext = /*#__PURE__*/createContext(null);
const WorkflowDefinitionTrackerProvider = ({
  children
}) => {
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.events || !resources.api || !resources.config) throw new Error('Missing required resources {api, events, config}');
  const manager = workflowDefinitionTrackerManager(resources);
  return jsx(WorkflowDefinitionTrackerContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const useWorkflowDefinitionTracker = () => {
  const context = useContext(WorkflowDefinitionTrackerContext);
  if (context === undefined || context === null) {
    throw new Error('useWorkflowDefinitionTracker used outside of Provider');
  }
  return context;
};
const workflowDefinitionTrackerManager = ({
  api,
  events,
  config
}) => {
  const [definitions, setDefinitions] = useState([]);
  const [tracked, setTracked] = useState([]);
  const [rawDefinitions, setRawDefinitions] = useState([]);
  const definitionsMap = useMemo(() => definitions.reduce((result, definition) => {
    result[definition._id] = definition;
    return result;
  }, {}), [definitions]);
  useEffect(() => {
    fetchDefinitions();
    function fetchDefinitions() {
      return __awaiter(this, void 0, void 0, function* () {
        const deDupedDefinitions = Array.from(new Set(rawDefinitions)).filter(definition => !tracked.includes(definition));
        if (!deDupedDefinitions.length) return;
        const newDefinitions = [];
        for (const definition of deDupedDefinitions) {
          try {
            const response = yield api.workflow.fullDefinition(definition);
            newDefinitions.push(response);
          } catch (e) {
            continue;
          }
        }
        setDefinitions(prev => prev.concat(newDefinitions));
        setTracked(prevTracked => prevTracked.concat(deDupedDefinitions));
      });
    }
  }, [rawDefinitions, api, tracked]);
  useEffect(() => {
    const tracker = events.createTracker();
    if (config && config.orgGroup) {
      tracker.on(`mqtt:orggroup/${config.orgGroup}/workflow/definitions/updated`, update => setDefinitions(prevDefinitions => prevDefinitions.map(definition => {
        if (definition._id === update._id) {
          return Object.assign(Object.assign({}, definition), update);
        }
        return definition;
      })));
    }
    return () => {
      tracker.off();
    };
  }, [events, config]);
  const trackDefinitions = definitions => setRawDefinitions(prevRawDefinitions => prevRawDefinitions.concat(definitions));
  return {
    trackDefinitions,
    definitionsMap
  };
};

const OngoingWorkflowTrackerContext = /*#__PURE__*/createContext(null);
const OngoingWorkflowTrackerProvider = ({
  children
}) => {
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.events || !resources.api || !resources.config) throw new Error('Missing required resources {api, events, config}');
  const manager = ongoingWorkflowTrackerManager(resources);
  return jsx(OngoingWorkflowTrackerContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const useOngoingWorkflowTracker = () => {
  const context = useContext(OngoingWorkflowTrackerContext);
  if (context === undefined || context === null) {
    throw new Error('useOngoingWorkflowTracker used outside of Provider');
  }
  return context;
};
const ongoingWorkflowTrackerManager = ({
  api
}) => {
  const [ongoingsData, setOngoingsData] = useState([]);
  const [tracked, setTracked] = useState([]);
  const [rawOngoing, setRawOngoing] = useState([]);
  const {
    people,
    trackPerson
  } = usePeople();
  const {
    definitionsMap,
    trackDefinitions
  } = useWorkflowDefinitionTracker();
  const ongoingWithData = useMemo(() => {
    return ongoingsData.map(ongoing => {
      const person = people[ongoing.owner];
      const workflowDefinition = definitionsMap[ongoing.workflow];
      if (person) {
        ongoing.ownerData = person || {
          fname: '',
          lname: ''
        };
      }
      if (workflowDefinition) {
        ongoing.workflowData = workflowDefinition;
      }
      return ongoing;
    });
  }, [ongoingsData, people, definitionsMap]);
  const ongoingMap = useMemo(() => {
    return ongoingWithData.reduce((acc, curr) => {
      acc[curr._id] = curr;
      return acc;
    }, {});
  }, [ongoingWithData]);
  useEffect(() => {
    fetchOngoingData();
    function fetchOngoingData() {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          const dedupedOngoing = Array.from(new Set(rawOngoing)).filter(ongoing => !tracked.includes(ongoing));
          const ongoings = [];
          if (!dedupedOngoing.length) return;
          for (const id of dedupedOngoing) {
            const response = yield api.workflow.data(id);
            ongoings.push(response);
          }
          const owners = ongoings.map(ongoing => ongoing.owner);
          const workflows = ongoings.map(ongoing => ongoing.workflow);
          setTracked(prev => prev.concat(dedupedOngoing));
          trackPerson(owners);
          trackDefinitions(workflows);
          setOngoingsData(prev => prev.concat(ongoings));
        } catch (error) {
          Sentry.captureException(error);
          console.error(error);
        }
      });
    }
  }, [api, rawOngoing, people, definitionsMap, trackPerson, trackDefinitions, tracked]);
  const trackOngoingWorkflows = workflowIds => __awaiter(void 0, void 0, void 0, function* () {
    setRawOngoing(prev => prev.concat(workflowIds));
  });
  return {
    trackOngoingWorkflows,
    ongoingMap
  };
};

const PAGE_LIMIT$1 = 25;
const BannersContext$1 = /*#__PURE__*/createContext(null);
const BannersProvider = ({
  children
}) => {
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.api || !resources.events) throw new Error('Missing events from resources');
  const manager = bannersManager(resources);
  return jsx(BannersContext$1.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const useBanners = () => {
  const context = useContext(BannersContext$1);
  if (context === undefined || context === null) {
    throw new Error('useBanners used outside of its Provider');
  }
  return context;
};
const bannersManager = ({
  api,
  events
}) => {
  const bannerTypes = useMemo(() => ['urgency:call', 'urgency:accepted', 'urgency:cancelled', 'warning:device:disconnected', 'warning:device:connected', 'warning:device:wandering', 'warning:device:acknowledge', 'warning:device:battery', 'warning:device:batterychanged', 'info:manageduser:new', 'info:indicator:heartrate', 'info:indicator:weight', 'info:indicator:oxygensaturation', 'info:indicator:bloodpressure', 'info:indicator:bloodsugar', 'info:indicator:bodytemperature', 'info:indicator:steps', 'info:indicator:bpPulserate'], []);
  const [rawBanners, setRawBanners] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [unreadNotifications, setUnreadNotifications] = useState(0);
  const [query, setQuery] = useState({
    page: 0,
    limit: PAGE_LIMIT$1,
    banner_type: {
      $in: bannerTypes
    }
  });
  const [isLoading, setIsLoading] = useState(false);
  const [noDataLeft, setNoDataLeft] = useState(false);
  const {
    ongoingMap,
    trackOngoingWorkflows
  } = useOngoingWorkflowTracker();
  const {
    users,
    addUsers: trackUserData,
    isLoading: usersLoading
  } = useUserPublicData();
  const {
    personal,
    group
  } = useCurrentPerson();
  const banners = useMemo(() => processRawBanners$1(users, rawBanners, bannerTypes, ongoingMap), [bannerTypes, rawBanners, users, ongoingMap]) || [];
  const buildQuery = useMemo(() => {
    const {
        page,
        limit
      } = query,
      rest = __rest(query, ["page", "limit"]);
    return {
      query: Object.assign({}, rest),
      pagination: {
        page,
        limit
      }
    };
  }, [query]);
  useEffect(() => {
    function fetchAllNotifications() {
      return __awaiter(this, void 0, void 0, function* () {
        setIsLoading(true);
        try {
          const response = yield api.notifications.list.patientBanners(buildQuery.pagination, buildQuery.query);
          if (response.length < PAGE_LIMIT$1) {
            setNoDataLeft(true);
          } else {
            setNoDataLeft(false);
          }
          setRawBanners(prev => prev.concat(response));
          const userIds = response.reduce((result, banner) => {
            result = result.concat(banner.from);
            const content = banner.content || {};
            const to = content.to;
            const acknowledge = content.acknowledge;
            if (to) result = result.concat(to);
            if (acknowledge) result = result.concat(acknowledge);
            return result;
          }, []);
          const ongoingWorkflows = response.reduce((result, banner) => {
            if (banner.type.includes('workflow:action') && banner.ongoingWorkflow) {
              result = result.concat(banner.ongoingWorkflow);
            }
            return result;
          }, []);
          trackUserData(userIds);
          trackOngoingWorkflows(ongoingWorkflows);
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
        }
        setIsLoading(false);
      });
    }
    fetchAllNotifications();
  }, [buildQuery, api]);
  useEffect(() => {
    fetchNotificationCount();
    function fetchNotificationCount() {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          const response = yield api.notifications.countUnread();
          setUnreadCount(response.count);
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
        }
      });
    }
  }, [api]);
  useEffect(() => {
    const tracker = events.createTracker();
    if (personal._id) {
      tracker.on(`mqtt:u/${personal._id}/notifications/new`, banner_type => {
        if (bannerTypes.includes(banner_type.banner_type)) {
          setUnreadNotifications(prevNotes => prevNotes + 1);
          setRawBanners(prevBanners => [banner_type, ...prevBanners]);
        }
      });
      tracker.on(`mqtt:u/${personal._id}/workflow/actions/added`, data => {
        trackOngoingWorkflows([data.ongoingWorkflow]);
        setUnreadNotifications(prevNotes => prevNotes + 1);
        setRawBanners(prevBanners => [data, ...prevBanners]);
      });
      tracker.on(`mqtt:u/${personal._id}/workflow/actions/removed`, data => {
        setUnreadNotifications(prevNotes => prevNotes - 1);
        setRawBanners(prevBanners => prevBanners.filter(banner => banner._id !== data._id));
      });
      tracker.on(`mqtt:u/${personal._id}/notifications/cleared`, notification => {
        let foundBanner = false;
        setRawBanners(prevBanners => prevBanners.map(banner => {
          if (banner._id === notification.notification) {
            banner.read = true;
            foundBanner = true;
          }
          return banner;
        }));
        if (foundBanner) {
          setUnreadNotifications(prevNotes => prevNotes - 1);
        }
      });
    }
    return () => {
      tracker.off();
    };
  }, [events, bannerTypes, personal, group, trackOngoingWorkflows]);
  useEffect(() => {
    function fetchUnreadNotifications() {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          const response = yield api.notifications.list.patientBanners({
            page: 0,
            limit: 500
          }, {
            banner_type: {
              $in: bannerTypes
            },
            read: false
          });
          setUnreadNotifications(response.length);
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
        }
      });
    }
    fetchUnreadNotifications();
  }, [api, bannerTypes, rawBanners]);
  const markBannerRead = useCallback(bannerId => __awaiter(void 0, void 0, void 0, function* () {
    bannerId = Array.isArray(bannerId) ? bannerId : [bannerId];
    bannerId.forEach(id => __awaiter(void 0, void 0, void 0, function* () {
      try {
        yield api.notifications.clear(id);
      } catch (e) {
        Sentry.captureException(e);
        console.error(e);
      }
    }));
  }), [api]);
  function markAllBannersRead() {
    return __awaiter(this, void 0, void 0, function* () {
      try {
        banners.forEach(banner => __awaiter(this, void 0, void 0, function* () {
          if (banner.type.includes("banner")) {
            if (!banner.read) {
              yield api.notifications.clear(banner._id);
            }
          }
        }));
      } catch (e) {
        Sentry.captureException(e);
        console.error(e);
      }
    });
  }
  const nextPage = useCallback(() => {
    if (noDataLeft) return;
    setQuery(prevQuery => Object.assign(Object.assign({}, prevQuery), {
      page: prevQuery.page + 1
    }));
  }, [noDataLeft]);
  const filterBySearch = useCallback(queryString => {
    setRawBanners([]);
    if (queryString) {
      setQuery(prevQuery => Object.assign(Object.assign({}, prevQuery), {
        searchName: {
          $regex: queryString,
          $options: 'i'
        },
        page: 0
      }));
    } else {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      setQuery(_a => {
        var prevQuery = __rest(_a, ["searchName"]);
        return Object.assign(Object.assign({}, prevQuery), {
          page: 0
        });
      });
    }
  }, []);
  const filterByBannerType = useCallback(types => __awaiter(void 0, void 0, void 0, function* () {
    setRawBanners([]);
    if (types && types.length) {
      setQuery(prevQuery => Object.assign(Object.assign({}, prevQuery), {
        banner_type: {
          $in: types
        },
        page: 0
      }));
    } else {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      setQuery(_a => {
        var prevQuery = __rest(_a, ["banner_type"]);
        return Object.assign(Object.assign({}, prevQuery), {
          page: 0
        });
      });
    }
  }), []);
  const filterByStartDate = startDate => {
    setRawBanners([]);
    if (startDate) {
      setQuery(prevQuery => Object.assign(Object.assign({}, prevQuery), {
        updated_at: Object.assign(Object.assign({}, (prevQuery === null || prevQuery === void 0 ? void 0 : prevQuery.updated_at) || {}), {
          $gte: startDate
        }),
        page: 0
      }));
    } else {
      setQuery(_a => {
        var {
            updated_at
          } = _a,
          prevQuery = __rest(_a, ["updated_at"]);
        return Object.assign(Object.assign(Object.assign({}, prevQuery), (updated_at === null || updated_at === void 0 ? void 0 : updated_at.$lte) && {
          updated_at: {
            $gte: updated_at.$lte
          }
        }), {
          page: 0
        });
      });
    }
  };
  const filterByEndDate = endDate => {
    setRawBanners([]);
    if (endDate) {
      setQuery(prevQuery => Object.assign(Object.assign({}, prevQuery), {
        updated_at: Object.assign(Object.assign({}, (prevQuery === null || prevQuery === void 0 ? void 0 : prevQuery.updated_at) || {}), {
          $lte: endDate
        }),
        page: 0
      }));
    } else {
      setQuery(_a => {
        var {
            updated_at
          } = _a,
          prevQuery = __rest(_a, ["updated_at"]);
        return Object.assign(Object.assign(Object.assign({}, prevQuery), (updated_at === null || updated_at === void 0 ? void 0 : updated_at.$gte) && {
          updated_at: {
            $gte: updated_at.$gte
          }
        }), {
          page: 0
        });
      });
    }
  };
  const clearFilters = () => {
    setRawBanners([]);
    setQuery(prev => {
      delete prev.updated_at;
      return Object.assign(Object.assign({}, prev), {
        page: 0
      });
    });
  };
  return {
    banners,
    bannerTypes,
    unreadCount,
    unreadNotifications,
    isLoading: isLoading || usersLoading,
    noDataLeft,
    markBannerRead,
    markAllBannersRead,
    nextPage,
    clearFilters,
    filterBySearch,
    filterByBannerType,
    filterByStartDate,
    filterByEndDate
  };
};

const processRawBanners = (users, rawBanners, bannerTypes) => {
  return rawBanners.map(banner => {
    const {
        content
      } = banner,
      rest = __rest(banner, ["content"]);
    const update = Object.assign(Object.assign({}, rest), {
      to: users[banner.to],
      from: users[banner.from]
    });
    if (content) {
      const {
          acknowledge,
          to,
          from
        } = content,
        otherContent = __rest(content, ["acknowledge", "to", "from"]);
      update.content = Object.assign({}, otherContent);
      if (to) {
        update.content.to = users[to];
      }
      if (from) {
        update.content.from = users[from];
      }
      if (acknowledge) {
        update.content.acknowledge = users[acknowledge];
      }
    }
    return update;
  });
};

const PAGE_LIMIT = 25;
const BannersContext = /*#__PURE__*/createContext(null);
const LogisticBannersProvider = ({
  children
}) => {
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.api || !resources.events) throw new Error('Missing events from resources');
  const manager = logisticBannersManager(resources);
  return jsx(BannersContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const useLogisticBanners = () => {
  const context = useContext(BannersContext);
  if (context === undefined || context === null) {
    throw new Error('useLogisticBanners used outside of its Provider');
  }
  return context;
};
const logisticBannersManager = ({
  api,
  events
}) => {
  const bannerTypes = useMemo(() => ['message:logistics:note'], []);
  const [rawBanners, setRawBanners] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [unreadLogisticsNotesCount, setUnreadLogisticsNotesCount] = useState(0);
  const [query, setQuery] = useState({
    page: 0,
    limit: PAGE_LIMIT,
    banner_type: {
      $in: bannerTypes
    }
  });
  const [isLoading, setIsLoading] = useState(false);
  const [noDataLeft, setNoDataLeft] = useState(false);
  const {
    users,
    addUsers: trackUserData
  } = useUserPublicData();
  const {
    personal
  } = useCurrentPerson();
  const banners = useMemo(() => processRawBanners(users, rawBanners), [bannerTypes, rawBanners, users]) || [];
  const buildQuery = useMemo(() => {
    const {
        page,
        limit
      } = query,
      rest = __rest(query, ["page", "limit"]);
    return {
      query: Object.assign({}, rest),
      pagination: {
        page,
        limit
      }
    };
  }, [query]);
  useEffect(() => {
    function fetchAllNotifications() {
      return __awaiter(this, void 0, void 0, function* () {
        const {
          query,
          pagination
        } = buildQuery;
        setIsLoading(true);
        try {
          const response = yield api.notifications.list.logisticsBanners(pagination, query);
          if (response.length < PAGE_LIMIT) {
            setNoDataLeft(true);
          } else {
            setNoDataLeft(false);
          }
          setRawBanners(prev => prev.concat(response));
          const userIds = response.reduce((result, banner) => {
            result = result.concat(banner.from);
            const content = banner.content || {};
            const to = content.to;
            const acknowledge = content.acknowledge;
            if (to) result = result.concat(to);
            if (acknowledge) result = result.concat(acknowledge);
            return result;
          }, []);
          trackUserData(userIds);
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
        }
        setIsLoading(false);
      });
    }
    fetchAllNotifications();
  }, [buildQuery, api]);
  useEffect(() => {
    fetchNotificationCount();
    function fetchNotificationCount() {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          const response = yield api.notifications.countUnread();
          setUnreadCount(response.count);
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
        }
      });
    }
  }, [api]);
  useEffect(() => {
    const tracker = events.createTracker();
    if (personal._id) {
      tracker.on(`mqtt:u/${personal._id}/notifications/new`, banner => {
        if (banner.banner_type === 'message:logistics:note') {
          setUnreadLogisticsNotesCount(prevNotes => prevNotes + 1);
          setRawBanners(prevBanners => {
            const bannerIndex = prevBanners.findIndex(prevBanner => prevBanner._id === banner._id);
            if (bannerIndex === -1) {
              return [banner, ...prevBanners];
            }
            return prevBanners;
          });
        }
      });
      tracker.on(`mqtt:u/${personal._id}/notifications/cleared/all`, () => {
        setUnreadLogisticsNotesCount(0);
        setRawBanners(prevBanners => prevBanners.map(banner => {
          banner.read = true;
          return banner;
        }));
      });
    }
    tracker.on(`mqtt:u/${personal._id}/notifications/cleared`, ({
      notification
    }) => {
      if (banners.find(banner => banner._id === notification._id)) {
        setUnreadLogisticsNotesCount(prevNotes => prevNotes - 1);
        setRawBanners(prevBanners => prevBanners.map(banner => {
          if (banner._id === notification._id) {
            banner.read = true;
          }
          return banner;
        }));
      }
    });
    return () => {
      tracker.off();
    };
  }, [personal._id, events, banners]);
  useEffect(() => {
    function fetchUnreadLogisticsNotesCount() {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          const response = yield api.notifications.list.logisticsBanners({
            page: 0,
            limit: 500
          }, {
            banner_type: {
              $in: bannerTypes
            },
            read: false
          });
          setUnreadLogisticsNotesCount(response.length);
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
        }
      });
    }
    fetchUnreadLogisticsNotesCount();
  }, [api, rawBanners]);
  function markBannerRead(bannerId) {
    return __awaiter(this, void 0, void 0, function* () {
      bannerId = Array.isArray(bannerId) ? bannerId : [bannerId];
      bannerId.forEach(id => __awaiter(this, void 0, void 0, function* () {
        try {
          yield api.notifications.clear(id);
          setRawBanners(prevBanners => prevBanners.map(banner => {
            if (banner._id === id) {
              banner.read = true;
            }
            return banner;
          }));
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
        }
      }));
    });
  }
  function markAllBannersRead() {
    return __awaiter(this, void 0, void 0, function* () {
      try {
        yield api.notifications.clearAll();
      } catch (e) {
        Sentry.captureException(e);
        console.error(e);
      }
    });
  }
  const nextPage = useCallback(() => {
    if (noDataLeft) return;
    setQuery(prevQuery => Object.assign(Object.assign({}, prevQuery), {
      page: prevQuery.page + 1
    }));
  }, [noDataLeft]);
  const filterBySearch = useCallback(queryString => {
    setRawBanners([]);
    if (queryString) {
      setQuery(prevQuery => Object.assign(Object.assign({}, prevQuery), {
        searchName: {
          $regex: queryString,
          $options: 'i'
        },
        page: 0
      }));
    } else {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      setQuery(_a => {
        var prevQuery = __rest(_a, ["searchName"]);
        return Object.assign(Object.assign({}, prevQuery), {
          page: 0
        });
      });
    }
  }, []);
  const filterByBannerType = useCallback(types => __awaiter(void 0, void 0, void 0, function* () {
    setRawBanners([]);
    if (types && types.length) {
      setQuery(prevQuery => Object.assign(Object.assign({}, prevQuery), {
        banner_type: {
          $in: types
        },
        page: 0
      }));
    } else {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      setQuery(_a => {
        var prevQuery = __rest(_a, ["banner_type"]);
        return Object.assign(Object.assign({}, prevQuery), {
          page: 0
        });
      });
    }
  }), []);
  const filterByStartDate = startDate => {
    setRawBanners([]);
    if (startDate) {
      setQuery(prevQuery => Object.assign(Object.assign({}, prevQuery), {
        updated_at: Object.assign(Object.assign({}, (prevQuery === null || prevQuery === void 0 ? void 0 : prevQuery.updated_at) || {}), {
          $gte: startDate
        }),
        page: 0
      }));
    } else {
      setQuery(_a => {
        var {
            updated_at
          } = _a,
          prevQuery = __rest(_a, ["updated_at"]);
        return Object.assign(Object.assign(Object.assign({}, prevQuery), (updated_at === null || updated_at === void 0 ? void 0 : updated_at.$lte) && {
          updated_at: {
            $gte: updated_at.$lte
          }
        }), {
          page: 0
        });
      });
    }
  };
  const filterByEndDate = endDate => {
    setRawBanners([]);
    if (endDate) {
      setQuery(prevQuery => Object.assign(Object.assign({}, prevQuery), {
        updated_at: Object.assign(Object.assign({}, (prevQuery === null || prevQuery === void 0 ? void 0 : prevQuery.updated_at) || {}), {
          $lte: endDate
        }),
        page: 0
      }));
    } else {
      setQuery(_a => {
        var {
            updated_at
          } = _a,
          prevQuery = __rest(_a, ["updated_at"]);
        return Object.assign(Object.assign(Object.assign({}, prevQuery), (updated_at === null || updated_at === void 0 ? void 0 : updated_at.$gte) && {
          updated_at: {
            $gte: updated_at.$gte
          }
        }), {
          page: 0
        });
      });
    }
  };
  const clearFilters = () => {
    setRawBanners([]);
    setQuery(prev => {
      delete prev.updated_at;
      return Object.assign(Object.assign({}, prev), {
        page: 0
      });
    });
  };
  return {
    banners,
    bannerTypes,
    unreadCount,
    unreadLogisticsNotesCount,
    isLoading,
    noDataLeft,
    markBannerRead,
    markAllBannersRead,
    nextPage,
    clearFilters,
    filterBySearch,
    filterByBannerType,
    filterByStartDate,
    filterByEndDate
  };
};

const CustomIndicatorsContext = /*#__PURE__*/createContext(null);
const CustomIndicatorsProvider = ({
  children
}) => {
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.api || !resources.events || !resources.config) throw new Error('Missing events from resources');
  const manager = customIndicatorsManager(resources);
  return jsx(CustomIndicatorsContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const useCustomIndicators = () => {
  const context = useContext(CustomIndicatorsContext);
  if (context === undefined || context === null) {
    throw new Error('useCustomIndicators used outside of its Provider');
  }
  return context;
};
const customIndicatorsManager = ({
  api,
  events,
  config
}) => {
  const [indicators, setIndicators] = useState([]);
  const indicatorMap = useMemo(() => indicators.reduce((result, indicator) => {
    result[indicator._id] = indicator;
    return result;
  }, {}), [indicators]);
  useEffect(() => {
    fetchIndicators();
    function fetchIndicators() {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          const response = yield api.org.indicators();
          setIndicators(response);
        } catch (e) {
          Sentry.captureException(e);
          console.error(e);
        }
      });
    }
  }, [api]);
  useEffect(() => {
    const {
      organization
    } = config || {};
    const tracker = events.createTracker();
    if (organization) {
      tracker.on(`mqtt:org/${organization}/indicators/added`, indicator => {
        setIndicators(prevIndicators => prevIndicators.concat(indicator));
      });
      tracker.on(`mqtt:org/${organization}/indicators/removed`, indicatorId => {
        setIndicators(prevIndicators => prevIndicators.filter(indicator => indicator._id !== indicatorId));
      });
      tracker.on(`mqtt:org/${organization}/indicators/updated`, newIndicator => {
        setIndicators(prevIndicators => prevIndicators.map(indicator => {
          if (indicator._id === newIndicator._id) return newIndicator;
          return indicator;
        }));
      });
    }
    return () => {
      tracker.off();
    };
  }, [events, config]);
  return {
    indicators,
    indicatorMap
  };
};

const LogisticsNotesContext = /*#__PURE__*/createContext(null);
const LogisticsNotesProvider = ({
  children
}) => {
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.api || !resources.events) throw new Error('Missing events from resources');
  const manager = LogisticsNotesManager(resources);
  return jsx(LogisticsNotesContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const useLogisticsNotes = () => {
  const context = useContext(LogisticsNotesContext);
  if (context === undefined || context === null) {
    throw new Error('useLogisticsNotes used outside of its Provider');
  }
  return context;
};
const LogisticsNotesManager = ({
  api,
  events
}) => {
  const {
    personal,
    org
  } = useCurrentPerson();
  const [notes, setNotes] = useState([]);
  const [search, setSearch] = useState({
    kitAssignmentId: null,
    patientId: null
  });
  const [apiMessage, setApiMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [unreadMap, setUnreadMap] = useState(new Map());
  const [unreadCountTracking, setUnreadCountTracking] = useState(new Set());
  useEffect(() => {
    if (!search.kitAssignmentId && !search.patientId) return;
    fetchNotes();
    function fetchNotes() {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          setIsLoading(true);
          const result = yield api.logisticsNotes.list(search);
          setNotes(result);
          setIsLoading(false);
        } catch (e) {
          setIsLoading(false);
          console.error(e);
          Sentry.captureException(e);
        }
      });
    }
  }, [api, search]);
  useEffect(() => {
    if (!unreadCountTracking.size) return;
    const fetchUnread = () => __awaiter(void 0, void 0, void 0, function* () {
      var _a;
      const unreadMap = new Map();
      for (const assignment of unreadCountTracking) {
        try {
          const result = yield (_a = api.logisticsNotes.unread) === null || _a === void 0 ? void 0 : _a.count(assignment);
          unreadMap.set(assignment, result);
        } catch (e) {
          console.error(e);
          Sentry.captureException(e);
        }
      }
      setUnreadMap(prevMap => {
        return new Map([...prevMap, ...unreadMap]);
      });
    });
    fetchUnread();
  }, [unreadCountTracking, api]);
  const trackUnreadNotesCount = useCallback(kitAssignmentIds => {
    setUnreadCountTracking(prev => new Set(Array.from(prev).concat(kitAssignmentIds)));
  }, []);
  const getUnreadNotesCount = useCallback(kitAssignmentId => {
    if (!kitAssignmentId) return 0;
    if (!personal._id) return 0;
    if (unreadMap.has(kitAssignmentId)) return unreadMap.get(kitAssignmentId);
    setUnreadCountTracking(prev => new Set(Array.from(prev).concat(kitAssignmentId)));
    return 0;
  }, [personal._id, unreadMap]);
  const getUnreadNotes = useCallback((options = {}) => {
    var _a;
    const {
      includePartialRead = true
    } = options;
    const notesToFilter = (_a = options.notes) !== null && _a !== void 0 ? _a : notes;
    return notesToFilter.filter(note => {
      if (note.read) return false;
      if (includePartialRead && note.readBy.includes(personal._id)) return false;
      if (includePartialRead && note.from === personal._id) return false;
      if (note.readByOrg.includes(org === null || org === void 0 ? void 0 : org._id)) return false;
      return true;
    }).map(note => note._id);
  }, [notes, personal._id, org === null || org === void 0 ? void 0 : org._id]);
  useEffect(() => {
    const tracker = events.createTracker();
    for (const assignment of unreadMap.keys()) {
      tracker.on(`mqtt:u/${assignment}/note`, ({
        patientId
      }) => __awaiter(void 0, void 0, void 0, function* () {
        try {
          const result = yield api.logisticsNotes.list({
            patientId
          });
          if (patientId === search.patientId) {
            setNotes(result);
          }
          const unread = getUnreadNotes({
            notes: result
          }).length;
          setUnreadMap(prevMap => {
            return new Map(prevMap.set(assignment, unread));
          });
        } catch (e) {
          console.error(e);
          Sentry.captureException(e);
        }
      }));
    }
    return () => {
      tracker.off();
    };
  }, [api, events, getUnreadNotes, unreadMap, search]);
  const sendNote = useCallback((content, kitAssignmentId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
      const {
        note,
        message
      } = yield api.logisticsNotes.send(content, kitAssignmentId);
      if (note) {
        setNotes(prevNotes => prevNotes.concat(note));
      }
      setApiMessage(message);
    } catch (e) {
      console.error(e);
      Sentry.captureException(e);
    }
  }), [api]);
  const markNotesRead = useCallback((noteIds, assignmentId, {
    markAsReadForOrg
  }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
      yield api.logisticsNotes.read(noteIds, markAsReadForOrg);
      const currentUserId = personal._id;
      setNotes(prevNotes => prevNotes.map(note => {
        if (!noteIds.includes(note._id)) return note;
        if (note.read) return note;
        if (markAsReadForOrg && (org === null || org === void 0 ? void 0 : org._id)) {
          return Object.assign(Object.assign({}, note), {
            readByOrg: note.readByOrg.concat(org._id)
          });
        }
        return Object.assign(Object.assign({}, note), {
          readBy: note.readBy.concat(currentUserId)
        });
      }));
      setUnreadMap(prevMap => {
        return new Map(prevMap.set(assignmentId, 0));
      });
    } catch (e) {
      console.error(e);
      Sentry.captureException(e);
    }
  }), [api, personal._id, org === null || org === void 0 ? void 0 : org._id]);
  const setKitAssignment = useCallback(assignmentId => {
    setSearch(prevSearch => {
      return Object.assign(Object.assign({}, prevSearch), {
        kitAssignmentId: assignmentId
      });
    });
  }, []);
  const setPatient = useCallback(patientId => {
    setSearch(prevSearch => {
      return Object.assign(Object.assign({}, prevSearch), {
        patientId: patientId
      });
    });
  }, []);
  return {
    notes,
    apiMessage,
    isLoading,
    unreadMap,
    setNotes,
    sendNote,
    markNotesRead,
    setKitAssignment,
    setPatient,
    getUnreadNotesCount,
    getUnreadNotes,
    trackUnreadNotesCount
  };
};

const PatientsPatientGroupContext = /*#__PURE__*/React__default.createContext(null);
const PatientsPatientGroupProvider = ({
  children,
  owner
}) => {
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.events || !resources.api || !resources.config) {
    throw new Error('PatientGroupProvider must be used within a ResourcesProvider');
  }
  const patientGroupManager = patientsPatientGroupManager(resources, owner);
  return jsx(PatientsPatientGroupContext.Provider, Object.assign({
    value: patientGroupManager
  }, {
    children: children
  }));
};
const usePatientsPatientGroup = () => {
  const context = useContext(PatientsPatientGroupContext);
  if (context === undefined || context === null) {
    throw new Error('usePatientsPatientGroup used outside of its Provider');
  }
  return context;
};
const patientsPatientGroupManager = ({
  api,
  events,
  config
}, owner) => {
  const [patientGroups, setPatientGroups] = useState([]);
  const [patientGroupIds, setPatientGroupIds] = useState([]);
  useEffect(() => {
    const fetchPatientGroup = () => __awaiter(void 0, void 0, void 0, function* () {
      try {
        const patientGroupResponse = yield api.org.managergroups.patient.list(owner);
        setPatientGroups(patientGroupResponse);
        setPatientGroupIds(patientGroupResponse.map(group => group._id));
      } catch (e) {
        console.error(e);
        Sentry.captureException(e);
      }
    });
    if (config === null || config === void 0 ? void 0 : config.orgGroup) {
      events.on(`mqtt:orggroup/${config === null || config === void 0 ? void 0 : config.orgGroup}/u/${owner}/settings`, ({
        manage_group
      }) => {
        if (manage_group) fetchPatientGroup();
      });
    }
    fetchPatientGroup();
  }, [api, events, owner, config === null || config === void 0 ? void 0 : config.orgGroup]);
  useEffect(() => {
    const orgGroup = config === null || config === void 0 ? void 0 : config.orgGroup;
    const tracker = events.createTracker();
    if (config === null || config === void 0 ? void 0 : config.orgGroup) {
      patientGroupIds.forEach(patientGroup => {
        tracker.on(`mqtt:orggroup/${orgGroup}/managegroup/${patientGroup}/updated`, data => {
          if (data.name) {
            setPatientGroups(prevPatientGroups => {
              const patientGroupIndex = prevPatientGroups.findIndex(oldPatientGroups => oldPatientGroups._id === patientGroup);
              const newPatientGroups = [...prevPatientGroups];
              newPatientGroups[patientGroupIndex] = Object.assign(Object.assign({}, prevPatientGroups[patientGroupIndex]), {
                name: data.name
              });
              return newPatientGroups;
            });
          }
        });
      });
    }
    return () => {
      tracker.off();
    };
  }, [events, patientGroupIds, config === null || config === void 0 ? void 0 : config.orgGroup]);
  return {
    patientGroups
  };
};

const getMeasureUnitsObject = current => {
  const metricUnits = current.measureUnits || "metric";
  const final = {
    measureUnits: metricUnits,
    weightUnits: "kg",
    temperatureUnits: "celsius",
    glucometerUnits: "mmol"
  };
  if (current.weightUnits) {
    final.weightUnits = current.weightUnits;
  } else if (metricUnits === "imperial") {
    final.weightUnits = "lbs";
  }
  if (current.temperatureUnits) {
    final.temperatureUnits = current.temperatureUnits;
  } else if (metricUnits === "imperial") {
    final.temperatureUnits = "fahrenheit";
  }
  if (current.glucometerUnits) {
    final.glucometerUnits = current.glucometerUnits;
  } else if (metricUnits === "imperial") {
    final.glucometerUnits = "mg";
  }
  return final;
};

const MeasureUnitsContext = /*#__PURE__*/createContext({
  measureUnits: "metric",
  weightUnits: "kg",
  temperatureUnits: "celsius",
  glucometerUnits: "mmol"
});
const MeasureUnitsProvider = ({
  children,
  value
}) => {
  return jsx(MeasureUnitsContext.Provider, Object.assign({
    value: value
  }, {
    children: children
  }));
};
const useMeasureUnits = () => {
  const context = useContext(MeasureUnitsContext);
  return getMeasureUnitsObject(context);
};

function useLocalStorageValue(key, defaultValue) {
  const [state, setState] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : defaultValue;
    } catch (error) {
      Sentry.captureException(error);
      localStorage.removeItem(key);
      return defaultValue;
    }
  });
  const updateState = value => {
    try {
      setState(value);
      const serializedValue = JSON.stringify(value);
      window.localStorage.setItem(key, serializedValue);
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  return [state, updateState];
}

function createFileKey(currentKey, currentData) {
  const update = {};
  update['key'] = currentKey;
  update['data'] = currentData;
  return update;
}
function parseFile(arr, currentKey, currentData) {
  if (!Array.isArray(currentData) && currentData['id']) return arr; // File is already uploaded
  return arr.concat(createFileKey(currentKey, currentData));
}
function parseFileList(arr, currentKey, currentData) {
  if (!currentData || !currentData.length) return arr;
  const result = [];
  return arr.concat(currentData.reduce((acc, data, index) => {
    const key = currentKey + '.' + index + '';
    if (data['id']) return acc; // File is already uploaded
    return acc.concat(createFileKey(key, data['file']));
  }, result));
}
function parseObject(arr, currentKey, currentData, current) {
  const properties = current.properties || {};
  return arr.concat(findFiles(properties, currentData, currentKey));
}
function parseArray(arr, currentKey, currentData, current) {
  const items = current.items || {};
  if (items.inputType === 'file') return parseFile(arr, currentKey, currentData);
  const props = items;
  return arr.concat(findFiles(props, currentData, currentKey));
}
const findFiles = (properties, data, parent) => {
  if (!properties) return [];
  const result = [];
  return Object.keys(properties).reduce((acc, key) => {
    const currentKey = parent ? parent + '.' + key : key;
    const current = (properties === null || properties === void 0 ? void 0 : properties[key]) || {};
    const currentData = data[key] || {};
    const dataIsArray = Array.isArray(currentData);
    if (current.inputType === 'signature' && currentData) return parseFile(acc, currentKey, currentData);
    if (current.inputType === 'file' && currentData) return parseFile(acc, currentKey, currentData);
    if (current.type === 'array' && current.inputType === 'fileList' && dataIsArray) {
      return parseFileList(acc, currentKey, currentData);
    }
    if (current.type === 'object') return parseObject(acc, currentKey, currentData, current);
    if (current.type === 'array' && dataIsArray) {
      return parseArray(acc, currentKey, currentData, current);
    }
    return acc;
  }, result);
};
function formatFile(file) {
  return {
    url: file.url,
    id: file._id,
    format: file.format,
    name: file.name
  };
}
function isApiError(e) {
  if (typeof e === 'object' && e !== null && 'response' in e && typeof e.response === 'object' && e.response !== null && 'message' in e.response && typeof e.response.message === 'string') {
    return true;
  }
  return false;
}
function getApiErrorMsg(e) {
  if (isApiError(e)) {
    return e.response.message;
  }
  return 'Internal Server Error';
}

const DEFAULT_RECORDS_PER_PAGE = 15;
const FormSubmissionsContext = /*#__PURE__*/createContext(null);
const FormSubmissionsProvider = ({
  userId,
  recordsPerPageKey,
  initialFilter,
  children
}) => {
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.events || !resources.api || !resources.config) throw new Error('Missing required resources {api, events, config}');
  if (!userId) throw new Error('Missing required userId');
  const manager = FormSubmissionsManager(resources, {
    userId,
    recordsPerPageKey,
    initialFilter
  });
  return jsx(FormSubmissionsContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const useFormSubmissions = () => {
  const context = useContext(FormSubmissionsContext);
  if (context === undefined || context === null) {
    throw new Error('useFormSubmissions used outside of its Provider');
  }
  return context;
};
const FormSubmissionsManager = ({
  api,
  events,
  config
}, {
  userId,
  recordsPerPageKey,
  initialFilter: _initialFilter = []
}) => {
  const [formSubmissions, setFormSubmissions] = useState([]);
  const [selectedForms, setSelectedForms] = useState(_initialFilter);
  const [allForms, setAllForms] = useState([]);
  const [formsById, setFormsById] = useState({});
  const [user, setUser] = useState(userId);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [prepopulateData, setPrepopulateData] = useState({});
  const [recordsPerPage, setRecordsPerPage] = useLocalStorageValue(recordsPerPageKey, DEFAULT_RECORDS_PER_PAGE);
  const fetchSubmissions = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
    try {
      const response = yield api.org.forms.submissions.list(user, selectedForms, {
        page,
        limit: recordsPerPage
      });
      setTotal(response.total);
      setFormSubmissions(response.submissions);
    } catch (e) {
      Sentry.captureException(e);
      if (e instanceof Error) setError(e.message);
    }
  }), [api, page, recordsPerPage, selectedForms, user]);
  const onUpdateEvent = useCallback(eventData => {
    fetchSubmissions();
  }, [fetchSubmissions]);
  const onCreateEvent = useCallback(eventData => {
    const formSchema = formsById[eventData.schema];
    if (!formSchema) return;
    if (page !== 0) return;
    if (selectedForms.length && !selectedForms.includes(eventData.schema)) return;
    const newSubmission = Object.assign(Object.assign({}, eventData), {
      schema: formSchema
    });
    const newSubmissions = [newSubmission, ...formSubmissions];
    setFormSubmissions(newSubmissions);
  }, [formSubmissions, formsById, selectedForms, page]);
  const onDeleteEvent = useCallback(eventData => {
    const index = formSubmissions.findIndex(data => data._id === eventData._id);
    if (index === -1) return;
    const newSubmissions = [...formSubmissions];
    newSubmissions.splice(index, 1);
    setFormSubmissions(newSubmissions);
  }, [formSubmissions]);
  const onLockEvent = useCallback(eventData => {
    const index = formSubmissions.findIndex(data => data._id === eventData._id);
    if (index === -1) return;
    const newSubmissions = [...formSubmissions];
    newSubmissions[index] = Object.assign(Object.assign({}, newSubmissions[index]), {
      locked: true
    });
    setFormSubmissions(newSubmissions);
  }, [formSubmissions]);
  const orgGroup = config === null || config === void 0 ? void 0 : config.orgGroup;
  const updateEvent = orgGroup ? `mqtt:orggroup/${orgGroup}/u/${user}/forms/submission/group/updated` : `mqtt:u/${user}/forms/submission/group/updated`;
  const createEvent = orgGroup ? `mqtt:orggroup/${orgGroup}/u/${user}/forms/submission/group/created` : `mqtt:u/${user}/forms/submission/group/created`;
  const deleteEvent = orgGroup ? `mqtt:orggroup/${orgGroup}/u/${user}/forms/submission/group/removed` : `mqtt:u/${user}/forms/submission/group/removed`;
  const lockEvent = orgGroup ? `mqtt:orggroup/${orgGroup}/u/${user}/forms/submission/group/locked` : `mqtt:u/${user}/forms/submission/group/locked`;
  useEffect(() => {
    const tracker = events.createTracker();
    tracker.on(updateEvent, onUpdateEvent);
    tracker.on(createEvent, onCreateEvent);
    tracker.on(deleteEvent, onDeleteEvent);
    tracker.on(lockEvent, onLockEvent);
    return () => tracker.off();
  }, [events, updateEvent, onUpdateEvent, createEvent, onCreateEvent, deleteEvent, onDeleteEvent, lockEvent, onLockEvent]);
  const updateAllForms = forms => {
    const newFormsById = {};
    forms.forEach(form => {
      newFormsById[form._id] = form;
    });
    setAllForms(forms);
    setFormsById(newFormsById);
  };
  useEffect(() => {
    function fetchData() {
      return __awaiter(this, void 0, void 0, function* () {
        try {
          const response = yield api.org.forms.listType('user');
          updateAllForms(response);
        } catch (e) {
          Sentry.captureException(e);
          if (e instanceof Error) setError(e.message);
        }
      });
    }
    fetchData();
  }, [api, user, orgGroup]);
  useEffect(() => {
    function fetchData() {
      return __awaiter(this, void 0, void 0, function* () {
        setIsLoading(true);
        yield fetchSubmissions();
        setIsLoading(false);
      });
    }
    fetchData();
  }, [fetchSubmissions]);
  const changeUser = useCallback(newUser => {
    if (!newUser) throw new Error('No users provided');
    setUser(newUser);
    setPage(0);
  }, []);
  const changeSelectedForms = useCallback(newForms => {
    setSelectedForms(newForms);
    setPage(0);
  }, []);
  const changeRecordsPerPage = useCallback(newRecordsPerPage => {
    setRecordsPerPage(newRecordsPerPage);
    setPage(0);
  }, [setRecordsPerPage]);
  const uploadFile = useCallback(data => __awaiter(void 0, void 0, void 0, function* () {
    const file = data.data;
    const uploaded = yield api.manage.forms.submission.group.file(user, file);
    return {
      key: data.key,
      file: uploaded
    };
  }), [user, api]);
  const uploadFiles = useCallback((files, data) => __awaiter(void 0, void 0, void 0, function* () {
    if (!files.length) return data;
    const uploaded = yield Promise.all(files.map(uploadFile));
    uploaded.forEach(function (upload) {
      dotty.put(data, upload.key, formatFile(upload.file));
    });
    return data;
  }), [uploadFile]);
  const submitForm = useCallback(({
    formId,
    submissionId,
    data
  }) => __awaiter(void 0, void 0, void 0, function* () {
    let apiResponse;
    try {
      const form = formsById[formId];
      const files = findFiles(form.schema.properties, data);
      const newData = yield uploadFiles(files, data);
      if (submissionId) {
        yield api.manage.forms.submission.group.update(user, submissionId, undefined, newData);
      } else {
        yield api.manage.forms.submission.group.create(user, formId, undefined, newData);
      }
      apiResponse = {
        status: 'success'
      };
    } catch (e) {
      Sentry.captureException(e);
      const errorMessage = getApiErrorMsg(e);
      setError(errorMessage);
      apiResponse = {
        errorMessage,
        status: 'error'
      };
    }
    return apiResponse;
  }), [api, user, formsById, uploadFiles]);
  const deleteSubmission = useCallback(submissionId => __awaiter(void 0, void 0, void 0, function* () {
    let apiResponse;
    try {
      yield api.manage.forms.submission.group.remove(user, submissionId);
      apiResponse = {
        status: 'success'
      };
    } catch (e) {
      Sentry.captureException(e);
      const errorMessage = getApiErrorMsg(e);
      setError(errorMessage);
      apiResponse = {
        errorMessage,
        status: 'error'
      };
    }
    return apiResponse;
  }), [api, user]);
  const lockSubmission = useCallback(submissionId => __awaiter(void 0, void 0, void 0, function* () {
    let apiResponse;
    try {
      yield api.manage.forms.submission.group.lock(user, submissionId);
      apiResponse = {
        status: 'success'
      };
    } catch (e) {
      Sentry.captureException(e);
      const errorMessage = getApiErrorMsg(e);
      setError(errorMessage);
      apiResponse = {
        errorMessage,
        status: 'error'
      };
    }
    return apiResponse;
  }), [api, user]);
  const getFormPrepopulate = useCallback(formId => __awaiter(void 0, void 0, void 0, function* () {
    let apiResponse = {
      status: 'success',
      data: {}
    };
    try {
      const form = formsById[formId];
      if (!form) throw new Error('Form not found');
      if (!form.prepopulate || !form.prepopulate.length) return apiResponse;
      if (prepopulateData[formId]) {
        apiResponse.data = prepopulateData[formId];
        return apiResponse;
      }
      const result = yield api.manage.forms.submission.group.prepopulate(user, formId);
      setPrepopulateData(Object.assign(Object.assign({}, prepopulateData), {
        [formId]: result
      }));
      apiResponse = {
        status: 'success',
        data: result
      };
    } catch (e) {
      Sentry.captureException(e);
      const errorMessage = getApiErrorMsg(e);
      setError(errorMessage);
      apiResponse = {
        errorMessage,
        status: 'error'
      };
    }
    return apiResponse;
  }), [api, formsById, user, prepopulateData]);
  const retrieveSubmissions = useCallback(formId => __awaiter(void 0, void 0, void 0, function* () {
    let apiResponse;
    try {
      const result = yield api.manage.forms.submission.group.search(user, formId);
      apiResponse = {
        status: 'success',
        data: result
      };
    } catch (e) {
      Sentry.captureException(e);
      const errorMessage = getApiErrorMsg(e);
      setError(errorMessage);
      apiResponse = {
        errorMessage,
        status: 'error'
      };
    }
    return apiResponse;
  }), [api, user]);
  return {
    allForms,
    changeError: setError,
    changePage: setPage,
    changeRecordsPerPage,
    changeSelectedForms,
    changeUser,
    deleteSubmission,
    error,
    formsById,
    formSubmissions,
    getFormPrepopulate,
    isLoading,
    lockSubmission,
    page,
    recordsPerPage,
    retrieveSubmissions,
    selectedForms,
    submitForm,
    total
  };
};

const OrgFormsContext = /*#__PURE__*/createContext(null);
const OrgFormsProviders = ({
  children
}) => {
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.events || !resources.api || !resources.config) throw new Error('Missing required resources {api, events, config}');
  const manager = OrgFormsManager(resources);
  return jsx(OrgFormsContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const useOrgForms = () => {
  const context = useContext(OrgFormsContext);
  if (context === undefined || context === null) {
    throw new Error('useOrgForms used outside of its Provider');
  }
  return context;
};
const OrgFormsManager = ({
  api,
  events
}) => {
  const [rawOrgs, setRawOrgs] = useState([]);
  const [orgForms, setOrgForms] = useState({});
  useEffect(() => {
    const fetchForms = orgsToFetch => __awaiter(void 0, void 0, void 0, function* () {
      try {
        const newDataGroups = {};
        const promises = orgsToFetch.map(org => __awaiter(void 0, void 0, void 0, function* () {
          const response = yield api.admin.forms.list(org);
          newDataGroups[org] = response;
        }));
        yield Promise.all(promises);
        setOrgForms(prevOrgForms => Object.assign(Object.assign({}, prevOrgForms), newDataGroups));
      } catch (e) {
        Sentry.captureException(e);
      }
    });
    const toFetch = [];
    rawOrgs.forEach(groupId => {
      if (!orgForms[groupId]) toFetch.push(groupId);
    });
    if (toFetch.length > 0) {
      fetchForms(toFetch);
    }
  }, [api, orgForms, rawOrgs]);
  useEffect(() => {
    const tracker = events.createTracker();
    rawOrgs.forEach(orgId => {
      tracker.on(`mqtt:org/${orgId}/forms/definitions/created`, newForm => {
        setOrgForms(prevOrgForms => {
          const prevForms = prevOrgForms[orgId] || [];
          return Object.assign(Object.assign({}, prevOrgForms), {
            [orgId]: [...prevForms, newForm]
          });
        });
      });
      tracker.on(`mqtt:org/${orgId}/forms/definitions/removed`, deletedForm => {
        setOrgForms(prevOrgForms => {
          const prevForms = prevOrgForms[orgId] || [];
          const updatedOrgForms = prevForms.filter(form => form._id !== deletedForm._id);
          return Object.assign(Object.assign({}, prevOrgForms), {
            [orgId]: updatedOrgForms
          });
        });
      });
    });
    return () => {
      tracker.off();
    };
  }, [events, rawOrgs]);
  const trackOrgs = useCallback(orgIds => {
    const orgsArr = [orgIds].flat();
    const toTrack = orgsArr.filter(orgId => !rawOrgs.includes(orgId));
    if (toTrack.length > 0) {
      setRawOrgs(prevRawOrgs => [...prevRawOrgs, ...toTrack]);
    }
  }, [rawOrgs]);
  return {
    orgForms,
    trackOrgs
  };
};

const WorkflowContext = /*#__PURE__*/createContext(null);
const WorkflowProvider = ({
  children
}) => {
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.events || !resources.api || !resources.config) throw new Error('Missing required resources {api, events, config}');
  const manager = WorkflowManager(resources);
  return jsx(WorkflowContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const useWorkflow = () => {
  const context = useContext(WorkflowContext);
  if (context == null) {
    throw new Error('useRawReport used outside of its Provider');
  }
  return context;
};
const WorkflowManager = ({
  api,
  events,
  config
}) => {
  /**
   * Submits the given workflow data to the backend.
   *
   * @param data - The workflow data to submit.
   * @param workflow - The workflow object.
   */
  const submitWorkflow = (data, workflow) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e, _f;
    const action = workflow._id;
    const actionForm = ((_d = (_c = (_b = (_a = workflow === null || workflow === void 0 ? void 0 : workflow.ongoingWorkflowData) === null || _a === void 0 ? void 0 : _a.workflowData) === null || _b === void 0 ? void 0 : _b.schema) === null || _c === void 0 ? void 0 : _c.actions) === null || _d === void 0 ? void 0 : _d[data.action]) || {};
    const formProperties = actionForm.properties;
    const externals = ((_f = (_e = workflow === null || workflow === void 0 ? void 0 : workflow.ongoingWorkflowData) === null || _e === void 0 ? void 0 : _e.workflowData) === null || _f === void 0 ? void 0 : _f.externals) || {};
    const mergedFormProperties = shallowMergeExternalsWithSchema(formProperties, externals);
    const files = findFiles(mergedFormProperties, data);
    const uploadedFiles = yield uploadFiles(files, data);
    yield api.workflow.actions.submit(action, uploadedFiles);
  });
  /**
   * Merges the given schema with the external data, shallowly.
   * If the property in the schema has an inputType of 'externalform',
   * it retrieves the corresponding external schema from the externals object
   * and assigns it to the property in the return object.
   * Otherwise, it assigns the property as is.
   *
   * @param schema - The schema object to merge with externals.
   * @param externals - The external data object.
   * @returns The merged object.
   */
  function shallowMergeExternalsWithSchema(schema, externals) {
    if (!schema) return;
    const retObject = {};
    const keys = Object.keys(schema);
    keys.forEach(key => {
      const property = schema[key];
      if (property.inputType === 'externalform') {
        const externalKeyStr = property.external || '';
        const externalKey = externalKeyStr.split(':')[1];
        const externalSchema = externals[externalKey];
        retObject[key] = externalSchema;
      } else {
        retObject[key] = property;
      }
    });
    return retObject;
  }
  /**
   * Finds files in the given object and data.
   *
   * @param obj - The object to search for files.
   * @param data - The data object containing file information.
   * @param parent - The parent key, if any.
   * @returns An array of parsed files.
   */
  function findFiles(obj, data, parent) {
    if (!obj) return;
    return Object.keys(obj).reduce((acc, key) => {
      const currentKey = parent ? `${parent}.${key}` : key;
      const current = obj[key] || {};
      const currentData = data[key] || {};
      if (current.inputType === 'signature' && currentData && (Object.keys(currentData).length === 0 || currentData.constructor === File)) return parseFile(acc, currentKey, currentData);else if (current.inputType === 'file' && currentData && (Object.keys(currentData).length === 0 || currentData.constructor === File)) return parseFile(acc, currentKey, currentData);else if (current.type === 'array' && current.inputType === 'fileList') return parseFileList(acc, currentKey, currentData);else if (current.type === 'object') return parseObject(acc, currentKey, currentData, current);else if (current.type === 'array') return parseArray(acc, currentKey, currentData, current);else return acc;
    }, []);
  }
  /**
   * Creates a file key with the given current key and current data.
   * @param currentKey The current key.
   * @param currentData The current data.
   * @returns The updated file key object.
   */
  function createFileKey(currentKey, currentData) {
    const update = {
      key: '',
      data: {}
    };
    update.key = currentKey;
    update.data = currentData;
    return update;
  }
  /**
   * Parses a file and returns an updated array.
   * If the file is already uploaded, the array remains unchanged.
   * Otherwise, a new file key is created and added to the array.
   *
   * @param arr - The array to be updated.
   * @param currentKey - The current key.
   * @param currentData - The current data.
   * @param current - The current value.
   * @returns The updated array.
   */
  function parseFile(arr, currentKey, currentData, current) {
    if (currentData.id) return arr; // File is already uploaded
    return arr.concat(createFileKey(currentKey, currentData));
  }
  /**
   * Parses the file list and returns an updated array.
   *
   * @param arr - The original array to be updated.
   * @param currentKey - The current key.
   * @param currentData - The current data.
   * @param current - The current value.
   * @returns The updated array.
   */
  function parseFileList(arr, currentKey, currentData, current) {
    if (!currentData || !currentData.length) return arr;
    return arr.concat(currentData.reduce((acc, data, index) => {
      const key = `${currentKey}.${index}`;
      if (data.id) return acc; // File is already uploaded
      return acc.concat(createFileKey(key, data.file));
    }, []));
  }
  /**
   * Parses an object and returns an array of files found in its properties.
   *
   * @param arr - The array to concatenate the found files to.
   * @param currentKey - The current key being processed.
   * @param currentData - The current data being processed.
   * @param current - The current object being processed.
   * @returns An array of files found in the properties of the object.
   */
  function parseObject(arr, currentKey, currentData, current) {
    const properties = current.properties || {};
    return arr.concat(findFiles(properties, currentData, currentKey));
  }
  /**
   * Parses an array based on the input type of the items.
   * If the input type is 'file', it calls the parseFile function.
   * Otherwise, it concatenates the result of findFiles function.
   *
   * @param arr - The array to be parsed.
   * @param currentKey - The current key.
   * @param currentData - The current data.
   * @param current - The current item.
   * @returns The parsed array.
   */
  function parseArray(arr, currentKey, currentData, current) {
    const items = current.items || {};
    if (items.inputType === 'file') return parseFile(arr, currentKey, currentData);else return arr.concat(findFiles(items, currentData, currentKey));
  }
  /**
   * Uploads a file using the provided data.
   * @param data - The data containing the file to be uploaded.
   * @returns An object with the key and the uploaded file.
   */
  function uploadFile(data) {
    return __awaiter(this, void 0, void 0, function* () {
      const file = data.data;
      const uploaded = yield api.workflow.actions.upload(file);
      return {
        key: data.key,
        file: uploaded
      };
    });
  }
  /**
   * Uploads files and updates the data object with the uploaded file information.
   * @param files - The files to be uploaded.
   * @param data - The data object to be updated.
   * @returns The updated data object.
   */
  function uploadFiles(files, data) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!files || !(files === null || files === void 0 ? void 0 : files.length)) return data;
      const uploadedFiles = yield Promise.all(files.map(uploadFile));
      uploadedFiles.forEach(upload => {
        dotty.put(data, upload.key, formatFile(upload.file));
      });
      return data;
    });
  }
  /**
   * Formats a file object into a specific format.
   * @param file - The file object to be formatted.
   * @returns The formatted file object.
   */
  function formatFile(file) {
    return {
      url: file.url,
      id: file._id,
      format: file.format,
      name: file.name
    };
  }
  return {
    submitWorkflow
  };
};

/**
 * Custom hook for managing subscriptions to topics with event trackers. Automatically handles MQTT topic prefixing if required.
 *
 * @param topic - The topic to subscribe to.
 * @param callback - The callback function to execute when an event is received.
 * @param isMqtt - Optional flag indicating if the topic is an MQTT topic. Defaults to true.
 * Example usage:
 * useSubscription("assistant/messages/retrieve", handleMessage, true);
 */
const useSubscription = (topic, callback, isMqtt = true) => {
  const {
    resources
  } = useResourceStore();
  useEffect(() => {
    var _a, _b;
    if (!topic || typeof callback !== "function") {
      console.error("Invalid topic or callback.");
      return;
    }
    const tracker = (_b = (_a = resources === null || resources === void 0 ? void 0 : resources.events) === null || _a === void 0 ? void 0 : _a.createTracker) === null || _b === void 0 ? void 0 : _b.call(_a);
    if (!tracker) {
      console.warn("Event tracker not initialized.");
      return;
    }
    const mqttPrefixRegex = /^mqtt:\$\/.*/;
    const fullTopic = isMqtt && !mqttPrefixRegex.test(topic) ? `mqtt:$/${topic}` : topic;
    tracker.on(fullTopic, callback);
    return () => {
      tracker.off(fullTopic, callback);
    };
  }, [topic, callback, isMqtt, resources === null || resources === void 0 ? void 0 : resources.events]);
};

/**
 * Provides a dispatch function that can optionally use a default event name while automatically
 * handling MQTT topic prefixing if required. This enhances usability by avoiding the need to
 * manually prepend "mqtt:/$/" to every topic that is intended for MQTT communication.
 *
 * @param defaultEvent - The default event name to use if not provided during dispatch.
 * @param isMqttDefault - Default value indicating if the events are MQTT events. Defaults to true.
 *
 * @returns A function to emit and track events. This function handles MQTT prefixing automatically
 * to ensure the topics are correctly formatted according to MQTT standards.
 *
 * Example Usage:
 * // Without specifying event name in the hook:
 * const dispatchEvent = useDispatchEvent();
 * dispatchEvent({ event: "assistant/messages/send", data: { message: "Hello" }, isMqtt: true });
 *
 * // With a default event name and automatically assuming MQTT:
 * const dispatchEvent = useDispatchEvent("assistant/messages/send");
 * dispatchEvent({ data: { message: "Hello" } }); // Uses default event and assumes MQTT
 *
 * This hook simplifies event dispatching especially in scenarios involving MQTT where
 * topics need specific formatting.
 */
const useDispatchEvent = (defaultEvent, isMqttDefault = true) => {
  const {
    resources: {
      dispatcher
    }
  } = useResourceStore();
  return useCallback(({
    event,
    data,
    isMqtt: _isMqtt = isMqttDefault
  }) => {
    if (!dispatcher) {
      console.warn("Dispatcher not initialized.");
      return;
    }
    const eventName = event !== null && event !== void 0 ? event : defaultEvent;
    if (!eventName) {
      console.error("No event name provided for dispatch.");
      return;
    }
    // Check for MQTT prefix and append if necessary. This regex checks if the event name
    // starts with optional '$' followed by 'mqtt:/$/'.
    const mqttPrefixRegex = /^\$?mqtt:\$\/.*/;
    const prefixedEventName = _isMqtt && !mqttPrefixRegex.test(eventName) ? `$mqtt:$/${eventName}` : eventName;
    dispatcher.emit(prefixedEventName, data);
    // Emit an additional event for user metrics tracking.
    dispatcher.emit("usermetrics:trigger:track", prefixedEventName);
  }, [dispatcher, defaultEvent, isMqttDefault]);
};

/**
 * The `useSliceData` hook is designed to manage slices of state within the application using global state store.
 *
 * This hook simplifies reading and updating user preferences and other settings directly from localStorage, sessionStorage
 * , or even AsyncStorage (for react-hook), and so on.
 *
 * Example usage:
 * ```
 * // Define the storage handling logic specific to user preferences and numeric counters.
 * const storageDescriptor = {
 *   sliceMethods: {
 *     getItems: async (keys) => {
 *       return keys.reduce((acc, key) => {
 *         const value = localStorage.getItem(key);
 *         acc[key] = value ? JSON.parse(value) : null; // Assuming values are stored as JSON strings
 *         return acc;
 *       }, {});
 *     },
 *     setItems: async (updates) => {
 *       Object.entries(updates).forEach(([key, value]) => {
 *         localStorage.setItem(key, JSON.stringify(value)); // Serialize and save the data
 *       });
 *     }
 *   },
 *   fields: {
 *     userPreferences: { type: 'json', defaultValue: {} },
 *     counter: { type: 'number', defaultValue: 2 }
 *   }
 * };
 *
 * // Use the hook with the defined descriptor to manage and update local storage data.
 * const { data, setData } = useSliceData(storageDescriptor);
 * ```
 *
 * This allows components to fetch and update settings like user preferences and counters in a clean and optimized manner.
 */
const useSliceData = descriptor => {
  var _a;
  const {
    data,
    load,
    descriptorMap,
    statuses
  } = useSliceStore();
  const namespace = (_a = descriptorMap.get(descriptor)) !== null && _a !== void 0 ? _a : "default";
  useEffect(() => {
    if (!statuses[namespace] || statuses[namespace] === 'unset') {
      load([descriptor]).catch(console.error);
    }
  }, [descriptor, load, statuses, namespace]);
  const setData = useCallback(updates => __awaiter(void 0, void 0, void 0, function* () {
    const parsedUpdates = Object.keys(updates).reduce((acc, key) => {
      const detail = descriptor.fields[key];
      if (detail) {
        // Ensure the type is a key of DefaultValuesMap before using it
        const defaultValue = DefaultValues[detail.type];
        acc[key] = parseValue(updates[key], detail.type, defaultValue);
      }
      return acc;
    }, {});
    const {
      setItems
    } = descriptor.sliceMethods;
    try {
      yield setItems(parsedUpdates);
      useSliceStore.setState(state => ({
        data: Object.assign(Object.assign({}, state.data), {
          [namespace]: Object.assign(Object.assign({}, state.data[namespace]), parsedUpdates)
        })
      }));
    } catch (error) {
      console.error(`Error setting the values for namespace ${namespace}:`, error);
    }
  }), [namespace, descriptor.sliceMethods, descriptor.fields]);
  const getData = useCallback(key => {
    var _a;
    return (_a = data[namespace]) === null || _a === void 0 ? void 0 : _a[key];
  }, [data, namespace]);
  return {
    data: data[namespace] || {},
    setData,
    getData
  };
};

const DesktopNotificationsContext = /*#__PURE__*/createContext(null);
const DesktopNotificationsProvider = ({
  children,
  redirectLink
}) => {
  const resources = useContext(ResourcesContext);
  if (!resources || !resources.events || !resources.api || !resources.config) throw new Error('Missing required resources {api, events, config}');
  const manager = desktopNotificationsManager({
    api: resources.api,
    events: resources.events,
    redirectLink
  });
  return jsx(DesktopNotificationsContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }));
};
const useDesktopNotifications = () => {
  const context = useContext(DesktopNotificationsContext);
  if (context === undefined || context === null) {
    throw new Error('useDesktopNotifications used outside of its Provider');
  }
  return context;
};
const desktopNotificationsManager = ({
  api,
  events,
  redirectLink
}) => {
  const {
    personal
  } = useCurrentPerson();
  const {
    localize
  } = useLocalize();
  useEffect(() => {
    const tracker = events.createTracker();
    tracker.on(`mqtt:u/${personal._id}/notifications/new`, notification => {
      if (notification.banner_type === 'urgency:call') {
        const message = localize('user_bracelets_urgencycall');
        createNotification({
          title: message
        });
      } else if (notification.banner_type === 'urgency:accepted') {
        const message = localize('user_bracelets_urgencycall');
        createNotification({
          title: message
        });
      } else if (notification.banner_type === 'urgency:cancelled') {
        const message = localize('user_bracelets_urgencycall');
        createNotification({
          title: message
        });
      } else if (notification.banner_type === 'warning:device:disconnected') {
        const message = localize('notification.deviceConnectivityStatus');
        createNotification({
          title: message
        });
      } else if (notification.banner_type === 'warning:device:connected') {
        const message = localize('notification.deviceConnectivityStatus');
        createNotification({
          title: message
        });
      } else if (notification.banner_type === 'warning:device:wandering') {
        const content = notification.content;
        const wandering = content === null || content === void 0 ? void 0 : content.wandering;
        const invalid = content === null || content === void 0 ? void 0 : content.invalid;
        let message = localize('banner.unknown');
        if (wandering && wandering !== 2) {
          message = localize('notification.deviceConnectivityStatus');
        } else if (!wandering && !invalid) {
          message = localize('notification.deviceConnectivityStatus');
        }
        createNotification({
          title: message
        });
      } else if (notification.banner_type === 'warning:device:battery') {
        const message = localize('notification.deviceBatteryLifeStatus');
        createNotification({
          title: message
        });
      } else if (notification.banner_type === 'warning:device:batterychanged') {
        const message = localize('notification.deviceBatteryLifeStatus');
        createNotification({
          title: message
        });
      } else if (notification.banner_type === 'info:manageduser:new') {
        const message = localize('notification.managedUserNew');
        createNotification({
          title: message
        });
      } else if (notification.banner_type === 'message:logistics:note') {
        const message = localize('notification.logistics');
        createNotification({
          title: message,
          link: '/logisticNotifications'
        });
      } else if (notification.banner_type === 'info:meeting:new') {
        const message = localize('banner.meeting_new');
        createNotification({
          title: message
        });
      } else if (notification.banner_type === 'info:indicator:bpPulserate') {
        const message = localize(`notification.NewIndicator`);
        createNotification({
          title: message
        });
      }
      if (notification.banner_type === 'info:indicator:heartrate') {
        const message = localize(`notification.NewIndicator`);
        createNotification({
          title: message
        });
      }
      if (notification.banner_type === 'info:indicator:oxygensaturation') {
        const message = localize(`notification.NewIndicator`);
        createNotification({
          title: message
        });
      }
      if (notification.banner_type === 'info:indicator:bloodpressure') {
        const message = localize(`notification.NewIndicator`);
        createNotification({
          title: message
        });
      }
      if (notification.banner_type === 'info:indicator:bloodsugar') {
        const message = localize(`notification.NewIndicator`);
        createNotification({
          title: message
        });
      }
      if (notification.banner_type === 'info:indicator:bodytemperature') {
        const message = localize(`notification.NewIndicator`);
        createNotification({
          title: message
        });
      }
      if (notification.banner_type === 'info:indicator:steps') {
        const message = localize(`notification.NewIndicator`);
        createNotification({
          title: message
        });
      }
      if (notification.banner_type === 'info:indicator:weight') {
        const message = localize(`notification.NewIndicator`);
        createNotification({
          title: message
        });
      }
    });
    tracker.on(`mqtt:u/${personal._id}/workflow/actions/added`, () => {
      createNotification({
        title: localize('notification.pathwayNotifications')
      });
    });
    return () => {
      tracker.off();
    };
  }, [events, localize, personal._id]);
  const createNotification = ({
    title,
    options,
    link
  }) => {
    // Check if the browser supports notifications
    if (!('Notification' in window)) {
      console.log('This browser does not support desktop notifications');
      return;
    }
    const defaultOptions = Object.assign(Object.assign({}, options), {
      icon: Images.IconBlue,
      body: 'Aetonix Notification'
    });
    // Request permission for notifications
    Notification.requestPermission().then(permission => {
      if (permission === 'granted') {
        const notification = new Notification(title, defaultOptions);
        const hrefLink = link ? link : redirectLink || '/';
        notification.onclick = e => {
          window.focus();
          notification.close();
          window.location.href = hrefLink;
        };
      }
    });
  };
  return {
    createNotification
  };
};

const IdPrefixContext = /*#__PURE__*/createContext("");
const IdPrefixProvider = ({
  children,
  prefix
}) => {
  const currentPrefix = useContext(IdPrefixContext) || '';
  const fullPrefix = currentPrefix ? `${currentPrefix}-${prefix}` : prefix;
  return jsx(IdPrefixContext.Provider, Object.assign({
    value: fullPrefix
  }, {
    children: children
  }));
};
const useIdPrefix = () => {
  const context = useContext(IdPrefixContext);
  return context;
};

const AtaTextSizeContext = /*#__PURE__*/createContext(undefined);
const useAtaTextSize = () => {
  return React__default.useContext(AtaTextSizeContext);
};

export { AdminOrganizationProvider, AllPatientsProvider, AtaTextSizeContext, BannersProvider, ConfigContext, ConnectionProvider, CurrentPersonProvider, CustomIndicatorsProvider, CustomReportsListProvider, DesktopNotificationsProvider, FormSubmissionsManager, FormSubmissionsProvider, IdPrefixContext, IdPrefixProvider, ItemManager, ItemModelsProvider, ItemProvider, KitAssignmentManager, KitAssignmentProvider, KitManager, KitModelsManager, KitModelsProvider, KitProvider, KitStates, LocalizeProvider, LogisticBannersProvider, LogisticsNotesManager, LogisticsNotesProvider, MeasureUnitsProvider, OngoingWorkflowActionsManager, OngoingWorkflowActionsProvider, OngoingWorkflowTrackerProvider, OrgFormsManager, OrgFormsProviders, OrgGroupsProvider, OrgSchemasProvider, OrganizationNamesManager, OrganizationNamesProvider, OwnContactsManager, OwnContactsProvider, OwnerOngoingWorkflowsProvider, PatientAllContactsManager, PatientAllContactsProvider, PatientAllManagersManager, PatientAllManagersProvider, PatientGroupManager, PatientGroupManagersManager, PatientGroupManagersProvider, PatientGroupProvider, PatientStates, PatientsPatientGroupProvider, PatientsProvider, PeopleProvider, RawReportProvider, ReportSchemaProvider, ResourcesContext, RoutesContext, UserDataProvider, UserPublicDataProvider, WorkflowDefinitionTrackerProvider, WorkflowDefinitionsProvider, WorkflowManager, WorkflowProvider, adminOrganizationManager, allPatientsManager, bannersManager, connectionManager, currentPersonManager, customIndicatorsManager, customReportsListManager, desktopNotificationsManager, itemModelsManager, localizeManager, logisticBannersManager, ongoingWorkflowTrackerManager, orgGroupsManager, orgSchemasManager, ownerOngoingWorkflowsManager, patientsManager, patientsPatientGroupManager, peopleManager, rawReportManager, reportSchemaManager, useAdminOrganization, useAllPatientContacts, useAllPatientManagers, useAllPatients, useAtaTextSize, useBanners, useConfig, useConnection, useCurrentPerson, useCustomIndicators, useCustomReportsList, useDesktopNotifications, useDispatchEvent, useFormSubmissions, useIdPrefix, useIntersectObserver, useItem, useItemModels, useKit, useKitAssignment, useKitModels, useLocalStorageValue, useLocalize, useLogisticBanners, useLogisticsNotes, useMeasureUnits, useOngoingWorkflowActions, useOngoingWorkflowTracker, useOrgForms, useOrgGroups, useOrgSchemas, useOrganizationNames, useOwnContacts, useOwnerOngoingWorkflows, usePatientGroup, usePatientGroupManagers, usePatients, usePatientsPatientGroup, usePeople, useRawReport, useReportSchema, useResources, useRoutes, useSliceData, useSubscription, useUserData, useUserPublicData, useWorkflow, useWorkflowDefinitionTracker, useWorkflowDefinitions, userDataManager, userPublicDataManager, workflowDefinitionTrackerManager, workflowDefinitionsManager };
